
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1BiXn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $9s7Po = parcelRequire("9s7Po");


var $hnvzE = parcelRequire("hnvzE");

const $2f66d7816a46cebf$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
const $2f66d7816a46cebf$var$CardLoadingWithContext = ()=>{
    const props = (0, $42omo.useContext)($2f66d7816a46cebf$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9s7Po.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

const $2f66d7816a46cebf$var$MediaCardWithMediaClientProvider = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "jrCIr",
    name: "MediaCardWithMediaClientProvider",
    loader: ()=>(parcelRequire("gY3e1")).then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$CardLoadingWithContext, null)
});
const $2f66d7816a46cebf$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "media-card",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$MediaCardContext.Provider, {
        value: props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$MediaCardWithMediaClientProvider, props)));
};
$2f66d7816a46cebf$var$CardLoader.preload = ()=>$2f66d7816a46cebf$var$MediaCardWithMediaClientProvider.preload();
var $2f66d7816a46cebf$export$2e2bcd8739ae039 = $2f66d7816a46cebf$var$CardLoader;
module.exports["default"] = $2f66d7816a46cebf$export$2e2bcd8739ae039;

});

parcelRegister("9s7Po", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fDGbV = parcelRequire("fDGbV");


var $64ehG = parcelRequire("64ehG");


var $9hlns = parcelRequire("9hlns");

class $bf3fa0f5391f39b8$export$5d25853fd6bdf402 extends (0, $42omo.Component) {
    render() {
        const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = this.props;
        const dimensions = (0, $fDGbV.getDimensionsWithDefault)(dimensionsProp);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $64ehG.Wrapper), {
            "data-testid": testId || 'media-card-loading',
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            interactionName: interactionName || 'media-card-loading'
        }));
    }
}
module.exports["CardLoading"] = $bf3fa0f5391f39b8$export$5d25853fd6bdf402;

});

parcelRegister("64ehG", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $fN2NR = parcelRequire("fN2NR");


var $6fnsQ = parcelRequire("6fnsQ");

const $aedc46c8c12477c6$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fN2NR.center), {
        background: `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`,
        color: `var(--ds-icon, ${(0, $6fnsQ.N50)})`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fN2NR.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });


const $fd9c20c94dd40490$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $aedc46c8c12477c6$export$491e6397d7c1480b)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};
module.exports["Wrapper"] = $fd9c20c94dd40490$export$e6dfd72ab29f8598;

});

parcelRegister("fN2NR", function(module, exports) {
const $adbace133e9e6202$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $adbace133e9e6202$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $adbace133e9e6202$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $adbace133e9e6202$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $adbace133e9e6202$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $adbace133e9e6202$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${"var(--ds-radius-small, 3px)"};
  border-bottom-right-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $adbace133e9e6202$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
module.exports["size"] = $adbace133e9e6202$export$346677f925de839c;
module.exports["center"] = $adbace133e9e6202$export$3481c78889e8fbe8;
module.exports["borderRadius"] = $adbace133e9e6202$export$7a57f79000377ca2;

});

parcelRegister("gY3e1", function(module, exports) {

let $c5a4c063ea98b365$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c5a4c063ea98b365$var$load("8JZKd"),
    $c5a4c063ea98b365$var$load("7EorR"),
    $c5a4c063ea98b365$var$load("fisfU"),
    $c5a4c063ea98b365$var$load("2fk6g"),
    $c5a4c063ea98b365$var$load("6wr18"),
    $c5a4c063ea98b365$var$load("ffEVr"),
    $c5a4c063ea98b365$var$load("8LPnw"),
    $c5a4c063ea98b365$var$load("4jPsO"),
    $c5a4c063ea98b365$var$load("hPalR"),
    $c5a4c063ea98b365$var$load("hszIA"),
    $c5a4c063ea98b365$var$load("8059b"),
    $c5a4c063ea98b365$var$load("72780"),
    $c5a4c063ea98b365$var$load("jDjSj"),
    $c5a4c063ea98b365$var$load("fwuXj")
]).then(()=>parcelRequire('r0CCR'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("3BZZG", function(module, exports) {
const $b77837f445efd10f$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $b77837f445efd10f$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $b77837f445efd10f$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $b77837f445efd10f$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $b77837f445efd10f$export$d87a47989c00f322;
    if (appearance === 'square') return $b77837f445efd10f$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $b77837f445efd10f$export$aeb48196afcd236a;
    return $b77837f445efd10f$export$d87a47989c00f322;
};
module.exports["defaultImageCardDimensions"] = $b77837f445efd10f$export$d87a47989c00f322;
module.exports["getDefaultCardDimensions"] = $b77837f445efd10f$export$ed7b8a4728e9c63;

});

parcelRegister("bhuzI", function(module, exports) {

var $dIgeg = parcelRequire("dIgeg");


var $7bPHJ = parcelRequire("7bPHJ");

var $wA8SJ = parcelRequire("wA8SJ");


var $eWRwJ = parcelRequire("eWRwJ");

const $4e9e5bfba2b350c8$export$31786e85bf49987b = (metadata, fileStatus)=>({
        fileMediatype: metadata.mediaType,
        fileMimetype: metadata.mimeType,
        fileId: metadata.id,
        fileSize: metadata.size,
        fileStatus: fileStatus
    });
const $4e9e5bfba2b350c8$export$4006df18b24ad838 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'success',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $4e9e5bfba2b350c8$export$30f484b360b0efe8 = (fileAttributes, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'success',
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $4e9e5bfba2b350c8$export$81661af638dd90bc = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'cache-hit',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $4e9e5bfba2b350c8$export$62c7b749808f1b8f = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'Remote-success',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $4e9e5bfba2b350c8$export$c9d988402f74bba = (fileAttributes, performanceAttributes)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'external-uri'
        }
    });
const $4e9e5bfba2b350c8$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $4e9e5bfba2b350c8$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $4e9e5bfba2b350c8$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError) && secondaryError.innerError?.message) return secondaryError.innerError?.message;
    if (secondaryError instanceof Error) return secondaryError.message;
    return error.message;
};
const $4e9e5bfba2b350c8$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata;
};
const $4e9e5bfba2b350c8$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $4e9e5bfba2b350c8$export$4af9d71992e89714(error),
        error: $4e9e5bfba2b350c8$export$88c61dcad53762da(error),
        errorDetail: $4e9e5bfba2b350c8$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $4e9e5bfba2b350c8$export$29aa614726672b2e(error)
    };
};
const $4e9e5bfba2b350c8$export$ea8620de23983ca1 = (fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            ...$4e9e5bfba2b350c8$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext
        }
    });
const $4e9e5bfba2b350c8$export$bd721ce2bd18db4c = (fileAttributes, error, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$4e9e5bfba2b350c8$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e(error),
            traceContext: traceContext
        }
    });
const $4e9e5bfba2b350c8$export$d3944464e6ecd3d4 = (cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'nonCriticalFail',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$4e9e5bfba2b350c8$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            cardStatus: cardStatus
        }
    });
const $4e9e5bfba2b350c8$export$116834b91a04bd49 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'failed-processing',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
function $4e9e5bfba2b350c8$export$60729f3fb03dcecc(payload, createAnalyticsEvent) {
    if (createAnalyticsEvent) {
        const event = createAnalyticsEvent((0, $wA8SJ.sanitiseAnalyticsPayload)(payload));
        event.fire((0, $7bPHJ.ANALYTICS_MEDIA_CHANNEL));
    }
}
const $4e9e5bfba2b350c8$export$4d33ada3618f7626 = (payload)=>{
    return (0, $eWRwJ.default)((0, $7bPHJ.ANALYTICS_MEDIA_CHANNEL))((0, $wA8SJ.sanitiseAnalyticsPayload)(payload));
};
module.exports["getRenderSucceededEventPayload"] = $4e9e5bfba2b350c8$export$4006df18b24ad838;
module.exports["getDownloadSucceededEventPayload"] = $4e9e5bfba2b350c8$export$30f484b360b0efe8;
module.exports["getRenderErrorRequestMetadata"] = $4e9e5bfba2b350c8$export$1a2ec9b4a3a99d5e;
module.exports["extractErrorInfo"] = $4e9e5bfba2b350c8$export$74aaf4784c2edb2c;
module.exports["getRenderErrorEventPayload"] = $4e9e5bfba2b350c8$export$ea8620de23983ca1;
module.exports["getDownloadFailedEventPayload"] = $4e9e5bfba2b350c8$export$bd721ce2bd18db4c;
module.exports["getErrorEventPayload"] = $4e9e5bfba2b350c8$export$d3944464e6ecd3d4;
module.exports["getRenderFailedFileStatusPayload"] = $4e9e5bfba2b350c8$export$116834b91a04bd49;
module.exports["fireMediaCardEvent"] = $4e9e5bfba2b350c8$export$60729f3fb03dcecc;
module.exports["createAndFireMediaCardEvent"] = $4e9e5bfba2b350c8$export$4d33ada3618f7626;

});

parcelRegister("7bPHJ", function(module, exports) {
const $f5d20cba8da3e43a$export$ec1779cb96554e1 = 'media';
module.exports["ANALYTICS_MEDIA_CHANNEL"] = $f5d20cba8da3e43a$export$ec1779cb96554e1;

});

parcelRegister("wA8SJ", function(module, exports) {

var $chIYi = parcelRequire("chIYi");


var $fl9IL = parcelRequire("fl9IL");

const $19999d8625134b0f$var$sanitiseFileId = (draft)=>{
    const { fileId: fileId } = draft.attributes.fileAttributes;
    draft.attributes.fileAttributes.fileId = fileId === 'external-image' || (0, (/*@__PURE__*/$parcel$interopDefault($chIYi)))(fileId) ? fileId : 'INVALID_FILE_ID';
};
const $19999d8625134b0f$var$hasFileAttributesWithFileId = (payload)=>'attributes' in payload && !!payload.attributes && typeof payload.attributes === 'object' && 'fileAttributes' in payload.attributes && !!payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes === 'object' && 'fileId' in payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes.fileId === 'string';
const $19999d8625134b0f$export$e24d38cbdf73bc1a = (payload)=>$19999d8625134b0f$var$hasFileAttributesWithFileId(payload) ? (0, $fl9IL.produce)(payload, $19999d8625134b0f$var$sanitiseFileId) : payload;
module.exports["sanitiseAnalyticsPayload"] = $19999d8625134b0f$export$e24d38cbdf73bc1a;

});

parcelRegister("e63NX", function(module, exports) {

var $hL7bb = parcelRequire("hL7bb");

const $aeded572d33c89ca$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};
const $aeded572d33c89ca$export$2782f2fbff82f0c9 = (identifier)=>{
    return identifier.mediaItemType === 'external-image';
};
const $aeded572d33c89ca$export$5883721593c4e4b1 = (a, b)=>{
    if ($aeded572d33c89ca$export$7695387cd66cf5b5(a) && $aeded572d33c89ca$export$7695387cd66cf5b5(b)) return a.id !== b.id || a.collectionName !== b.collectionName || a.occurrenceKey !== b.occurrenceKey;
    else return !(0, (/*@__PURE__*/$parcel$interopDefault($hL7bb)))(a, b);
};
module.exports["isFileIdentifier"] = $aeded572d33c89ca$export$7695387cd66cf5b5;
module.exports["isExternalImageIdentifier"] = $aeded572d33c89ca$export$2782f2fbff82f0c9;

});

parcelRegister("hL7bb", function(module, exports) {
var $cedc651d64f014e0$var$pSlice = Array.prototype.slice;

var $gFqzn = parcelRequire("gFqzn");


var $2EuUq = parcelRequire("2EuUq");

var $cedc651d64f014e0$var$deepEqual = module.exports = function(actual, expected, opts) {
    if (!opts) opts = {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
    else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') return opts.strict ? actual === expected : actual == expected;
    else return $cedc651d64f014e0$var$objEquiv(actual, expected, opts);
};
function $cedc651d64f014e0$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $cedc651d64f014e0$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $cedc651d64f014e0$var$objEquiv(a, b, opts) {
    var i, key;
    if ($cedc651d64f014e0$var$isUndefinedOrNull(a) || $cedc651d64f014e0$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    //~~~I've managed to break Object.keys through screwy arguments passing.
    //   Converting to array solves the problem.
    if ($2EuUq(a)) {
        if (!$2EuUq(b)) return false;
        a = $cedc651d64f014e0$var$pSlice.call(a);
        b = $cedc651d64f014e0$var$pSlice.call(b);
        return $cedc651d64f014e0$var$deepEqual(a, b, opts);
    }
    if ($cedc651d64f014e0$var$isBuffer(a)) {
        if (!$cedc651d64f014e0$var$isBuffer(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    try {
        var ka = $gFqzn(a), kb = $gFqzn(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length != kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$cedc651d64f014e0$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return typeof a === typeof b;
}

});

parcelRegister("gFqzn", function(module, exports) {
exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
exports.shim = shim;
function shim(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
}

});

parcelRegister("2EuUq", function(module, exports) {
var supportsArgumentsClass = function() {
    return Object.prototype.toString.call(arguments);
}() == '[object Arguments]';
exports = module.exports = supportsArgumentsClass ? supported : unsupported;
exports.supported = supported;
function supported(object) {
    return Object.prototype.toString.call(object) == '[object Arguments]';
}
exports.unsupported = unsupported;
function unsupported(object) {
    return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
}

});

parcelRegister("7NoXb", function(module, exports) {
$parcel$export(module.exports, "default", () => $a320422a745418e6$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fs5Wi = parcelRequire("fs5Wi");




parcelRequire("42omo");


var $caX7N = parcelRequire("caX7N");

const $86b842c4b2e17806$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
        zIndex: 510,
        children: children
    });



const $a320422a745418e6$var$MediaViewer = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hpQsF")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $a320422a745418e6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $fs5Wi.default), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $86b842c4b2e17806$export$51aee4c01b17acde), {
            children: /*#__PURE__*/ (0, $l998X.jsx)($a320422a745418e6$var$MediaViewer, {
                ...props
            })
        })
    });
}

});

parcelRegister("fs5Wi", function(module, exports) {
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $70BxX = parcelRequire("70BxX");


var $cOrQJ = parcelRequire("cOrQJ");

const $379228055afe24f5$export$442b7be89436c101 = '#101214';
const $379228055afe24f5$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $70BxX.default), {
        blankedColor: $379228055afe24f5$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $379228055afe24f5$export$2e2bcd8739ae039 = $379228055afe24f5$var$ModalSpinner;
module.exports["default"] = $379228055afe24f5$export$2e2bcd8739ae039;

});

parcelRegister("70BxX", function(module, exports) {

var $42omo = parcelRequire("42omo");

/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");

const $ed42ad447c5e042f$var$blanketStyles = null;
const $ed42ad447c5e042f$var$spinnerStyles = null;
const $ed42ad447c5e042f$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $ed42ad447c5e042f$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ $42omo.createElement("div", {
        style: {
            backgroundColor: blankedColor || $ed42ad447c5e042f$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $gMc0m.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        size: "large",
        appearance: invertSpinnerColor || $ed42ad447c5e042f$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
        testId: 'media-modal-spinner'
    })));


const $9f2ec0906c10b2d9$var$ModalSpinner = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ed42ad447c5e042f$export$2e2bcd8739ae039), props);
var $9f2ec0906c10b2d9$export$2e2bcd8739ae039 = $9f2ec0906c10b2d9$var$ModalSpinner;
module.exports["default"] = $9f2ec0906c10b2d9$export$2e2bcd8739ae039;

});

parcelRegister("hpQsF", function(module, exports) {

let $cadd77347ca0cc50$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cadd77347ca0cc50$var$load("3t6fF"),
    $cadd77347ca0cc50$var$load("6wr18"),
    $cadd77347ca0cc50$var$load("3wVig"),
    $cadd77347ca0cc50$var$load("llcfA"),
    $cadd77347ca0cc50$var$load("bA4nr"),
    $cadd77347ca0cc50$var$load("8JZKd"),
    $cadd77347ca0cc50$var$load("azCDs"),
    $cadd77347ca0cc50$var$load("kJZ90"),
    $cadd77347ca0cc50$var$load("4lnLb"),
    $cadd77347ca0cc50$var$load("2fk6g"),
    $cadd77347ca0cc50$var$load("4jPsO"),
    $cadd77347ca0cc50$var$load("hPalR"),
    $cadd77347ca0cc50$var$load("hszIA"),
    $cadd77347ca0cc50$var$load("8059b"),
    $cadd77347ca0cc50$var$load("72780"),
    $cadd77347ca0cc50$var$load("jDjSj"),
    $cadd77347ca0cc50$var$load("hhss7"),
    $cadd77347ca0cc50$var$load("ffEVr"),
    $cadd77347ca0cc50$var$load("cKkZK")
]).then(()=>parcelRequire('gamJO'));

});

parcelRegister("31QJ7", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $51c490bf07ac8c08$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    click_to_join: {
        id: "fabric.media.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.media.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    request_access: {
        id: "fabric.media.request_access",
        defaultMessage: "Request access"
    },
    request_access_description: {
        id: "fabric.media.request_access_description",
        defaultMessage: "Request access to {context} view this preview."
    },
    request_access_pending: {
        id: "fabric.media.request_access_pending",
        defaultMessage: "Access pending"
    },
    request_access_pending_description: {
        id: "fabric.media.request_access_pending_description",
        defaultMessage: "Your access request is pending."
    },
    forbidden_description: {
        id: "fabric.media.forbidden_description",
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access."
    },
    request_denied_description: {
        id: "fabric.media.request_denied_description",
        defaultMessage: "Your access request was denied. Contact the site admin if you still need access."
    },
    retry: {
        id: "fabric.media.retry",
        defaultMessage: "Retry"
    },
    failed_to_load: {
        id: "fabric.media.failed_to_load",
        defaultMessage: "Failed to load"
    },
    failed_to_upload: {
        id: "fabric.media.failed_to_upload",
        defaultMessage: "Failed to upload"
    },
    recent_uploads: {
        id: "fabric.media.recent_uploads",
        defaultMessage: "Recent uploads"
    },
    upload_file: {
        id: "fabric.media.upload_file",
        defaultMessage: "Upload a file"
    },
    drag_and_drop_your_files: {
        id: "fabric.media.drag_and_drop_your_files",
        defaultMessage: "Drag and drop your files anywhere or"
    },
    drag_and_drop_your_files_and_folders: {
        id: "fabric.media.drag_and_drop_your_files_and_folders",
        defaultMessage: "Drag and drop your files and folders anywhere or"
    },
    drop_your_files: {
        id: "fabric.media.drop_your_files",
        defaultMessage: "Drop your files to upload"
    },
    upload: {
        id: "fabric.media.upload",
        defaultMessage: "Upload"
    },
    cancel: {
        id: "fabric.media.cancel",
        defaultMessage: "Cancel"
    },
    delete: {
        id: "fabric.media.delete",
        defaultMessage: "Delete"
    },
    success: {
        id: "fabric.media.success",
        defaultMessage: "Success"
    },
    error: {
        id: "fabric.media.error",
        defaultMessage: "Error"
    },
    search_all_gifs: {
        id: "fabric.media.search_all_gifs",
        defaultMessage: "Search all the GIFs!"
    },
    cant_retrieve_gifs: {
        id: "fabric.media.cant_retrieve_gifs",
        defaultMessage: "Ouch! We could not retrieve any GIFs"
    },
    cant_retrieve_files: {
        id: "fabric.media.cant_retrieve_files",
        defaultMessage: "Ouch! We could not retrieve any files"
    },
    check_your_network: {
        id: "fabric.media.check_your_network",
        defaultMessage: "Check your network connection"
    },
    try_again: {
        id: "fabric.media.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.media.try_another_account",
        defaultMessage: "Try another account"
    },
    no_gifs_found: {
        id: "fabric.media.no_gifs_found",
        defaultMessage: "Hello? Was it me you're looking for?"
    },
    no_gifs_found_suggestion: {
        id: "fabric.media.no_gifs_found_suggestion",
        defaultMessage: "We couldn't find anything for \"{query}\""
    },
    load_more_gifs: {
        id: "fabric.media.load_more_gifs",
        defaultMessage: "Load more GIFs"
    },
    add_account: {
        id: "fabric.media.add_account",
        defaultMessage: "Add account"
    },
    unlink_account: {
        id: "fabric.media.unlink_account",
        defaultMessage: "Unlink Account"
    },
    upload_file_from: {
        id: "fabric.media.upload_file_from",
        defaultMessage: "Upload a file from {name}"
    },
    connect_to: {
        id: "fabric.media.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.media.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.media.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.media.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.media.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.media.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    invalid_permissions: {
        id: "fabric.media.invalid_permissions",
        defaultMessage: "Restricted link"
    },
    invalid_permissions_description: {
        id: "fabric.media.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    select_an_avatar: {
        id: "fabric.media.select_an_avatar",
        defaultMessage: "Select a default avatar"
    },
    upload_an_avatar: {
        id: "fabric.media.upload_an_avatar",
        defaultMessage: "Upload an avatar"
    },
    select_an_avatar_from_all_defaults: {
        id: "fabric.media.select_an_avatar_from_all_defaults",
        defaultMessage: "Select from all default options"
    },
    show_more_avatars_btn_label: {
        id: "fabric.media.show_more_avatars_btn_label",
        defaultMessage: "Show more"
    },
    or_select_default_avatars: {
        id: "fabric.media.or_select_default_avatars",
        defaultMessage: "Upload a photo or select from some default options"
    },
    loading: {
        id: "fabric.media.loading",
        defaultMessage: "Loading..."
    },
    loading_file: {
        id: "fabric.media.loading_file",
        defaultMessage: "Loading file..."
    },
    save: {
        id: "fabric.media.save",
        defaultMessage: "Save"
    },
    or: {
        id: "fabric.media.or",
        defaultMessage: "or"
    },
    upload_photo: {
        id: "fabric.media.upload_photo",
        defaultMessage: "Upload a photo"
    },
    default_avatars: {
        id: "fabric.media.default_avatars",
        defaultMessage: "Default avatars"
    },
    avatar_picker_back_btn_label: {
        id: "fabric.media.avatar_picker_back_btn_label",
        defaultMessage: "Go Back"
    },
    drag_and_drop_images_here: {
        id: "fabric.media.drag_and_drop_images_here",
        defaultMessage: "Drag and drop your images here"
    },
    alt_text: {
        id: "fabric.media.alt_text_label",
        defaultMessage: "Alt text"
    },
    alt_text_description: {
        id: "fabric.media.alt_text_helper_message",
        defaultMessage: "How would you describe the selected image to someone with low vision?"
    },
    image_url_invalid_error: {
        id: "fabric.media.image_url_invalid_error",
        defaultMessage: "Could not load image, the url is invalid."
    },
    image_format_invalid_error: {
        id: "fabric.media.image_format_invalid_error",
        defaultMessage: "Could not load image, the format is invalid."
    },
    image_size_too_large_error: {
        id: "fabric.media.image_size_too_large_error",
        defaultMessage: "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    something_went_wrong: {
        id: "fabric.media.something_went_wrong",
        defaultMessage: "Something went wrong."
    },
    might_be_a_hiccup: {
        id: "fabric.media.might_be_a_hiccup",
        defaultMessage: "It might just be a hiccup."
    },
    couldnt_generate_preview: {
        id: "fabric.media.couldnt_generate_preview",
        defaultMessage: "We couldn't generate a preview for this file."
    },
    couldnt_generate_encrypted_entry_preview: {
        id: "fabric.media.couldnt_generate_encrypted_entry_preview",
        defaultMessage: "We can't preview encrypted or password protected files."
    },
    cant_preview_file_type: {
        id: "fabric.media.cant_preview_file_type",
        defaultMessage: "We can't preview this file type."
    },
    item_not_found_in_list: {
        id: "fabric.media.item_not_found_in_list",
        defaultMessage: "The selected item was not found on the list."
    },
    not_found_title: {
        id: "fabric.media.not_found_title",
        defaultMessage: "Uh oh. We can't find this link!"
    },
    not_found_description: {
        id: "fabric.media.not_found_description",
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again."
    },
    no_pdf_artifacts: {
        id: "fabric.media.no_pdf_artifacts",
        defaultMessage: "No PDF artifacts found for this file."
    },
    password_protected_pdf: {
        id: "fabric.media.password_protected_pdf",
        defaultMessage: "This file is password protected."
    },
    password: {
        id: "fabric.media.password",
        defaultMessage: "Password"
    },
    enter_password: {
        id: "fabric.media.enter_password",
        defaultMessage: "Enter password"
    },
    incorrect_password: {
        id: "fabric.media.incorrect_password",
        defaultMessage: "Incorrect password. Please try again."
    },
    submit: {
        id: "fabric.media.submit",
        defaultMessage: "Submit"
    },
    give_feedback: {
        id: "fabric.media.give_feedback",
        defaultMessage: "Give feedback"
    },
    try_downloading_file: {
        id: "fabric.media.try_downloading_file",
        defaultMessage: "Try downloading the file to view it."
    },
    webgl_warning_description: {
        id: "fabric.media.webgl_warning_description",
        defaultMessage: "Your browser does not support WebGL. Use a WebGL enabled browser to annotate images."
    },
    unable_to_annotate_image: {
        id: "fabric.media.unable_to_annotate_image",
        defaultMessage: "You're unable to annotate this image"
    },
    learn_more: {
        id: "fabric.media.learn_more",
        defaultMessage: "Learn More"
    },
    accounts: {
        id: "fabric.media.accounts",
        defaultMessage: "Accounts"
    },
    actions: {
        id: "fabric.media.actions",
        defaultMessage: "Actions"
    },
    error_hint_retry: {
        id: "fabric.media.error_hint_retry",
        defaultMessage: "Try again and we'll give it another shot."
    },
    error_hint_critical: {
        id: "fabric.media.error_hint_critical",
        defaultMessage: "If the problem keeps happening contact support."
    },
    close: {
        id: "fabric.media.close",
        defaultMessage: "Close"
    },
    could_not_load_editor: {
        id: "fabric.media.could_not_load_editor",
        defaultMessage: "Ouch! We could not load the editor"
    },
    could_not_save_image: {
        id: "fabric.media.could_not_save_image",
        defaultMessage: "Ouch! We could not save the image"
    },
    could_not_load_link: {
        id: "fabric.media.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    annotate: {
        id: "fabric.media.annotate",
        defaultMessage: "Annotate"
    },
    annotate_tool_arrow: {
        id: "fabric.media.annotate.tool.arrow",
        defaultMessage: "Arrow"
    },
    annotate_tool_text: {
        id: "fabric.media.annotate.tool.text",
        defaultMessage: "Text"
    },
    annotate_tool_shape: {
        id: "fabric.media.annotate.tool.shape",
        defaultMessage: "Shape"
    },
    annotate_tool_brush: {
        id: "fabric.media.annotate.tool.brush",
        defaultMessage: "Brush"
    },
    annotate_tool_blur: {
        id: "fabric.media.annotate.tool.blur",
        defaultMessage: "Blur"
    },
    annotate_tool_line_thickness: {
        id: "fabric.media.annotate.tool.line.thickness",
        defaultMessage: "Line thickness"
    },
    annotate_tool_color: {
        id: "fabric.media.annotate.tool.color",
        defaultMessage: "Color"
    },
    annotate_confirmation_close_anyway: {
        id: "fabric.media.annotate.confirmation.close.anyway",
        defaultMessage: "Close anyway"
    },
    annotate_confirmation_heading: {
        id: "fabric.media.annotate.confirmation.heading",
        defaultMessage: "Unsaved changes"
    },
    annotate_confirmation_content: {
        id: "fabric.media.annotate.confirmation.content",
        defaultMessage: "You have some unsaved changes. Are you sure you want to leave?"
    },
    drop_your_files_here: {
        id: "fabric.media.drop_your_files_here",
        defaultMessage: "Drop your files here"
    },
    share_files_instantly: {
        id: "fabric.media.share_files_instantly",
        defaultMessage: "We'll share them instantly"
    },
    insert_files: {
        id: "fabric.media.insert_files",
        defaultMessage: "Insert {0, plural, one {a file} other {{0} files}}"
    },
    zoom_out: {
        id: "fabric.media.zoom_out",
        defaultMessage: "zoom out"
    },
    zoom_in: {
        id: "fabric.media.zoom_in",
        defaultMessage: "zoom in"
    },
    remove_image: {
        id: "fabric.media.remove_image",
        defaultMessage: "Remove image"
    },
    play: {
        id: "fabric.media.play",
        defaultMessage: "Play"
    },
    pause: {
        id: "fabric.media.pause",
        defaultMessage: "Pause"
    },
    disable_fullscreen: {
        id: "fabric.media.disable_fullscreen",
        defaultMessage: "disable fullscreen"
    },
    enable_fullscreen: {
        id: "fabric.media.enable_fullscreen",
        defaultMessage: "enable fullscreen"
    },
    error_loading_file: {
        id: "fabric.media.error_loading_file",
        defaultMessage: "Error loading file"
    },
    error_generating_preview: {
        id: "fabric.media.error_generating_preview",
        defaultMessage: "Error generating preview"
    },
    download: {
        id: "fabric.media.download",
        defaultMessage: "Download"
    },
    download_disabled_security_policy: {
        id: "fabric.media.download_disabled_security_policy",
        defaultMessage: "Download is blocked by your organization's security policy."
    },
    unknown: {
        id: "fabric.media.unknown",
        defaultMessage: "unknown"
    },
    document: {
        id: "fabric.media.document",
        defaultMessage: "document"
    },
    audio: {
        id: "fabric.media.audio",
        defaultMessage: "audio"
    },
    video: {
        id: "fabric.media.video",
        defaultMessage: "video"
    },
    image: {
        id: "fabric.media.image",
        defaultMessage: "image"
    },
    archive: {
        id: "fabric.media.archive",
        defaultMessage: "archive"
    },
    email: {
        id: "fabric.media.email",
        defaultMessage: "email"
    },
    text: {
        id: "fabric.media.text",
        defaultMessage: "text"
    },
    displayThumbnail: {
        id: "fabric.media.display_thumbnail",
        defaultMessage: "Display thumbnail"
    },
    search: {
        id: "fabric.media.search",
        defaultMessage: "search"
    },
    view: {
        id: "fabric.media.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.media.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.media.srclinkunknown",
        defaultMessage: "View Original"
    },
    changeView: {
        id: "fabric.media.change_view",
        defaultMessage: "Change view"
    },
    playbackSpeed: {
        id: "fabric.media.playback_speed",
        defaultMessage: "Playback speed"
    },
    video_captions_enable: {
        id: "fabric.media.video_captions_enable",
        defaultMessage: "Closed Captions"
    },
    video_captions_select_captions: {
        id: "fabric.media.video_captions_select_captions",
        defaultMessage: "Select Captions"
    },
    video_captions_upload_captions_form_header: {
        id: "fabric.media.video_captions_upload_captions_form_header",
        defaultMessage: "Upload Captions"
    },
    video_captions_upload_captions_form_language_picker: {
        id: "fabric.media.video_captions_upload_captions_form_language_picker",
        defaultMessage: "Select the file language"
    },
    video_captions_upload_success_description: {
        id: "fabric.media.video_captions_upload_success_description",
        defaultMessage: "The caption was successfully uploaded for this video."
    },
    video_captions_upload_error_description: {
        id: "fabric.media.video_captions_upload_error_description",
        defaultMessage: "The caption failed to upload."
    },
    video_captions_delete_captions_confirmation_header: {
        id: "fabric.media.video_captions_delete_captions_confirmation_header",
        defaultMessage: "Delete Caption"
    },
    video_captions_delete_captions_confirmation_description: {
        id: "fabric.media.video_captions_delete_captions_confirmation_description",
        defaultMessage: "Please confirm that you want to delete this caption."
    },
    video_captions_delete_success_description: {
        id: "fabric.media.video_captions_delete_success_description",
        defaultMessage: "The caption was successfully removed from this video."
    },
    video_captions_delete_error_description: {
        id: "fabric.media.video_captions_delete_error_description",
        defaultMessage: "The caption failed to delete."
    },
    manage_captions: {
        id: "fabric.media.manage_captions",
        defaultMessage: "Manage Captions"
    },
    add_captions: {
        id: "fabric.media.add_captions",
        defaultMessage: "Add Captions"
    },
    skipBackward: {
        id: "fabric.media.skip_backward",
        defaultMessage: "Back 10 seconds"
    },
    skipForward: {
        id: "fabric.media.skip_forward",
        defaultMessage: "Forward 10 seconds"
    },
    sizeOptions: {
        id: "fabric.media.size_options",
        defaultMessage: "Size options"
    },
    fileDisplayOptions: {
        id: "fabric.media.file.display_options",
        defaultMessage: "Display options"
    },
    volumeLevelControlAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "volume"
    },
    volumeMuteButtonAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "mute"
    },
    playbackDefaultSpeed: {
        id: "fabric.media.playback_default_speed",
        defaultMessage: "Default"
    },
    preview: {
        id: "fabric.media.preview",
        defaultMessage: "Preview"
    },
    creating_preview: {
        id: "fabric.media.creating_preview",
        defaultMessage: "Creating preview..."
    },
    preview_unavailable: {
        id: "fabric.media.preview_unavailable",
        defaultMessage: "Preview unavailable"
    },
    couldnt_load_file: {
        id: "fabric.media.couldnt_load_file",
        defaultMessage: "We couldn't load the file."
    },
    error_429: {
        id: "fabric.media.error_429",
        defaultMessage: "Error 429"
    },
    close_and_reopen: {
        id: "fabric.media.close_and_reopen",
        defaultMessage: "Try closing this file and reopening."
    },
    viewer_rateLimited: {
        id: "fabric.media.viewer_rateLimited",
        defaultMessage: "We're having difficulties loading your file."
    },
    zip_entry_load_fail: {
        id: "fabric.media.zip_entry_load_failed",
        defaultMessage: "We couldn't load that zip file item to preview"
    },
    file_image_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Image {name} is selected"
    },
    file_video_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Video {name} is selected"
    },
    file_audio_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Audio {name} is selected"
    },
    file_doc_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Document {name} is selected"
    },
    file_archive_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Archive {name} is selected"
    },
    file_unknown_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "File {name} is selected"
    },
    open_file_in_viewer: {
        id: "fabric.media.open_file_in_viewer",
        defaultMessage: "Open {name}"
    },
    video_seeker_assistive_text_time_value: {
        id: "fabric.media.video_seeker_assistive_text_time_value",
        defaultMessage: "{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}"
    },
    video_seeker_label_assistive_text: {
        id: "fabric.media.video_seeker_label_assistive_text",
        defaultMessage: "Seek slider"
    },
    abuse_modal_body: {
        id: "fabric.media.abuse_modal_body",
        defaultMessage: "For your security, our system automatically scans all uploaded files. The file you are about to download potentially contains malicious content"
    },
    abuse_modal_title: {
        id: "fabric.media.abuse_modal_title",
        defaultMessage: "Warning"
    },
    abuse_modal_submit: {
        id: "fabric.media.abuse_modal_submit",
        defaultMessage: "Proceed with download"
    },
    image_cropper_arrow_keys_label: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.label",
        defaultMessage: "Draggable Image, Ensure your screen reader is not in browse mode. use arrow keys to move & crop the image"
    },
    image_cropper_image_moved: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.action",
        defaultMessage: "You have moved the image from {key, select, left {left to right} right {right to left} top {top to bottom} other {bottom to top} }, use arrow keys to move & crop the image"
    },
    image_cropper_zoom_out: {
        id: "media.media-avatar-picker.image-cropper.zoom_out",
        defaultMessage: "Zoom out"
    },
    image_cropper_zoom_in: {
        id: "media.media-avatar-picker.image-cropper.zoom_in",
        defaultMessage: "Zoom in"
    },
    image_cropper_zoom_slider: {
        id: "media.media-avatar-picker.image-cropper.zoom_slider",
        defaultMessage: "set zoom"
    }
});
module.exports["messages"] = $51c490bf07ac8c08$export$defe85febe8b728c;

});

parcelRegister("8QL6C", function(module, exports) {
// Media feature flags - type and defaults defined here in one source of truth
const $6b97f3fad80b5910$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];


const $d17c6572fbd16cff$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $d17c6572fbd16cff$export$189fe120be7e73fc = ()=>$d17c6572fbd16cff$var$productKeys;


// window.localStorage is easier to mock in tests if wrapped in this module
const $6c56cea62b261d1c$export$d125817a2695dbc9 = (key)=>{
    try {
        return typeof window !== 'undefined' && window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};


function $18475707c4faede4$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $6c56cea62b261d1c$export$d125817a2695dbc9)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}


const $586e61da7604bdbd$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $586e61da7604bdbd$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $d17c6572fbd16cff$export$189fe120be7e73fc)();
    let ldFeatureFlags = [];
    (0, $6b97f3fad80b5910$export$2db74afa1ef496f1).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $586e61da7604bdbd$export$836625761e76d373 = {
    mediaInline: false
};
function $586e61da7604bdbd$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $18475707c4faede4$export$f2687d0de19e4973)(flagName, $586e61da7604bdbd$export$836625761e76d373, featureFlags);
}
module.exports["getFeatureFlagKeysAllProducts"] = $586e61da7604bdbd$export$c8bcd5e6111ea1f3;
module.exports["getMediaFeatureFlag"] = $586e61da7604bdbd$export$383e8f51978266d;

});

parcelRegister("ihjDz", function(module, exports) {
class $197aaa08f701d50c$export$ec8d022824f41295 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $197aaa08f701d50c$export$2c035820a31723e extends $197aaa08f701d50c$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $197aaa08f701d50c$export$10ab445310d30114 extends $197aaa08f701d50c$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $197aaa08f701d50c$export$18e89b7e50818288 extends $197aaa08f701d50c$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $197aaa08f701d50c$export$921ab4548acefaa4 = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $197aaa08f701d50c$export$d0a45ab59b4606b extends $197aaa08f701d50c$export$ec8d022824f41295 {
    constructor(source){
        super($197aaa08f701d50c$export$921ab4548acefaa4(source));
    }
}
function $197aaa08f701d50c$export$36b43e3dd9a92(err) {
    return err instanceof $197aaa08f701d50c$export$ec8d022824f41295;
}
const $197aaa08f701d50c$export$b380593ba3516c6f = (err)=>err instanceof $197aaa08f701d50c$export$2c035820a31723e;
const $197aaa08f701d50c$export$e1d87830b3784f94 = (err)=>err instanceof $197aaa08f701d50c$export$10ab445310d30114;
const $197aaa08f701d50c$export$443aeb298d35d79d = (err)=>$197aaa08f701d50c$export$36b43e3dd9a92(err) && err.primaryReason === 'local-preview-unsupported';
function $197aaa08f701d50c$export$f00bb5a138da22e1(err) {
    return err instanceof $197aaa08f701d50c$export$d0a45ab59b4606b;
}
const $197aaa08f701d50c$export$4536ca0b68b4caf9 = (primaryReason, error, updatePrimaryReason)=>{
    if ($197aaa08f701d50c$export$36b43e3dd9a92(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $197aaa08f701d50c$export$ec8d022824f41295(primaryReason, error.secondaryError);
        return error;
    }
    return new $197aaa08f701d50c$export$ec8d022824f41295(primaryReason, error);
};
const $197aaa08f701d50c$export$11f9f5835c5b9a04 = (error)=>error && error.primaryReason === 'upload';
module.exports["MediaCardError"] = $197aaa08f701d50c$export$ec8d022824f41295;
module.exports["ImageLoadError"] = $197aaa08f701d50c$export$d0a45ab59b4606b;
module.exports["isUploadError"] = $197aaa08f701d50c$export$11f9f5835c5b9a04;

});

parcelRegister("aWYXa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gxsT9 = parcelRequire("gxsT9");


var $cbc8g = parcelRequire("cbc8g");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 


/*
  TODO: https://product-fabric.atlassian.net/browse/CXP-3132

  We need to revisit omitting percentage values for Design Token since the parent applies transform(-50%, -50%) on it (packages/media/media-ui/src/mediaImage/index.tsx). This styling is complex and may potentially cause a bug if not treaded carefully.
*/ const $a49532cd1c66edc2$var$imgStyle = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    objectFit: 'contain',
    imageOrientation: 'none'
};
const $a49532cd1c66edc2$export$fd536c918b58ab76 = (props)=>{
    const { style: style, imageRef: imageRef, ...otherProps } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlassian/a11y/alt-text -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        ...otherProps,
        ref: imageRef,
        style: {
            ...$a49532cd1c66edc2$var$imgStyle,
            ...style
        }
    }));
};



var $21oLb = parcelRequire("21oLb");


var $iP9n7 = parcelRequire("iP9n7");

const $e496909ca63f7b47$export$1f97dc1e9d072692 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ dataURI: dataURI, alt: alt = '', crop: crop = false, stretch: stretch = false, previewOrientation: previewOrientation = 1, crossOrigin: crossOrigin, onImageLoad: onImageLoad, onImageError: onImageError, loading: loading, forceSyncDisplay: forceSyncDisplay = false }, ref)=>{
    const [{ width: parentWidth, height: parentHeight }, setParentDimensions] = (0, $42omo.useState)({
        width: Infinity,
        height: Infinity
    });
    const [{ width: imgWidth, height: imgHeight }, setImageDimensions] = (0, $42omo.useState)({
        width: 0,
        height: 0
    });
    const [isImageLoaded, setIsImageLoaded] = (0, $42omo.useState)(false);
    const imgRef = (0, $42omo.useRef)(null);
    const imageRef = (0, $42omo.useCallback)((imgElem)=>{
        if (!imgElem || imgRef.current) return;
        if (imgElem.parentElement) {
            const { width: width, height: height } = imgElem.parentElement.getBoundingClientRect();
            setParentDimensions({
                width: width,
                height: height
            });
        }
        imgRef.current = imgElem;
    }, []);
    const mergedRef = (0, $iP9n7.useMergeRefs)([
        imageRef,
        ref
    ]);
    const imageLoadHandler = (e)=>{
        if (!imgRef.current) return;
        setImageDimensions({
            width: imgRef.current.naturalWidth,
            height: imgRef.current.naturalHeight
        });
        setIsImageLoaded(true);
        onImageLoad?.(e.currentTarget);
    };
    const parentRatio = parentWidth / parentHeight;
    let imgRatio = imgWidth / imgHeight;
    let percentSize = '100%';
    /*
      Cover strategy means we want to full entire screen with an image. Here is an example:

         Image           Container   Result (░ - is what cropped out)
     ┌──────────────┐    ┌──────┐    ┌───┬──────┬───┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    └──────┘    └───┴──────┴───┘
     └──────────────┘
    */ const isCoverStrategy = crop;
    /*
      Fit strategy means image is fully inside container even if there is empty space left.
      Here is an example:

             Image            Container     Result
     ┌────────────────────┐    ┌──────┐    ┌──────┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     └────────────────────┘    └──────┘    └──────┘
     */ const isFitStrategy = !crop;
    const isImageRotated = previewOrientation !== 'from-image' && (0, $21oLb.isRotated)(previewOrientation);
    /*
      When photo has orientation of 90deg or 270deg (stored in EXIF meta data)
      things get very tricky. Let me go through an two examples to explain how we deal with that:

      Example #1:

      Image comes in as    ________    But it needs to be     ┌──────┐
      horizontal picture  |        |   displayed as 750x1000  │      │
      of 1000x750         |        |   because orientation    │      │
                          |________|   say it must be rotated │      │
                                       90 degrees             │      │
                                                              └──────┘

      Container is smaller, and has dimensions of 100x200.
      So, input parameters are:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: true (means we want to cover)
        stretch: true
        previewOrientation: 6

      To see what true value of isImageMoreLandscapyThanContainer is we need to flip imgRatio.
      Since initial value is 1000/750 = 1.33 we can just do 1/1.3333 = 0.75.

      In this situation final values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: true
        isFitStrategy: false
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

      According to this variables state css will become:
        height: 100%;

      Now here is what going to happened.
      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply height: 100%.

      ┌────┬──────┬────┐  This will scale an image according to rules of proportions:
      │░░░░│▓▓▓▓▓▓│░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      │░░░░│▓▓▓▓▓▓│░░░░│  (orig img height) -> (scaled down img height)
      │░░░░│▓▓▓▓▓▓│░░░░│  750px             -> 200px  (is === container height, since `height: 100%`)
      └────┴──────┴────┘  (orig img width)  -> (scaled down img width)
              ↑           1000px            -> (200 x 1000) / 750 = 266.66px
       266x200 image in
       100x200 container.

      And only NOW browser will apply rotate: 90deg and turn image around.
      And we end up with this:

      ┌──────────┐   Where 200x266 image
      │░░░░░░░░░░│   in the 100x200 container.
      │░┌──────┐░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░└──────┘░│
      │░░░░░░░░░░│
      └──────────┘

      To combat this we will not make height: 100% but use ratio of an image.
      In this case imgRatio is now 0.75 (after flipping)

      New math will look like this:
      (orig img height) -> (scaled down img height)
      750px             -> (0.75 x 200px) = 150px (since `height: 75%`)
      (orig img width)  -> (scaled down img width)
      1000px            -> (150 x 1000) / 750 = 200px

      ┌─┬──────┬─┐  Now 150x200 image
      │░│▓▓▓▓▓▓│░│  is in 100x200 container.
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      └─┴──────┴─┘

      Unfortunately this is not over yet.



      Example #2:

      Input parameters:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: false (means we want to fit)  <-- This is only changed parameter
        stretch: true
        previewOrientation: 6

      Final variable values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: false
        isFitStrategy: true
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

       According to this variables state css will become:
        width: 100%;

      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply width: 100%.

      ┌────────┐  This will scale an image according to rules of proportions:
      │░░░░░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      ├────────┤  (orig img width)  -> (scaled down img width)
      │▓▓▓▓▓▓▓▓│  1000px            -> 100px (is === container width, since `width: 100%`)
      │▓▓▓▓▓▓▓▓│  (orig img height) -> (scaled down img height)
      ├────────┤  750px             -> (750x100) / 1000 = 75px
      │░░░░░░░░│
      └────────┘
          ↑
       100x75 image in
       100x200 container.

      Now browser will turn image 90degrees and we und up with:
      ┌──────────┐
      │          │  75x100 image in
      │ ┌──────┐ │  100x200 container
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ └──────┘ │
      │          │
      └──────────┘

      This looks familiar, and you might want to try what we did before and apply 75% not 100%.
      Unfortunately this will make it even worse. If you do calculation you will find out that
      final result will be 75x56 image in 100x200 container. For this and one more specific
      variables state we need to use original imgRatio for percent size. In this case it's 1.333, so
      134%

      New math will look like this:
      (orig img width)  -> (scaled down img width)
      1000px            -> (100px * 1.34) = 134px (since `width: 134%`)
      (orig img height) -> (scaled down img height)
      750px             -> (750x134) / 1000 = 100px

      So, 100x134 image in 100x200 container.
     */ if (isImageRotated) {
        imgRatio = 1 / imgRatio;
        percentSize = `${Math.ceil(imgRatio * 100)}%`;
    }
    /*
      Here is an example of when isImageMoreLandscapyThanContainer is true:

        Image      Container   OR   Image      Container
       ________      _____          ____           __
      |        | -> |     |        |    |   ->    |  |
      |________|    |_____|        |    |         |  |
                                   |    |         |  |
                                   |    |         |  |
                                   |____|         |__|

      For false just swap "Image" and "Container" in the example above.
     */ const isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
    const isImgLandscape = imgWidth > imgHeight;
    /*
    This is two cases we need to cover as described in Example #2 above, but only for rotated landscape images.
     */ if (isImageRotated && isImgLandscape) {
        if (isFitStrategy || isImageMoreLandscapyThanContainer || isCoverStrategy && !isImageMoreLandscapyThanContainer) percentSize = `${Math.ceil(1 / imgRatio * 100)}%`;
    }
    /*
      When isStretchingAllowed is false image is as big as it is, but as small as container
      (according to strategy - cover or fit).
      isStretchingAllowed is true if image is bigger then container.
     */ const isStretchingAllowed = stretch;
    /*
      We do not want to show image until we finish deciding on sizing strategy.
      Though if it is a "fit" strategy (and image hasn't been rotated) we can display it right away,
      since it doesn't depend on isImageMoreLandscapyThanContainer nor it will change when isStretchingAllowed
      changes it's value after imgRatio and parentRatio get defined.
      The reason for exclude isImageRotated is that we need to calculate percentSize variable
      and we can do that only when image is loaded (and we have image size)
     */ const showImage = forceSyncDisplay || isImageLoaded || isFitStrategy && !isImageRotated;
    const style = {
        transform: 'translate(-50%, -50%)'
    };
    if (isStretchingAllowed) {
        if (isFitStrategy && isImageMoreLandscapyThanContainer) /*
          Image matches its width to container's and height scales accordingly.

            Image       Container       Result
                       ┌─────────┐    ┌─────────┐
           ┌──────┐    │         │    ├─────────┤
           │▓▓▓▓▓▓│ -> │         │ => │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           └──────┘    │         │    ├─────────┤
                       └─────────┘    └─────────┘
         */ style.width = percentSize;
        else if (isFitStrategy && !isImageMoreLandscapyThanContainer) /*
          Image matches its height to container's and width scales accordingly.
         */ style.height = percentSize;
        else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          In order to cover whole container guaranteed (even in expense of stretching)
          image matches its height to container's. Width scales accordingly and crops out sides.

             Image       Container    Result (░ - is what cropped out)
                       ┌─────────┐    ┌──┬──────┬──┐
           ┌──────┐    │         │    │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│ -> │         │ => │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│    │         │    │░░│▓▓▓▓▓▓│░░│
           └──────┘    │         │    │░░│▓▓▓▓▓▓│░░│
                       └─────────┘    └──┴──────┴──┘
         */ style.height = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.width = percentSize;
    } else {
        if (isFitStrategy) {
            /*
          We want image to be as wide and as height as container but not bigger then it's own size.

            Image       Container       Result
           ┌───────────┐    ┌─────────┐    ┌─────────┐
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    ├─────────┤
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓▓▓▓▓▓│->  │         │ => │▓▓▓▓▓▓▓▓▓│
           └───────────┘    │         │    │▓▓▓▓▓▓▓▓▓│
                            │         │    ├─────────┤
                            └─────────┘    └─────────┘

         And if image is smaller it doesn't change its size

            Image       Container       Result
                       ┌──────────┐    ┌──────────┐
                       │          │    │          │
           ┌──────┐    │          │    │ ┌──────┐ │
           │▓▓▓▓▓▓│ -> │          │ => │ │▓▓▓▓▓▓│ │
           │▓▓▓▓▓▓│    │          │    │ │▓▓▓▓▓▓│ │
           └──────┘    │          │    │ └──────┘ │
                       │          │    │          │
                       └──────────┘    └──────────┘
         */ style.maxWidth = percentSize;
            style.maxHeight = percentSize;
        } else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          We want to fill container but we can't stretch an image if it's smaller then container.

            Image            Container       Result
           ┌────────────┐    ┌───────┐    ┌──┬───────┬──┐
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│->  │       │ => │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    └───────┘    └──┴───────┴──┘
           └────────────┘

         */ style.maxHeight = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.maxWidth = percentSize;
    }
    if (!showImage || !dataURI) style.display = 'none';
    if (previewOrientation === 'from-image') style.imageOrientation = 'from-image';
    else if (previewOrientation > 1) {
        const transform = (0, $21oLb.getCssFromImageOrientation)(previewOrientation);
        style.transform += ` ${transform}`;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbc8g.default), {
        data: {
            hasMediaComponent: true
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a49532cd1c66edc2$export$fd536c918b58ab76), {
        loading: loading,
        "data-testid": "media-image",
        "data-vc": "media-image",
        draggable: false,
        alt: alt,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onLoad: imageLoadHandler,
        onError: onImageError,
        imageRef: mergedRef,
        src: dataURI,
        crossOrigin: crossOrigin,
        ...(0, $gxsT9.VcMediaWrapperProps)
    }));
});
module.exports["MediaImage"] = $e496909ca63f7b47$export$1f97dc1e9d072692;

});

parcelRegister("bSKDV", function(module, exports) {
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $d1a10455ac2f8edd$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $d1a10455ac2f8edd$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $d1a10455ac2f8edd$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #091E4224)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #758195)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #172B4D)"
};
module.exports["hexToEditorBorderPaletteColor"] = $d1a10455ac2f8edd$export$bad3c41dd33cb4bc;

});

parcelRegister("55QXP", function(module, exports) {
var $59f4a16af392a89e$export$ecd1fed429542b49 = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}({});
var $59f4a16af392a89e$export$9cf3651d97128b9c = /*#__PURE__*/ function(VIEW_METHOD) {
    VIEW_METHOD["BADGE"] = "badge";
    VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
    return VIEW_METHOD;
}({});
module.exports["RESOLVE_METHOD"] = $59f4a16af392a89e$export$ecd1fed429542b49;
module.exports["VIEW_METHOD"] = $59f4a16af392a89e$export$9cf3651d97128b9c;

});

parcelRegister("fGYGE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1yB28 = parcelRequire("1yB28");


var $kOV42 = parcelRequire("kOV42");


var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $7BTEV = parcelRequire("7BTEV");

const $4e0b21253fab8db4$var$baseStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small'
});
const $4e0b21253fab8db4$var$mediumBadgeStyles = (0, $ecnYn.xcss)({
    height: 'space.300',
    width: 'space.300'
});
const $4e0b21253fab8db4$export$d5da84b0136a0cc4 = ({ status: status = 'default', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const intl = (0, $8C5kA.default)();
    const title = intl.formatMessage((0, $7BTEV.commentMessages).viewCommentsOnMedia);
    const colourToken = (0, $42omo.useMemo)(()=>{
        switch(status){
            case 'active':
                return 'color.background.accent.yellow.subtlest.pressed';
            case 'entered':
                return 'color.background.accent.yellow.subtlest.hovered';
            default:
                return 'color.background.accent.yellow.subtlest';
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "top",
        content: title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        xcss: [
            $4e0b21253fab8db4$var$baseStyles,
            $4e0b21253fab8db4$var$mediumBadgeStyles
        ],
        padding: "space.0",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        backgroundColor: colourToken
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
        label: title,
        spacing: "spacious",
        color: "currentColor",
        LEGACY_size: "medium",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kOV42)))
    })));
};
module.exports["CommentBadgeNext"] = $4e0b21253fab8db4$export$d5da84b0136a0cc4;

});

parcelRegister("7BTEV", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $724c8781ca7eb4e2$export$4c0d145df60cfb04 = (0, $cgtv4.defineMessages)({
    addCommentOnMedia: {
        id: "fabric.editor.addCommentOnMedia",
        defaultMessage: "Add comment"
    },
    viewCommentsOnMedia: {
        id: "fabric.editor.viewCommentOnMedia",
        defaultMessage: "View comments"
    },
    viewAndAddCommentsOnMedia: {
        id: "fabric.editor.viewAndAddCommentsOnMedia",
        defaultMessage: "View and add comments"
    }
});
module.exports["commentMessages"] = $724c8781ca7eb4e2$export$4c0d145df60cfb04;

});

parcelRegister("4i54r", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $lVBH4 = parcelRequire("lVBH4");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $cgtv4 = parcelRequire("cgtv4");

const $c4b5cf4ce6d702b4$export$8e36294abfabe45e = (0, $cgtv4.defineMessages)({
    externalMediaFile: {
        id: "fabric.editor.externalMediaFile",
        defaultMessage: "External media file"
    }
});


const $df07f356bbd706ec$var$baseStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $df07f356bbd706ec$var$NO_EXTERNAL_BADGE_HOSTS = [
    'atlassian.com',
    'loom.com'
];
const $df07f356bbd706ec$export$babb68fb5c212c90 = (url)=>{
    if (!url) return false;
    // Check if URL is valid
    try {
        new URL(url);
    } catch  {
        return false;
    }
    const parsedUrl = new URL(url || '');
    const { hostname: hostname, pathname: pathname, protocol: protocol } = parsedUrl;
    if (protocol === 'data:') return pathname?.startsWith('image/');
    return Boolean(hostname && $df07f356bbd706ec$var$NO_EXTERNAL_BADGE_HOSTS.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
};
const $df07f356bbd706ec$export$66bf2ed7a5d4691f = ({ type: type, url: url })=>{
    const intl = (0, $8C5kA.default)();
    const message = intl.formatMessage((0, $c4b5cf4ce6d702b4$export$8e36294abfabe45e).externalMediaFile);
    if (type !== 'external' || $df07f356bbd706ec$export$babb68fb5c212c90(url)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.050",
        xcss: $df07f356bbd706ec$var$baseStyles,
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "external-image-badge"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: message,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lVBH4))), {
        LEGACY_size: "small",
        label: message
    })));
};
module.exports["ExternalImageBadge"] = $df07f356bbd706ec$export$66bf2ed7a5d4691f;

});

parcelRegister("1xbL9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $0b276d94054df1c8$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT = 200;
const $0b276d94054df1c8$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $0b276d94054df1c8$var$hackedZIndexStyles = (0, $ecnYn.xcss)({
    // @ts-ignore
    zIndex: '1'
});
const $0b276d94054df1c8$var$resizeOffsetStyles = (0, $ecnYn.xcss)({
    right: 'space.150'
});
const $0b276d94054df1c8$var$getBadgeVisible = (width, height)=>{
    return width && width < $0b276d94054df1c8$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT || height && height < $0b276d94054df1c8$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $0b276d94054df1c8$export$6a31fc38737d0e58 = ({ children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $42omo.useState)($0b276d94054df1c8$var$getBadgeVisible(mediaWidth, mediaHeight));
    (0, $42omo.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setVisible($0b276d94054df1c8$var$getBadgeVisible(width, height));
        }));
        if (mediaElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(mediaElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaElement
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    // delete this block on cleanup of media-perf-uplift-mutation-fix
    if (!(0, $dh538.fg)('media-perf-uplift-mutation-fix')) {
        // becuase it is wrapped in a fragment, React.Children.count(children) will always be 1.
        // That makes this check a source of late mutations that we don't need.
        if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) === 0) return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        xcss: [
            $0b276d94054df1c8$var$containerStyles,
            useMinimumZIndex && $0b276d94054df1c8$var$hackedZIndexStyles,
            extendedResizeOffset && $0b276d94054df1c8$var$resizeOffsetStyles
        ]
    }, children);
};
module.exports["MediaBadges"] = $0b276d94054df1c8$export$6a31fc38737d0e58;

});

parcelRegister("46EIy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cewj5 = parcelRequire("cewj5");


var $6ZDLj = parcelRequire("6ZDLj");


var $dh538 = parcelRequire("dh538");

const $340ce807e864e408$var$DURATION_MIN = 0.5;
const $340ce807e864e408$var$DURATION_MAX = 1.0;
const $340ce807e864e408$var$EXTRA_PADDING = 4;
const $340ce807e864e408$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $340ce807e864e408$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $340ce807e864e408$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
   * The furthest we can scroll, where the end of the buffer is just in view
   */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $340ce807e864e408$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $340ce807e864e408$var$DURATION_MAX - $340ce807e864e408$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $340ce807e864e408$var$DURATION_MAX), $340ce807e864e408$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $340ce807e864e408$export$ba458cf715b18bd1);
        }
    }
    triggerScrollEvent() {
        if (!this.windowElement) return;
        const event = document.createEvent('MouseEvents');
        event.initEvent('scroll', true, true);
        this.windowElement.dispatchEvent(event);
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $340ce807e864e408$var$EXTRA_PADDING) return newOffset - $340ce807e864e408$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $340ce807e864e408$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $340ce807e864e408$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
        if (!(0, $dh538.fg)('platform_editor_disable_trigger_scroll_event')) // trigger a "real" scroll event so lazily loaded cards realize they've been shown
        // note: we have to wait for the transition to end, otherwise the cards not visible when the scroll
        // event is triggered will be forever stuck in the loading screen (due to the lazy load)
        window.setTimeout(()=>this.triggerScrollEvent(), this.transitionDuration * 1000);
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripViewWrapper), {
            "data-testid": testId
        }, this.renderLeftArrow(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripListWrapper), {
            ref: this.handleWindowElementChange,
            onWheel: this.handleScroll,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            "data-testid": "filmstrip-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripList), {
            ref: this.handleBufferElementChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                transform: transform,
                transitionProperty: transitionProperty,
                transitionDuration: transitionDuration
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, $340ce807e864e408$var$mapReactChildToReactNode))), this.renderRightArrow());
    }
    constructor(props){
        super(props);
        this.bufferElement = void 0;
        this.windowElement = void 0;
        this.mutationObserver = void 0;
        this.childOffsets = void 0;
        this.previousOffset = 0;
        this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        };
        this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        };
        this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        };
        this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        };
        this.handleMutation = (mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        };
        this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        };
        this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        };
        this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($cewj5)))(this.handleMutation, 30, true));
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
}
$340ce807e864e408$export$817db220b90d8024.defaultProps = {
    animate: false,
    offset: 0
};
function $340ce807e864e408$var$mapReactChildToReactNode(child, index) {
    const key = $340ce807e864e408$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripListItem), {
        key: key,
        index: key
    }, child);
}
function $340ce807e864e408$var$isReactElement(child) {
    return !!child.type;
}
module.exports["MediaFilmStripListItemSelector"] = $340ce807e864e408$export$9f2ec2b609810bce;
module.exports["FilmstripView"] = $340ce807e864e408$export$817db220b90d8024;

});

parcelRegister("cewj5", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $8e7fda51b7396b67$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$8e7fda51b7396b67$var$debounce.debounce = $8e7fda51b7396b67$var$debounce;
module.exports = $8e7fda51b7396b67$var$debounce;

});

parcelRegister("jpMnG", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $jTxSS = parcelRequire("jTxSS");


var $1e2E5 = parcelRequire("1e2E5");

var $gmMgo = parcelRequire("gmMgo");


var $inPa6 = parcelRequire("inPa6");


var $dehRH = parcelRequire("dehRH");

var $ihjDz = parcelRequire("ihjDz");


var $fO7zn = parcelRequire("fO7zn");


var $3rvSa = parcelRequire("3rvSa");


var $7NoXb = parcelRequire("7NoXb");


var $iu6m9 = parcelRequire("iu6m9");


var $cgtv4 = parcelRequire("cgtv4");

const $d94a223ed3433d0e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    unableToLoadContent: {
        id: "fabric.editor.unableToLoadContent",
        defaultMessage: "We couldn't load this content"
    },
    failedToUpload: {
        id: "fabric.editor.failed_to_upload",
        defaultMessage: "Failed to upload"
    }
});



var $5gVJx = parcelRequire("5gVJx");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $fCrf0 = parcelRequire("fCrf0");


var $k0QVR = parcelRequire("k0QVR");


var $aWYXa = parcelRequire("aWYXa");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $9hlns = parcelRequire("9hlns");

/** Height threshold that determines icon size to be small or medium */ const $6a98a0a47ebe23af$export$88e3664eef60c981 = 24;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



const $0090dcbf00152f3e$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'inline-flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    boxDecorationBreak: 'clone',
    borderRadius: `${"var(--ds-radius-small, 3px)"}`,
    color: `${"var(--ds-text, #292A2E)"}`,
    backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}`,
    transition: '0.1s all ease-in-out',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `${"var(--ds-background-neutral-hovered, #0B120E24)"}`
    }
});


const $365414ee34d9fe7e$export$b89a827e9254211a = ({ children: children, testId: testId })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: (0, $0090dcbf00152f3e$export$c4d4f06a25de97f),
        "data-testid": testId
    }, children);


const $59ac8d14dbcf9d7f$export$4b1a62d8f05056a7 = ({ testId: testId = 'media-inline-image-card-loading-view', height: height = (0, $6a98a0a47ebe23af$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $365414ee34d9fe7e$export$b89a827e9254211a), {
        testId: testId
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9hlns.default), {
        size: height > (0, $6a98a0a47ebe23af$export$88e3664eef60c981) ? 'medium' : 'small',
        interactionName: "media-inline-spinner"
    }));
};


const $c12bc8babb02df83$export$bb1dd14451154199 = ({ dimensions: dimensions, identifier: identifier, renderError: renderError, alt: alt, isLazy: isLazy, ssr: ssr, crop: crop, stretch: stretch })=>{
    // Generate unique traceId for file
    const traceContext = (0, $42omo.useMemo)(()=>({
            traceId: (0, $fCrf0.getRandomHex)(8)
        }), []);
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO do we need to handle nonCriticalError
    const { preview: preview, error: previewError, onImageError: onImageError, onImageLoad: onImageLoad, getSsrScriptProps: getSsrScriptProps, copyNodeRef: copyNodeRef } = (0, $k0QVR.useFilePreview)({
        identifier: identifier,
        ssr: ssr,
        dimensions: dimensions,
        traceContext: traceContext
    });
    if (previewError) return renderError({
        error: previewError
    });
    if (!preview) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $59ac8d14dbcf9d7f$export$4b1a62d8f05056a7), null);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aWYXa.MediaImage), {
        dataURI: preview.dataURI,
        alt: alt,
        previewOrientation: preview.orientation,
        onImageLoad: ()=>{
            onImageLoad(preview);
        },
        onImageError: onImageError,
        loading: isLazy ? 'lazy' : undefined,
        forceSyncDisplay: !!ssr,
        crop: crop,
        stretch: stretch,
        ref: copyNodeRef
    }), getSsrScriptProps && // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $9K4OG.jsx)("script", getSsrScriptProps()));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $bSKDV = parcelRequire("bSKDV");


var $fhm10 = parcelRequire("fhm10");

function $7cf4b05323c49fee$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// The MediaImage component needs to obtain its parent's dimensions.
// To achieve this, we have added an additional wrapper that allows
// for better interaction with the parent element. This is necessary
//  because the parent size changes its box-sizing with the node border.
const $7cf4b05323c49fee$var$sizeWrapperStyle = {
    name: "1ogmv4n",
    styles: "display:inline-flex;width:100%;height:100%"
};
const $7cf4b05323c49fee$export$8519fee8cc913056 = ({ children: children, isSelected: isSelected, aspectRatio: aspectRatio, borderSize: borderSize, borderColor: borderColor, htmlAttrs: htmlAttrs = {}, onClick: onClick })=>{
    const borderStyleVars = borderSize && borderColor ? {
        [(0, $fhm10.INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY)]: borderSize,
        [(0, $fhm10.INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY)]: (0, $bSKDV.hexToEditorBorderPaletteColor)(borderColor) || borderColor
    } : {};
    const aspectStyleVars = aspectRatio ? {
        [(0, $fhm10.INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY)]: aspectRatio
    } : {};
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...borderStyleVars,
            ...aspectStyleVars
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $fhm10.wrapperStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            borderSize && borderColor && (0, $fhm10.borderStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isSelected && (0, $fhm10.selectedStyle)
        ],
        "data-testid": "inline-image-wrapper",
        onClick: onClick,
        ...htmlAttrs
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $7cf4b05323c49fee$var$sizeWrapperStyle
    }, children)));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $5MACL = parcelRequire("5MACL");


var $3gadb = parcelRequire("3gadb");



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



function $6ea526080872ea45$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6ea526080872ea45$var$wrapperStyle = {
    name: "1xutr1y",
    styles: "display:flex;span > svg{vertical-align:top;}"
};
const $6ea526080872ea45$export$be58b4326e23250f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $6ea526080872ea45$var$wrapperStyle,
        "data-testid": "media-inline-image-card-icon"
    }, children);
};


const $d55d56648ffb705b$export$cbdc50f98f4f8d00 = ({ testId: testId = 'media-inline-image-card-error-view', message: message, icon: icon, height: height = (0, $6a98a0a47ebe23af$export$88e3664eef60c981) })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $365414ee34d9fe7e$export$b89a827e9254211a), {
        testId: testId
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: message,
        position: "top",
        tag: "span",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6ea526080872ea45$export$be58b4326e23250f), null, icon || /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5MACL))), {
        label: "error",
        LEGACY_size: height > (0, $6a98a0a47ebe23af$export$88e3664eef60c981) ? 'medium' : 'small',
        color: "var(--ds-icon-danger, #C9372C)"
    }))));
};



const $f34f4663ccb261f9$export$5d2cd1bea8591ba3 = ({ mediaClient: mediaClient, identifier: identifier, isSelected: isSelected, intl: intl, alt: alt, isLazy: isLazy, width: width, height: height, border: border, ssr: ssr, serializeDataAttrs: serializeDataAttrs, shouldOpenMediaViewer: shouldOpenMediaViewer, isViewOnly: isViewOnly })=>{
    const [fileState, setFileState] = (0, $42omo.useState)();
    const [subscribeError, setSubscribeError] = (0, $42omo.useState)();
    const [isFailedEventSent, setIsFailedEventSent] = (0, $42omo.useState)(false);
    const [isSucceededEventSent, setIsSucceededEventSent] = (0, $42omo.useState)(false);
    const [isMediaViewerVisible, setMediaViewerVisible] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = intl || (0, $1e2E5.createIntl)({
        locale: 'en'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireFailedOperationalEvent = (error = new (0, $ihjDz.MediaCardError)('missing-error-data'), failReason)=>{
        if (!isFailedEventSent && fileState) {
            setIsFailedEventSent(true);
            (0, $dehRH.fireFailedOperationalEvent)(fileState, error, failReason, createAnalyticsEvent);
        }
    };
    const fireSucceededOperationalEvent = ()=>{
        if (!isSucceededEventSent && fileState) {
            setIsSucceededEventSent(true);
            (0, $dehRH.fireSucceededOperationalEvent)(fileState, createAnalyticsEvent);
        }
    };
    (0, $42omo.useEffect)(()=>{
        if (mediaClient) {
            const subscription = mediaClient.file.getFileState(identifier.id, {
                collectionName: identifier.collectionName
            }).subscribe({
                next: (fileState)=>{
                    setFileState(fileState);
                    setSubscribeError(undefined);
                },
                error: (e)=>{
                    setSubscribeError(e);
                }
            });
            return ()=>{
                subscription.unsubscribe();
            };
        }
    }, [
        identifier,
        mediaClient
    ]);
    const content = (dimensions)=>{
        if (!mediaClient) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $59ac8d14dbcf9d7f$export$4b1a62d8f05056a7), null);
        if (!ssr) {
            if (subscribeError) {
                const isUploading = fileState?.status === 'uploading';
                const errorMessage = isUploading ? (0, $d94a223ed3433d0e$export$defe85febe8b728c).failedToUpload : (0, $d94a223ed3433d0e$export$defe85febe8b728c).unableToLoadContent;
                const errorReason = fileState?.status === 'uploading' ? 'upload' : 'metadata-fetch';
                fireFailedOperationalEvent(new (0, $ihjDz.MediaCardError)(errorReason, subscribeError));
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d55d56648ffb705b$export$cbdc50f98f4f8d00), {
                    message: formatMessage(errorMessage)
                });
            }
            if (!fileState || fileState?.status === 'uploading') return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $59ac8d14dbcf9d7f$export$4b1a62d8f05056a7), null);
            if (fileState.status === 'error') {
                fireFailedOperationalEvent(new (0, $ihjDz.MediaCardError)('error-file-state', new Error(fileState.message)));
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d55d56648ffb705b$export$cbdc50f98f4f8d00), {
                    message: formatMessage((0, $d94a223ed3433d0e$export$defe85febe8b728c).unableToLoadContent)
                });
            } else if (fileState.status === 'failed-processing') {
                fireFailedOperationalEvent(undefined, 'failed-processing');
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d55d56648ffb705b$export$cbdc50f98f4f8d00), {
                    message: formatMessage((0, $d94a223ed3433d0e$export$defe85febe8b728c).unableToLoadContent)
                });
            } else if (!fileState.name) {
                fireFailedOperationalEvent(new (0, $ihjDz.MediaCardError)('metadata-fetch', new (0, $fO7zn.FileFetcherError)('emptyFileName', {
                    id: fileState.id
                })));
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d55d56648ffb705b$export$cbdc50f98f4f8d00), {
                    message: formatMessage((0, $d94a223ed3433d0e$export$defe85febe8b728c).unableToLoadContent)
                });
            }
            if (fileState.status === 'processed') fireSucceededOperationalEvent();
        }
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3rvSa.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c12bc8babb02df83$export$bb1dd14451154199), {
            dimensions: dimensions,
            identifier: identifier,
            renderError: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $d55d56648ffb705b$export$cbdc50f98f4f8d00), {
                    message: formatMessage((0, $d94a223ed3433d0e$export$defe85febe8b728c).unableToLoadContent)
                }),
            alt: alt,
            ssr: ssr?.mode,
            isLazy: isLazy,
            crop: true,
            stretch: false
        }));
    };
    const aspectRatio = (0, $42omo.useMemo)(()=>width && height ? width / height : undefined, [
        width,
        height
    ]);
    /**
   * scaledDimensions is used to define the correct media size fetched from media service
   * inline images will only ever be rendered at a maximum height of H1 and so scaled dimensions
   * will only ever return a width and height where the height has a maximum height of H1
   */ const scaledDimension = (0, $42omo.useMemo)(()=>{
        if (!width || !height || !aspectRatio) return {
            width: width,
            height: height
        };
        return {
            width: Math.round(aspectRatio * (0, $5gVJx.referenceHeights)['h1']),
            height: (0, $5gVJx.referenceHeights)['h1']
        };
    }, [
        width,
        height,
        aspectRatio
    ]);
    const htmlAttributes = (0, $42omo.useMemo)(()=>{
        if (serializeDataAttrs) {
            const resolvedAttrs = fileState && fileState.status !== 'error' ? {
                'data-file-size': fileState.size,
                'data-file-mime-type': fileState.mimeType,
                'data-file-name': fileState.name
            } : {};
            return {
                'data-type': 'image',
                'data-node-type': 'mediaInline',
                'data-id': identifier.id,
                'data-collection': identifier.collectionName,
                'data-width': width,
                'data-height': height,
                'data-alt': alt,
                ...resolvedAttrs
            };
        }
        return {};
    }, [
        alt,
        fileState,
        height,
        identifier,
        width,
        serializeDataAttrs
    ]);
    const onMediaInlineImageClick = (0, $42omo.useCallback)((e)=>{
        if (shouldOpenMediaViewer) setMediaViewerVisible(true);
        // In edit mode (node content wrapper has contenteditable set to true), link redirection is disabled by default
        // We need to call "stopPropagation" here in order to prevent in editor view mode, the browser from navigating to
        // another URL if the media node is wrapped in a link mark.
        if (isViewOnly && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) e.preventDefault();
    }, [
        shouldOpenMediaViewer,
        isViewOnly
    ]);
    const onMediaInlinePreviewClose = (0, $42omo.useCallback)(()=>{
        setMediaViewerVisible(false);
    }, []);
    const mediaViewer = (0, $42omo.useMemo)(()=>{
        if (isMediaViewerVisible && mediaClient?.mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, $9K4OG.jsx)((0, $7NoXb.default), {
            collectionName: identifier.collectionName || '',
            items: [
                identifier
            ],
            mediaClientConfig: mediaClient?.mediaClientConfig,
            selectedItem: identifier,
            onClose: onMediaInlinePreviewClose
        }), document.body);
        return null;
    }, [
        identifier,
        isMediaViewerVisible,
        mediaClient?.mediaClientConfig,
        onMediaInlinePreviewClose
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7cf4b05323c49fee$export$8519fee8cc913056), {
        isSelected: isSelected,
        aspectRatio: aspectRatio,
        borderColor: border?.borderColor,
        borderSize: border?.borderSize,
        htmlAttrs: htmlAttributes,
        onClick: onMediaInlineImageClick
    }, content(scaledDimension)), mediaViewer);
};
const $f34f4663ccb261f9$export$fca833ae4278270f = (0, $gmMgo.default)($f34f4663ccb261f9$export$5d2cd1bea8591ba3, {
    enforceContext: false
});
module.exports["MediaInlineImageCard"] = $f34f4663ccb261f9$export$fca833ae4278270f;

});

parcelRegister("dehRH", function(module, exports) {

var $bhuzI = parcelRequire("bhuzI");


var $ihjDz = parcelRequire("ihjDz");

const $fc1f7121f2c54ee5$export$95e48cf5f4b392a4 = (fileState)=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'success',
            fileAttributes: {
                fileId: fileState?.id || '',
                fileSize: fileState?.size,
                fileMediatype: fileState?.mediaType,
                fileMimetype: fileState?.mimeType,
                fileStatus: fileState?.status
            }
        }
    };
};
const $fc1f7121f2c54ee5$export$b37f976ad373d2e0 = (fileId, error, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            ...(0, $bhuzI.extractErrorInfo)(error)
        }
    };
};
const $fc1f7121f2c54ee5$export$d0b5daf3b6a26055 = (fileId, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            failReason: 'failed-processing'
        }
    };
};
const $fc1f7121f2c54ee5$export$d66a74eca3334206 = (fileState, error = new (0, $ihjDz.MediaCardError)('missing-error-data'), failReason, createAnalyticsEvent)=>{
    const payload = failReason ? $fc1f7121f2c54ee5$export$d0b5daf3b6a26055(fileState?.id || 'unknown-id', fileState) : $fc1f7121f2c54ee5$export$b37f976ad373d2e0(fileState?.id || 'unknown-id', error, fileState);
    (0, $bhuzI.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $fc1f7121f2c54ee5$export$3bc90882cb04fda4 = (fileState, createAnalyticsEvent)=>{
    const payload = $fc1f7121f2c54ee5$export$95e48cf5f4b392a4(fileState);
    (0, $bhuzI.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
module.exports["getSucceededStatusPayload"] = $fc1f7121f2c54ee5$export$95e48cf5f4b392a4;
module.exports["getErrorStatusPayload"] = $fc1f7121f2c54ee5$export$b37f976ad373d2e0;
module.exports["getFailedProcessingStatusPayload"] = $fc1f7121f2c54ee5$export$d0b5daf3b6a26055;
module.exports["fireFailedOperationalEvent"] = $fc1f7121f2c54ee5$export$d66a74eca3334206;
module.exports["fireSucceededOperationalEvent"] = $fc1f7121f2c54ee5$export$3bc90882cb04fda4;

});

parcelRegister("i4o81", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kZmsK = parcelRequire("kZmsK");


var $bYRk6 = parcelRequire("bYRk6");




class $a406840fbc805bb1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    async componentDidMount() {
        this.mounted = true;
        if (!this.state.MediaInlineCard) try {
            const [mediaClient, cardModule, mediaInlineErrorBoundaryModule] = await Promise.all([
                (parcelRequire("kSwPg")),
                (parcelRequire("fOwVT")),
                (parcelRequire("1cFiH"))
            ]);
            $a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard = mediaClient.withMediaClient(cardModule.MediaInlineCard);
            $a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary = mediaInlineErrorBoundaryModule.default;
            if (this.mounted) this.setState({
                MediaInlineCard: $a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard,
                ErrorBoundary: $a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary
            });
        } catch (error) {}
    }
    async componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { MediaInlineCard: MediaInlineCard, ErrorBoundary: ErrorBoundary } = this.state;
        const analyticsContext = {
            packageVersion: "platform-pkg",
            packageName: "0.0.0-use.local",
            componentName: 'mediaInlineCard',
            component: 'mediaInlineCard'
        };
        if (!MediaInlineCard || !ErrorBoundary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZmsK.MediaInlineCardLoadingView), {
            message: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: analyticsContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ErrorBoundary, {
            isSelected: this.props.isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(MediaInlineCard, this.props)));
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            MediaInlineCard: $a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard,
            ErrorBoundary: $a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary
        };
    }
}
$a406840fbc805bb1$export$2e2bcd8739ae039.displayName = 'MediaInlineCardLoader';
$a406840fbc805bb1$export$2e2bcd8739ae039.MediaInlineCard = void 0;
$a406840fbc805bb1$export$2e2bcd8739ae039.ErrorBoundary = void 0;
module.exports["default"] = $a406840fbc805bb1$export$2e2bcd8739ae039;

});

parcelRegister("kZmsK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $Dmhrr = parcelRequire("Dmhrr");


var $9hlns = parcelRequire("9hlns");


var $d3MnB = parcelRequire("d3MnB");




/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");

const $8f39e15e200c8aa2$var$spinnerWrapperStyles = null;
const $8f39e15e200c8aa2$export$52b4dfd89a6b3a1b = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_o5721jtm _1nmz9jpi _s7n41q9y _18u0v77o"
        ])
    }, children);


const $d812b1a99afbef93$export$52b4dfd89a6b3a1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8f39e15e200c8aa2$export$52b4dfd89a6b3a1b), props);



var $9HuAe = parcelRequire("9HuAe");

class $1a4a0b48836516fc$export$4449fcbb2ad61ad1 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { message: message, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, innerRef: innerRef, testId: testId = 'media-inline-card-loading-view' } = this.props;
        if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Dmhrr.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.IconTitleWrapper), null, message, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.RightIconPositionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d812b1a99afbef93$export$52b4dfd89a6b3a1b), {
            className: "inline-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: 14
        })))));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Dmhrr.Frame), {
            innerRef: innerRef,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d3MnB.IconAndTitleLayout), {
            title: message
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d812b1a99afbef93$export$52b4dfd89a6b3a1b), {
            className: "inline-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: 14
        }))));
    }
}
module.exports["MediaInlineCardLoadingView"] = $1a4a0b48836516fc$export$4449fcbb2ad61ad1;

});

parcelRegister("Dmhrr", function(module, exports) {

var $42omo = parcelRequire("42omo");




/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");




const $c18bd19407527c2b$var$selectedStyles = null;
const $c18bd19407527c2b$var$notSelectedStyles = null;
const $c18bd19407527c2b$var$errorStyles = null;
const $c18bd19407527c2b$var$wrapperStyles = null; /*
                              Media Inline cards should have the following layout:
                              -----------------
                              | icon | title |
                              -----------------
                              The aim is to ensure (1) all children are
                              in line with each other, (2) are vertically
                              centered.
                            */ 
const $c18bd19407527c2b$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ isSelected: isSelected, isError: isError, children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: ref,
        "data-testid": "frame-wrapper",
        ...props,
        className: (0, $gMc0m.default)([
            "_2rkofajl _v56415x0 _vwz47vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _16d9qvcn _1e0c1nu9 _syazi7uo _bfhki8nm _1rkwglyw _80omtlke _irr3plhp",
            isSelected && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d1j28 _80omtlke _16qsr4us _uiztglyw _4bfu1r31 _1nrm1r31 _1a3b1r31 _9oik1r31 _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
            !isSelected && "_uizt1kdv",
            isError && "_bfhk1gly _80om73ad _irr31gly"
        ])
    }, children));


const $f4d2cc17db8a2086$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c18bd19407527c2b$export$e6dfd72ab29f8598), {
        ...props,
        ref: ref
    }));


class $81345eb3da367d71$export$b89a827e9254211a extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { isSelected: isSelected, children: children, onClick: onClick, innerRef: innerRef, testId: testId, isError: isError } = this.props;
        const isInteractive = Boolean(onClick);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4d2cc17db8a2086$export$e6dfd72ab29f8598), {
            ref: innerRef,
            isSelected: isSelected,
            isError: isError,
            tabIndex: isInteractive ? 0 : undefined,
            role: isInteractive ? 'button' : undefined,
            onClick: this.handleClick,
            onKeyPress: this.handleKeyPress,
            "data-testid": testId
        }, children);
    }
    constructor(...args){
        super(...args);
        this.handleClick = (event)=>{
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
        this.handleKeyPress = (event)=>{
            if (event.key !== ' ' && event.key !== 'Enter') return;
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
    }
}
module.exports["Frame"] = $81345eb3da367d71$export$b89a827e9254211a;

});

parcelRegister("d3MnB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cMypa = parcelRequire("cMypa");


var $3iiat = parcelRequire("3iiat");


var $9HuAe = parcelRequire("9HuAe");


var $8Q3VW = parcelRequire("8Q3VW");

class $cf4ec8e3d957b355$export$d34be4d513116847 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    renderAtlaskitIcon() {
        const { icon: icon, emoji: emoji } = this.props;
        if (emoji) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.EmojiWrapper), null, emoji);
        if (!icon || typeof icon === 'string') return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.IconWrapper), null, icon);
    }
    renderImageIcon(errored, testId) {
        const { icon: url } = this.props;
        if (!url || typeof url !== 'string') return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMypa))), {
            src: url,
            loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3iiat.Icon), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "smart-link-icon",
                src: url,
                "data-testid": `${testId}-image`
            }),
            errored: errored
        });
    }
    renderIconPlaceholder(testId) {
        const { defaultIcon: defaultIcon } = this.props;
        if (defaultIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.IconWrapper), null, defaultIcon);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Q3VW))), {
            color: "currentColor",
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`
        }));
    }
    renderIcon(testId) {
        // We render two kinds of icons here:
        // - Image: acquired from either DAC or Teamwork Platform Apps;
        // - Atlaskit Icon: an Atlaskit SVG;
        // Each of these are scaled down to 12x12.
        const icon = this.renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = this.renderIconPlaceholder(testId);
        const image = this.renderImageIcon(placeholder, testId);
        return image || placeholder;
    }
    render() {
        const { children: children, title: title, titleColor: titleColor, testId: testId = 'media-inline-card-icon-and-title' } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.IconTitleWrapper), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: titleColor ? {
                color: titleColor
            } : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.IconPositionWrapper), null, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9HuAe.IconEmptyWrapper), null), this.renderIcon(testId))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-test-id": "title"
        }, title)));
    }
}
module.exports["IconAndTitleLayout"] = $cf4ec8e3d957b355$export$d34be4d513116847;

});

parcelRegister("3iiat", function(module, exports) {

var $42omo = parcelRequire("42omo");

/* Icon-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Figure out a more scalable/responsive solution
// for vertical alignment.
// Current rationale: vertically positioned at the top of
// the smart card container (when set to 0). Offset this
// to position it with appropriate whitespace from the top.




var $gMc0m = parcelRequire("gMc0m");

const $5112814eaaf490cd$var$iconStyles = null;
const $5112814eaaf490cd$export$f04a61298a47a40f = ({ alt: alt, ...props })=>/*#__PURE__*/ $42omo.createElement("img", {
        alt: alt || 'icon',
        ...props,
        className: (0, $gMc0m.default)([
            "_2rkolb4i _4t3idlk8 _1bsbdlk8 _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    }); // Used for 'untrue' icons which claim to be 16x16 but
// are less than that in height/width.
// TODO: Replace this override with proper AtlasKit solution.
const $5112814eaaf490cd$var$akIconWrapperStyles = null;
const $5112814eaaf490cd$export$a201b065fc2e76a1 = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_2hwx1i6y"
        ])
    }, children);


const $85360ec6e10e0eb4$export$f04a61298a47a40f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5112814eaaf490cd$export$f04a61298a47a40f), props);
const $85360ec6e10e0eb4$export$a201b065fc2e76a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5112814eaaf490cd$export$a201b065fc2e76a1), props);
module.exports["Icon"] = $85360ec6e10e0eb4$export$f04a61298a47a40f;
module.exports["AKIconWrapper"] = $85360ec6e10e0eb4$export$a201b065fc2e76a1;

});

parcelRegister("kSwPg", function(module, exports) {

let $f33250547ef58c63$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f33250547ef58c63$var$load("h4k4y"),
    $f33250547ef58c63$var$load("15VrD"),
    $f33250547ef58c63$var$load("3t6fF"),
    $f33250547ef58c63$var$load("6aruy")
]).then(()=>parcelRequire('9VKkC'));

});

parcelRegister("fOwVT", function(module, exports) {

let $b835124b053ae367$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b835124b053ae367$var$load("7EorR"),
    $b835124b053ae367$var$load("2fk6g"),
    $b835124b053ae367$var$load("4jPsO"),
    $b835124b053ae367$var$load("hPalR"),
    $b835124b053ae367$var$load("hszIA"),
    $b835124b053ae367$var$load("8059b"),
    $b835124b053ae367$var$load("72780"),
    $b835124b053ae367$var$load("jDjSj"),
    $b835124b053ae367$var$load("4M7W5")
]).then(()=>parcelRequire('akEZB'));

});

parcelRegister("1cFiH", function(module, exports) {

let $0e06f2dbd2346d35$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e06f2dbd2346d35$var$load("iP5Bv").then(()=>parcelRequire('lysJr'));

});

parcelRegister("aL0VQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hZ6O7 = parcelRequire("hZ6O7");


var $jRNsq = parcelRequire("jRNsq");


var $i2CQL = parcelRequire("i2CQL");




function $8227eceacc56cecd$export$5cae361ad82dce8b(value) {
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}


const $4cae511015088d55$var$areFilesPotentiallyDuplicated = (file1, file2)=>file1.status === file2.status && file1.name === file2.name && file1.size === file2.size && file1.mimeType === file2.mimeType && file1.id !== file2.id;
function $4cae511015088d55$export$f91c9e51e5ab027d(ids) {
    const nonErrorFiles = (0, $i2CQL.useMediaStore)((state)=>Object.values(state.files).filter((0, $hZ6O7.isNonErrorFinalFileState)));
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const collections = (0, $42omo.useMemo)(()=>Object.fromEntries(ids.map(({ id: id, collectionName: collectionName })=>[
                id,
                collectionName
            ])), [
        ids
    ]);
    const files = (0, $42omo.useMemo)(()=>nonErrorFiles.filter((file)=>ids.some(({ id: id })=>file.id === id)), [
        nonErrorFiles,
        ids
    ]);
    const prevFiles = (0, $8227eceacc56cecd$export$5cae361ad82dce8b)(files);
    (0, $42omo.useEffect)(()=>{
        const prev = prevFiles ?? [];
        // Get the files that have been added or whose status has changed since last time.
        const addedOrChangedFiles = files.filter((file)=>file && prev.every((prevFile)=>prevFile.id !== file.id || prevFile.status !== file.status));
        // Get the files from the list that are duplicates of the added / changed files
        const potentialDuplicates = files.filter((file)=>addedOrChangedFiles.some((addedFile)=>$4cae511015088d55$var$areFilesPotentiallyDuplicated(file, addedFile)));
        if (potentialDuplicates.length) // if any duplicates are found then fetch their hashes along with the added files
        [
            ...addedOrChangedFiles,
            ...potentialDuplicates
        ].forEach((file)=>{
            const collectionName = collections[file.id];
            mediaClient.file.getFileState(file.id, {
                collectionName: collectionName,
                includeHashForDuplicateFiles: true,
                forceRefresh: true
            });
        });
    }, [
        files,
        prevFiles,
        mediaClient,
        collections
    ]);
    const hashMap = (0, $42omo.useMemo)(()=>Object.fromEntries(files.map((file)=>[
                file.id,
                file.hash
            ])), [
        files
    ]);
    return hashMap;
}
module.exports["useFileHashes"] = $4cae511015088d55$export$f91c9e51e5ab027d;

});

parcelRegister("c3GpY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c76ab2c8aaeca3d$export$2e2bcd8739ae039);

var $b5utg = parcelRequire("b5utg");


var $d1KG5 = parcelRequire("d1KG5");

function $8c76ab2c8aaeca3d$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var dateLeftStartOfWeek = (0, $d1KG5.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, $d1KG5.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

});

parcelRegister("1BJPA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $42f20bb3d6e61667$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E sekunda",
            past: "p\u0159ed m\xe9n\u011B ne\u017E sekundou",
            future: "za m\xe9n\u011B ne\u017E sekundu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "p\u0159ed sekundou",
            future: 'za sekundu'
        },
        few: {
            regular: '{{count}} sekundy',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekundy'
        },
        many: {
            regular: '{{count}} sekund',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekund'
        }
    },
    halfAMinute: {
        type: 'other',
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E minutou",
            future: "za m\xe9n\u011B ne\u017E minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "p\u0159ed minutou",
            future: 'za minutu'
        },
        few: {
            regular: '{{count}} minuty',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minuty'
        },
        many: {
            regular: '{{count}} minut',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minut'
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed hodinou",
            future: "p\u0159ibli\u017En\u011B za hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: 'hodina',
            past: "p\u0159ed hodinou",
            future: 'za hodinu'
        },
        few: {
            regular: '{{count}} hodiny',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodiny'
        },
        many: {
            regular: '{{count}} hodin',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodin'
        }
    },
    xDays: {
        one: {
            regular: 'den',
            past: "p\u0159ed dnem",
            future: 'za den'
        },
        few: {
            regular: '{{count}} dny',
            past: "p\u0159ed {{count}} dny",
            future: 'za {{count}} dny'
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "t\xfdden",
            past: "p\u0159ed t\xfddnem",
            future: "za t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "m\u011Bs\xedc",
            past: "p\u0159ed m\u011Bs\xedcem",
            future: "za m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed rokem",
            future: "p\u0159ibli\u017En\u011B za rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: 'rok',
            past: "p\u0159ed rokem",
            future: 'za rok'
        },
        few: {
            regular: '{{count}} roky',
            past: "p\u0159ed {{count}} roky",
            future: 'za {{count}} roky'
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E rok",
            past: "p\u0159ed v\xedce ne\u017E rokem",
            future: "za v\xedce ne\u017E rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: 'skoro rok',
            past: "skoro p\u0159ed rokem",
            future: 'skoro za rok'
        },
        few: {
            regular: 'skoro {{count}} roky',
            past: "skoro p\u0159ed {{count}} roky",
            future: 'skoro za {{count}} roky'
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
var $42f20bb3d6e61667$var$formatDistance = function formatDistance(token, count, options) {
    var pluralResult;
    var tokenValue = $42f20bb3d6e61667$var$formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === 'other') pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    var suffixExist = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var comparison = options === null || options === void 0 ? void 0 : options.comparison;
    var timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace('{{count}}', String(count));
};
var $42f20bb3d6e61667$export$2e2bcd8739ae039 = $42f20bb3d6e61667$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $613e2419dbf87c84$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy',
    long: 'd. MMMM yyyy',
    medium: 'd. M. yyyy',
    short: 'dd.MM.yyyy'
};
var $613e2419dbf87c84$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $613e2419dbf87c84$var$dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $613e2419dbf87c84$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $613e2419dbf87c84$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $613e2419dbf87c84$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $613e2419dbf87c84$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $613e2419dbf87c84$export$2e2bcd8739ae039 = $613e2419dbf87c84$var$formatLong;


var $1d7788c393c96de4$var$accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    'sobotu'
];
var $1d7788c393c96de4$var$formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        return "'v " + $1d7788c393c96de4$var$accusativeWeekdays[day] + " o' p";
    },
    other: 'P'
};
var $1d7788c393c96de4$var$formatRelative = function formatRelative(token, date) {
    var format = $1d7788c393c96de4$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $1d7788c393c96de4$export$2e2bcd8739ae039 = $1d7788c393c96de4$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $66c54c00332c4fc6$var$eraValues = {
    narrow: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    abbreviated: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
var $66c54c00332c4fc6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
var $66c54c00332c4fc6$var$monthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'leden',
        "\xfanor",
        "b\u0159ezen",
        'duben',
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        'srpen',
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        'listopad',
        'prosinec'
    ]
};
var $66c54c00332c4fc6$var$formattingMonthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'ledna',
        "\xfanora",
        "b\u0159ezna",
        'dubna',
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        'srpna',
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        'listopadu',
        'prosince'
    ]
};
var $66c54c00332c4fc6$var$dayValues = {
    narrow: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    short: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    abbreviated: [
        'ned',
        'pon',
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        'sob'
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        'sobota'
    ]
};
var $66c54c00332c4fc6$var$dayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $66c54c00332c4fc6$var$formattingDayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $66c54c00332c4fc6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $66c54c00332c4fc6$var$localize = {
    ordinalNumber: $66c54c00332c4fc6$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $66c54c00332c4fc6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $66c54c00332c4fc6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $66c54c00332c4fc6$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $66c54c00332c4fc6$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $66c54c00332c4fc6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $66c54c00332c4fc6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $66c54c00332c4fc6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $66c54c00332c4fc6$export$2e2bcd8739ae039 = $66c54c00332c4fc6$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $1e27dce96bd0b901$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $1e27dce96bd0b901$var$parseOrdinalNumberPattern = /\d+/i;
var $1e27dce96bd0b901$var$matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var $1e27dce96bd0b901$var$parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
var $1e27dce96bd0b901$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
var $1e27dce96bd0b901$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1e27dce96bd0b901$var$matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var $1e27dce96bd0b901$var$parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
var $1e27dce96bd0b901$var$matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var $1e27dce96bd0b901$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
var $1e27dce96bd0b901$var$matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
var $1e27dce96bd0b901$var$parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
var $1e27dce96bd0b901$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $1e27dce96bd0b901$var$matchOrdinalNumberPattern,
        parsePattern: $1e27dce96bd0b901$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $1e27dce96bd0b901$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1e27dce96bd0b901$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $1e27dce96bd0b901$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1e27dce96bd0b901$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $1e27dce96bd0b901$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1e27dce96bd0b901$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $1e27dce96bd0b901$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1e27dce96bd0b901$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $1e27dce96bd0b901$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $1e27dce96bd0b901$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $1e27dce96bd0b901$export$2e2bcd8739ae039 = $1e27dce96bd0b901$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
 */ var $12bccc3f66c13888$var$locale = {
    code: 'cs',
    formatDistance: (0, $42f20bb3d6e61667$export$2e2bcd8739ae039),
    formatLong: (0, $613e2419dbf87c84$export$2e2bcd8739ae039),
    formatRelative: (0, $1d7788c393c96de4$export$2e2bcd8739ae039),
    localize: (0, $66c54c00332c4fc6$export$2e2bcd8739ae039),
    match: (0, $1e27dce96bd0b901$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $12bccc3f66c13888$export$2e2bcd8739ae039 = $12bccc3f66c13888$var$locale;
module.exports["default"] = $12bccc3f66c13888$export$2e2bcd8739ae039;

});

parcelRegister("dHsuJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $6a86540ee16e3aa8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: 'mindre end {{count}} sekunder'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: 'mindre end {{count}} minutter'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'cirka 1 time',
        other: 'cirka {{count}} timer'
    },
    xHours: {
        one: '1 time',
        other: '{{count}} timer'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dage'
    },
    aboutXWeeks: {
        one: 'cirka 1 uge',
        other: 'cirka {{count}} uger'
    },
    xWeeks: {
        one: '1 uge',
        other: '{{count}} uger'
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
var $6a86540ee16e3aa8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $6a86540ee16e3aa8$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
var $6a86540ee16e3aa8$export$2e2bcd8739ae039 = $6a86540ee16e3aa8$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $b93d0f47b95dc963$var$dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd/MM/y'
};
var $b93d0f47b95dc963$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $b93d0f47b95dc963$var$dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $b93d0f47b95dc963$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $b93d0f47b95dc963$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $b93d0f47b95dc963$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $b93d0f47b95dc963$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b93d0f47b95dc963$export$2e2bcd8739ae039 = $b93d0f47b95dc963$var$formatLong;


var $7fe4575ec698c608$var$formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: 'P'
};
var $7fe4575ec698c608$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $7fe4575ec698c608$var$formatRelativeLocale[token];
};
var $7fe4575ec698c608$export$2e2bcd8739ae039 = $7fe4575ec698c608$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $09492a9109024a06$var$eraValues = {
    narrow: [
        'fvt',
        'vt'
    ],
    abbreviated: [
        'f.v.t.',
        'v.t.'
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        'vesterlandsk tidsregning'
    ]
};
var $09492a9109024a06$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. kvt.',
        '2. kvt.',
        '3. kvt.',
        '4. kvt.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $09492a9109024a06$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marts',
        'april',
        'maj',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
var $09492a9109024a06$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        'man.',
        'tir.',
        'ons.',
        'tor.',
        'fre.',
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $09492a9109024a06$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    }
};
var $09492a9109024a06$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    }
};
var $09492a9109024a06$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $09492a9109024a06$var$localize = {
    ordinalNumber: $09492a9109024a06$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $09492a9109024a06$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $09492a9109024a06$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $09492a9109024a06$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $09492a9109024a06$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $09492a9109024a06$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $09492a9109024a06$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $09492a9109024a06$export$2e2bcd8739ae039 = $09492a9109024a06$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $3f61a56bbc00dd7c$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $3f61a56bbc00dd7c$var$parseOrdinalNumberPattern = /\d+/i;
var $3f61a56bbc00dd7c$var$matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var $3f61a56bbc00dd7c$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
var $3f61a56bbc00dd7c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
var $3f61a56bbc00dd7c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3f61a56bbc00dd7c$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var $3f61a56bbc00dd7c$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $3f61a56bbc00dd7c$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $3f61a56bbc00dd7c$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $3f61a56bbc00dd7c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var $3f61a56bbc00dd7c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
var $3f61a56bbc00dd7c$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $3f61a56bbc00dd7c$var$matchOrdinalNumberPattern,
        parsePattern: $3f61a56bbc00dd7c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $3f61a56bbc00dd7c$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3f61a56bbc00dd7c$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $3f61a56bbc00dd7c$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3f61a56bbc00dd7c$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $3f61a56bbc00dd7c$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3f61a56bbc00dd7c$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $3f61a56bbc00dd7c$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3f61a56bbc00dd7c$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $3f61a56bbc00dd7c$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3f61a56bbc00dd7c$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $3f61a56bbc00dd7c$export$2e2bcd8739ae039 = $3f61a56bbc00dd7c$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
 */ var $9f9564fb6b3e49d8$var$locale = {
    code: 'da',
    formatDistance: (0, $6a86540ee16e3aa8$export$2e2bcd8739ae039),
    formatLong: (0, $b93d0f47b95dc963$export$2e2bcd8739ae039),
    formatRelative: (0, $7fe4575ec698c608$export$2e2bcd8739ae039),
    localize: (0, $09492a9109024a06$export$2e2bcd8739ae039),
    match: (0, $3f61a56bbc00dd7c$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9f9564fb6b3e49d8$export$2e2bcd8739ae039 = $9f9564fb6b3e49d8$var$locale;
module.exports["default"] = $9f9564fb6b3e49d8$export$2e2bcd8739ae039;

});

parcelRegister("5cYlT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $habgs = parcelRequire("habgs");


var $3xVG3 = parcelRequire("3xVG3");


var $95e3R = parcelRequire("95e3R");


var $lo4TZ = parcelRequire("lo4TZ");

var $eb3b7abab01f8187$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var $eb3b7abab01f8187$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $eb3b7abab01f8187$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var $eb3b7abab01f8187$var$formattingMonthValues = {
    narrow: $eb3b7abab01f8187$var$monthValues.narrow,
    abbreviated: [
        'Jan.',
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: $eb3b7abab01f8187$var$monthValues.wide
};
var $eb3b7abab01f8187$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $eb3b7abab01f8187$var$dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var $eb3b7abab01f8187$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var $eb3b7abab01f8187$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $eb3b7abab01f8187$var$localize = {
    ordinalNumber: $eb3b7abab01f8187$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $eb3b7abab01f8187$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $eb3b7abab01f8187$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $eb3b7abab01f8187$var$monthValues,
        formattingValues: $eb3b7abab01f8187$var$formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $eb3b7abab01f8187$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $eb3b7abab01f8187$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $eb3b7abab01f8187$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $eb3b7abab01f8187$export$2e2bcd8739ae039 = $eb3b7abab01f8187$var$localize;



var $1BsG4 = parcelRequire("1BsG4");

/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var $3cace3661010d055$var$locale = {
    code: 'de',
    formatDistance: (0, $habgs.default),
    formatLong: (0, $3xVG3.default),
    formatRelative: (0, $95e3R.default),
    localize: (0, $eb3b7abab01f8187$export$2e2bcd8739ae039),
    match: (0, $1BsG4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $3cace3661010d055$export$2e2bcd8739ae039 = $3cace3661010d055$var$locale;
module.exports["default"] = $3cace3661010d055$export$2e2bcd8739ae039;

});

parcelRegister("habgs", function(module, exports) {
var $c7ec1bbb44296361$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        },
        withPreposition: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        }
    },
    xSeconds: {
        standalone: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        },
        withPreposition: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        }
    },
    halfAMinute: {
        standalone: 'halbe Minute',
        withPreposition: 'halben Minute'
    },
    lessThanXMinutes: {
        standalone: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        },
        withPreposition: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        }
    },
    xMinutes: {
        standalone: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        },
        withPreposition: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        }
    },
    aboutXHours: {
        standalone: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        },
        withPreposition: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        }
    },
    xHours: {
        standalone: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        },
        withPreposition: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        }
    },
    xDays: {
        standalone: {
            one: '1 Tag',
            other: '{{count}} Tage'
        },
        withPreposition: {
            one: '1 Tag',
            other: '{{count}} Tagen'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        },
        withPreposition: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        }
    },
    xWeeks: {
        standalone: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monate'
        },
        withPreposition: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monaten'
        }
    },
    xMonths: {
        standalone: {
            one: '1 Monat',
            other: '{{count}} Monate'
        },
        withPreposition: {
            one: '1 Monat',
            other: '{{count}} Monaten'
        }
    },
    aboutXYears: {
        standalone: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahre'
        },
        withPreposition: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahren'
        }
    },
    xYears: {
        standalone: {
            one: '1 Jahr',
            other: '{{count}} Jahre'
        },
        withPreposition: {
            one: '1 Jahr',
            other: '{{count}} Jahren'
        }
    },
    overXYears: {
        standalone: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahre'
        },
        withPreposition: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahren'
        }
    },
    almostXYears: {
        standalone: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahre'
        },
        withPreposition: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahren'
        }
    }
};
var $c7ec1bbb44296361$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $c7ec1bbb44296361$var$formatDistanceLocale[token].withPreposition : $c7ec1bbb44296361$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return 'vor ' + result;
    }
    return result;
};
var $c7ec1bbb44296361$export$2e2bcd8739ae039 = $c7ec1bbb44296361$var$formatDistance;
module.exports["default"] = $c7ec1bbb44296361$export$2e2bcd8739ae039;

});

parcelRegister("3xVG3", function(module, exports) {

var $ke66V = parcelRequire("ke66V");

// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var $295131adc62dfdc0$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    // Montag, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan. 2018
    short: 'dd.MM.y' // 07.01.2018
};
var $295131adc62dfdc0$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $295131adc62dfdc0$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $295131adc62dfdc0$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $295131adc62dfdc0$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $295131adc62dfdc0$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $295131adc62dfdc0$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $295131adc62dfdc0$export$2e2bcd8739ae039 = $295131adc62dfdc0$var$formatLong;
module.exports["default"] = $295131adc62dfdc0$export$2e2bcd8739ae039;

});

parcelRegister("95e3R", function(module, exports) {
var $69cf7cf32f63114d$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var $69cf7cf32f63114d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $69cf7cf32f63114d$var$formatRelativeLocale[token];
};
var $69cf7cf32f63114d$export$2e2bcd8739ae039 = $69cf7cf32f63114d$var$formatRelative;
module.exports["default"] = $69cf7cf32f63114d$export$2e2bcd8739ae039;

});

parcelRegister("1BsG4", function(module, exports) {

var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $12af7deeeecf4463$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $12af7deeeecf4463$var$parseOrdinalNumberPattern = /\d+/i;
var $12af7deeeecf4463$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var $12af7deeeecf4463$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $12af7deeeecf4463$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $12af7deeeecf4463$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $12af7deeeecf4463$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var $12af7deeeecf4463$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $12af7deeeecf4463$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var $12af7deeeecf4463$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $12af7deeeecf4463$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var $12af7deeeecf4463$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var $12af7deeeecf4463$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $12af7deeeecf4463$var$matchOrdinalNumberPattern,
        parsePattern: $12af7deeeecf4463$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $12af7deeeecf4463$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $12af7deeeecf4463$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $12af7deeeecf4463$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $12af7deeeecf4463$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $12af7deeeecf4463$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $12af7deeeecf4463$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $12af7deeeecf4463$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $12af7deeeecf4463$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $12af7deeeecf4463$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $12af7deeeecf4463$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $12af7deeeecf4463$export$2e2bcd8739ae039 = $12af7deeeecf4463$var$match;
module.exports["default"] = $12af7deeeecf4463$export$2e2bcd8739ae039;

});

parcelRegister("e6KrE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $hnQFw = parcelRequire("hnQFw");


var $jdGf6 = parcelRequire("jdGf6");


var $7Aaku = parcelRequire("7Aaku");


var $afCHX = parcelRequire("afCHX");


var $jCY1h = parcelRequire("jCY1h");

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var $a455a735ccebb0d4$var$locale = {
    code: 'en-GB',
    formatDistance: (0, $hnQFw.default),
    formatLong: (0, $jCY1h.default),
    formatRelative: (0, $jdGf6.default),
    localize: (0, $7Aaku.default),
    match: (0, $afCHX.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $a455a735ccebb0d4$export$2e2bcd8739ae039 = $a455a735ccebb0d4$var$locale;
module.exports["default"] = $a455a735ccebb0d4$export$2e2bcd8739ae039;

});

parcelRegister("jCY1h", function(module, exports) {

var $ke66V = parcelRequire("ke66V");

var $e4a01f8e839db647$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $e4a01f8e839db647$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $e4a01f8e839db647$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e4a01f8e839db647$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $e4a01f8e839db647$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $e4a01f8e839db647$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $e4a01f8e839db647$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e4a01f8e839db647$export$2e2bcd8739ae039 = $e4a01f8e839db647$var$formatLong;
module.exports["default"] = $e4a01f8e839db647$export$2e2bcd8739ae039;

});

parcelRegister("2rFSr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $0633a0e9c4600cf3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de un segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos de un minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'alrededor de 1 hora',
        other: 'alrededor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'alrededor de 1 semana',
        other: 'alrededor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'alrededor de 1 mes',
        other: 'alrededor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
var $0633a0e9c4600cf3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $0633a0e9c4600cf3$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hace ' + result;
    }
    return result;
};
var $0633a0e9c4600cf3$export$2e2bcd8739ae039 = $0633a0e9c4600cf3$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $80cb326caef88268$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $80cb326caef88268$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $80cb326caef88268$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $80cb326caef88268$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $80cb326caef88268$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $80cb326caef88268$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $80cb326caef88268$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $80cb326caef88268$export$2e2bcd8739ae039 = $80cb326caef88268$var$formatLong;


var $c7c21761b230b900$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var $c7c21761b230b900$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: 'P'
};
var $c7c21761b230b900$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $c7c21761b230b900$var$formatRelativeLocalePlural[token];
    else return $c7c21761b230b900$var$formatRelativeLocale[token];
};
var $c7c21761b230b900$export$2e2bcd8739ae039 = $c7c21761b230b900$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $4eeee602c369a671$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        "despu\xe9s de cristo"
    ]
};
var $4eeee602c369a671$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $4eeee602c369a671$var$monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic'
    ],
    wide: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
    ]
};
var $4eeee602c369a671$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'mi',
        'ju',
        'vi',
        "s\xe1"
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        "mi\xe9",
        'jue',
        'vie',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'lunes',
        'martes',
        "mi\xe9rcoles",
        'jueves',
        'viernes',
        "s\xe1bado"
    ]
};
var $4eeee602c369a671$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    }
};
var $4eeee602c369a671$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    }
};
var $4eeee602c369a671$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $4eeee602c369a671$var$localize = {
    ordinalNumber: $4eeee602c369a671$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $4eeee602c369a671$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $4eeee602c369a671$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $4eeee602c369a671$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $4eeee602c369a671$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $4eeee602c369a671$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $4eeee602c369a671$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $4eeee602c369a671$export$2e2bcd8739ae039 = $4eeee602c369a671$var$localize;



var $aqoqo = parcelRequire("aqoqo");


var $jLTD6 = parcelRequire("jLTD6");

var $627fc3056e5debd0$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $627fc3056e5debd0$var$parseOrdinalNumberPattern = /\d+/i;
var $627fc3056e5debd0$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var $627fc3056e5debd0$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var $627fc3056e5debd0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $627fc3056e5debd0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $627fc3056e5debd0$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var $627fc3056e5debd0$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var $627fc3056e5debd0$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var $627fc3056e5debd0$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var $627fc3056e5debd0$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var $627fc3056e5debd0$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var $627fc3056e5debd0$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $627fc3056e5debd0$var$matchOrdinalNumberPattern,
        parsePattern: $627fc3056e5debd0$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $627fc3056e5debd0$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $627fc3056e5debd0$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $627fc3056e5debd0$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $627fc3056e5debd0$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $627fc3056e5debd0$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $627fc3056e5debd0$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $627fc3056e5debd0$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $627fc3056e5debd0$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $627fc3056e5debd0$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $627fc3056e5debd0$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $627fc3056e5debd0$export$2e2bcd8739ae039 = $627fc3056e5debd0$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var $1c7e9648998a0fe6$var$locale = {
    code: 'es',
    formatDistance: (0, $0633a0e9c4600cf3$export$2e2bcd8739ae039),
    formatLong: (0, $80cb326caef88268$export$2e2bcd8739ae039),
    formatRelative: (0, $c7c21761b230b900$export$2e2bcd8739ae039),
    localize: (0, $4eeee602c369a671$export$2e2bcd8739ae039),
    match: (0, $627fc3056e5debd0$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $1c7e9648998a0fe6$export$2e2bcd8739ae039 = $1c7e9648998a0fe6$var$locale;
module.exports["default"] = $1c7e9648998a0fe6$export$2e2bcd8739ae039;

});

parcelRegister("5NDCB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
function $9967885a263ee544$var$futureSeconds(text) {
    return text.replace(/sekuntia?/, 'sekunnin');
}
function $9967885a263ee544$var$futureMinutes(text) {
    return text.replace(/minuuttia?/, 'minuutin');
}
function $9967885a263ee544$var$futureHours(text) {
    return text.replace(/tuntia?/, 'tunnin');
}
function $9967885a263ee544$var$futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function $9967885a263ee544$var$futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, 'viikon');
}
function $9967885a263ee544$var$futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
}
function $9967885a263ee544$var$futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, 'vuoden');
}
var $9967885a263ee544$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'alle sekunti',
        other: 'alle {{count}} sekuntia',
        futureTense: $9967885a263ee544$var$futureSeconds
    },
    xSeconds: {
        one: 'sekunti',
        other: '{{count}} sekuntia',
        futureTense: $9967885a263ee544$var$futureSeconds
    },
    halfAMinute: {
        one: 'puoli minuuttia',
        other: 'puoli minuuttia',
        futureTense: function futureTense(_text) {
            return 'puolen minuutin';
        }
    },
    lessThanXMinutes: {
        one: 'alle minuutti',
        other: 'alle {{count}} minuuttia',
        futureTense: $9967885a263ee544$var$futureMinutes
    },
    xMinutes: {
        one: 'minuutti',
        other: '{{count}} minuuttia',
        futureTense: $9967885a263ee544$var$futureMinutes
    },
    aboutXHours: {
        one: 'noin tunti',
        other: 'noin {{count}} tuntia',
        futureTense: $9967885a263ee544$var$futureHours
    },
    xHours: {
        one: 'tunti',
        other: '{{count}} tuntia',
        futureTense: $9967885a263ee544$var$futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: $9967885a263ee544$var$futureDays
    },
    aboutXWeeks: {
        one: 'noin viikko',
        other: 'noin {{count}} viikkoa',
        futureTense: $9967885a263ee544$var$futureWeeks
    },
    xWeeks: {
        one: 'viikko',
        other: '{{count}} viikkoa',
        futureTense: $9967885a263ee544$var$futureWeeks
    },
    aboutXMonths: {
        one: 'noin kuukausi',
        other: 'noin {{count}} kuukautta',
        futureTense: $9967885a263ee544$var$futureMonths
    },
    xMonths: {
        one: 'kuukausi',
        other: '{{count}} kuukautta',
        futureTense: $9967885a263ee544$var$futureMonths
    },
    aboutXYears: {
        one: 'noin vuosi',
        other: 'noin {{count}} vuotta',
        futureTense: $9967885a263ee544$var$futureYears
    },
    xYears: {
        one: 'vuosi',
        other: '{{count}} vuotta',
        futureTense: $9967885a263ee544$var$futureYears
    },
    overXYears: {
        one: 'yli vuosi',
        other: 'yli {{count}} vuotta',
        futureTense: $9967885a263ee544$var$futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: $9967885a263ee544$var$futureYears
    }
};
var $9967885a263ee544$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $9967885a263ee544$var$formatDistanceLocale[token];
    var result = count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + ' kuluttua';
        else return result + ' sitten';
    }
    return result;
};
var $9967885a263ee544$export$2e2bcd8739ae039 = $9967885a263ee544$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $41c237f26d7b3a45$var$dateFormats = {
    full: 'eeee d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'd.M.y'
};
var $41c237f26d7b3a45$var$timeFormats = {
    full: 'HH.mm.ss zzzz',
    long: 'HH.mm.ss z',
    medium: 'HH.mm.ss',
    short: 'HH.mm'
};
var $41c237f26d7b3a45$var$dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $41c237f26d7b3a45$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $41c237f26d7b3a45$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $41c237f26d7b3a45$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $41c237f26d7b3a45$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $41c237f26d7b3a45$export$2e2bcd8739ae039 = $41c237f26d7b3a45$var$formatLong;


var $a807b6c15dd09ea0$var$formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: 'P'
};
var $a807b6c15dd09ea0$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a807b6c15dd09ea0$var$formatRelativeLocale[token];
};
var $a807b6c15dd09ea0$export$2e2bcd8739ae039 = $a807b6c15dd09ea0$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $8e9330e936f0c35d$var$eraValues = {
    narrow: [
        'eaa.',
        'jaa.'
    ],
    abbreviated: [
        'eaa.',
        'jaa.'
    ],
    wide: [
        'ennen ajanlaskun alkua',
        "j\xe4lkeen ajanlaskun alun"
    ]
};
var $8e9330e936f0c35d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartaali',
        '2. kvartaali',
        '3. kvartaali',
        '4. kvartaali'
    ]
};
var $8e9330e936f0c35d$var$monthValues = {
    narrow: [
        'T',
        'H',
        'M',
        'H',
        'T',
        'K',
        'H',
        'E',
        'S',
        'L',
        'M',
        'J'
    ],
    abbreviated: [
        'tammi',
        'helmi',
        'maalis',
        'huhti',
        'touko',
        "kes\xe4",
        "hein\xe4",
        'elo',
        'syys',
        'loka',
        'marras',
        'joulu'
    ],
    wide: [
        'tammikuu',
        'helmikuu',
        'maaliskuu',
        'huhtikuu',
        'toukokuu',
        "kes\xe4kuu",
        "hein\xe4kuu",
        'elokuu',
        'syyskuu',
        'lokakuu',
        'marraskuu',
        'joulukuu'
    ]
};
var $8e9330e936f0c35d$var$formattingMonthValues = {
    narrow: $8e9330e936f0c35d$var$monthValues.narrow,
    abbreviated: $8e9330e936f0c35d$var$monthValues.abbreviated,
    wide: [
        'tammikuuta',
        'helmikuuta',
        'maaliskuuta',
        'huhtikuuta',
        'toukokuuta',
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        'elokuuta',
        'syyskuuta',
        'lokakuuta',
        'marraskuuta',
        'joulukuuta'
    ]
};
var $8e9330e936f0c35d$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'K',
        'T',
        'P',
        'L'
    ],
    short: [
        'su',
        'ma',
        'ti',
        'ke',
        'to',
        'pe',
        'la'
    ],
    abbreviated: [
        'sunn.',
        'maan.',
        'tiis.',
        'kesk.',
        'torst.',
        'perj.',
        'la'
    ],
    wide: [
        'sunnuntai',
        'maanantai',
        'tiistai',
        'keskiviikko',
        'torstai',
        'perjantai',
        'lauantai'
    ]
};
var $8e9330e936f0c35d$var$formattingDayValues = {
    narrow: $8e9330e936f0c35d$var$dayValues.narrow,
    short: $8e9330e936f0c35d$var$dayValues.short,
    abbreviated: $8e9330e936f0c35d$var$dayValues.abbreviated,
    wide: [
        'sunnuntaina',
        'maanantaina',
        'tiistaina',
        'keskiviikkona',
        'torstaina',
        'perjantaina',
        'lauantaina'
    ]
};
var $8e9330e936f0c35d$var$dayPeriodValues = {
    narrow: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    }
};
var $8e9330e936f0c35d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $8e9330e936f0c35d$var$localize = {
    ordinalNumber: $8e9330e936f0c35d$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $8e9330e936f0c35d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $8e9330e936f0c35d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $8e9330e936f0c35d$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $8e9330e936f0c35d$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $8e9330e936f0c35d$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $8e9330e936f0c35d$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $8e9330e936f0c35d$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $8e9330e936f0c35d$export$2e2bcd8739ae039 = $8e9330e936f0c35d$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $30c2d2438551c40b$var$matchOrdinalNumberPattern = /^(\d+)(\.)/i;
var $30c2d2438551c40b$var$parseOrdinalNumberPattern = /\d+/i;
var $30c2d2438551c40b$var$matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var $30c2d2438551c40b$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
var $30c2d2438551c40b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
var $30c2d2438551c40b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $30c2d2438551c40b$var$matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var $30c2d2438551c40b$var$parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
var $30c2d2438551c40b$var$matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var $30c2d2438551c40b$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
var $30c2d2438551c40b$var$matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var $30c2d2438551c40b$var$parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
var $30c2d2438551c40b$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $30c2d2438551c40b$var$matchOrdinalNumberPattern,
        parsePattern: $30c2d2438551c40b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $30c2d2438551c40b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $30c2d2438551c40b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $30c2d2438551c40b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $30c2d2438551c40b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $30c2d2438551c40b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $30c2d2438551c40b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $30c2d2438551c40b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $30c2d2438551c40b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $30c2d2438551c40b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $30c2d2438551c40b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $30c2d2438551c40b$export$2e2bcd8739ae039 = $30c2d2438551c40b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */ var $4390435b9a12a534$var$locale = {
    code: 'fi',
    formatDistance: (0, $9967885a263ee544$export$2e2bcd8739ae039),
    formatLong: (0, $41c237f26d7b3a45$export$2e2bcd8739ae039),
    formatRelative: (0, $a807b6c15dd09ea0$export$2e2bcd8739ae039),
    localize: (0, $8e9330e936f0c35d$export$2e2bcd8739ae039),
    match: (0, $30c2d2438551c40b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $4390435b9a12a534$export$2e2bcd8739ae039 = $4390435b9a12a534$var$locale;
module.exports["default"] = $4390435b9a12a534$export$2e2bcd8739ae039;

});

parcelRegister("dPWO1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $fnPCM = parcelRequire("fnPCM");


var $ke66V = parcelRequire("ke66V");

var $143fc09b5e0421bd$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $143fc09b5e0421bd$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $143fc09b5e0421bd$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $143fc09b5e0421bd$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $143fc09b5e0421bd$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $143fc09b5e0421bd$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $143fc09b5e0421bd$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $143fc09b5e0421bd$export$2e2bcd8739ae039 = $143fc09b5e0421bd$var$formatLong;



var $01rSh = parcelRequire("01rSh");


var $bgELe = parcelRequire("bgELe");


var $5uKey = parcelRequire("5uKey");

/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var $a12da75f2fe04cf5$var$locale = {
    code: 'fr',
    formatDistance: (0, $fnPCM.default),
    formatLong: (0, $143fc09b5e0421bd$export$2e2bcd8739ae039),
    formatRelative: (0, $01rSh.default),
    localize: (0, $bgELe.default),
    match: (0, $5uKey.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $a12da75f2fe04cf5$export$2e2bcd8739ae039 = $a12da75f2fe04cf5$var$locale;
module.exports["default"] = $a12da75f2fe04cf5$export$2e2bcd8739ae039;

});

parcelRegister("fnPCM", function(module, exports) {
var $b3310c8ebf286119$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: 'moins de {{count}} secondes'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} secondes'
    },
    halfAMinute: '30 secondes',
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: 'moins de {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'environ 1 heure',
        other: 'environ {{count}} heures'
    },
    xHours: {
        one: '1 heure',
        other: '{{count}} heures'
    },
    xDays: {
        one: '1 jour',
        other: '{{count}} jours'
    },
    aboutXWeeks: {
        one: 'environ 1 semaine',
        other: 'environ {{count}} semaines'
    },
    xWeeks: {
        one: '1 semaine',
        other: '{{count}} semaines'
    },
    aboutXMonths: {
        one: 'environ 1 mois',
        other: 'environ {{count}} mois'
    },
    xMonths: {
        one: '1 mois',
        other: '{{count}} mois'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: 'plus de {{count}} ans'
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: 'presque {{count}} ans'
    }
};
var $b3310c8ebf286119$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = $b3310c8ebf286119$var$formatDistanceLocale[token];
    if (typeof form === 'string') result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dans ' + result;
        else return 'il y a ' + result;
    }
    return result;
};
var $b3310c8ebf286119$export$2e2bcd8739ae039 = $b3310c8ebf286119$var$formatDistance;
module.exports["default"] = $b3310c8ebf286119$export$2e2bcd8739ae039;

});

parcelRegister("01rSh", function(module, exports) {
var $0045b765cefef7ca$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: 'P'
};
var $0045b765cefef7ca$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $0045b765cefef7ca$var$formatRelativeLocale[token];
};
var $0045b765cefef7ca$export$2e2bcd8739ae039 = $0045b765cefef7ca$var$formatRelative;
module.exports["default"] = $0045b765cefef7ca$export$2e2bcd8739ae039;

});

parcelRegister("bgELe", function(module, exports) {

var $lo4TZ = parcelRequire("lo4TZ");

var $8340ce93ee5018db$var$eraValues = {
    narrow: [
        'av. J.-C',
        'ap. J.-C'
    ],
    abbreviated: [
        'av. J.-C',
        'ap. J.-C'
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var $8340ce93ee5018db$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1er trim.',
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        '1er trimestre',
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var $8340ce93ee5018db$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        "f\xe9vr.",
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        "ao\xfbt",
        'sept.',
        'oct.',
        'nov.',
        "d\xe9c."
    ],
    wide: [
        'janvier',
        "f\xe9vrier",
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        "ao\xfbt",
        'septembre',
        'octobre',
        'novembre',
        "d\xe9cembre"
    ]
};
var $8340ce93ee5018db$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        'je',
        've',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'lun.',
        'mar.',
        'mer.',
        'jeu.',
        'ven.',
        'sam.'
    ],
    wide: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi'
    ]
};
var $8340ce93ee5018db$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'soir',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'matin',
        afternoon: "apr\xe8s-midi",
        evening: 'soir',
        night: 'matin'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'du matin',
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: 'du soir',
        night: 'du matin'
    }
};
var $8340ce93ee5018db$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return '0';
    var feminineUnits = [
        'year',
        'week',
        'hour',
        'minute',
        'second'
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : 'er';
    else suffix = "\xe8me";
    return number + suffix;
};
var $8340ce93ee5018db$var$localize = {
    ordinalNumber: $8340ce93ee5018db$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $8340ce93ee5018db$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $8340ce93ee5018db$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $8340ce93ee5018db$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $8340ce93ee5018db$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $8340ce93ee5018db$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $8340ce93ee5018db$export$2e2bcd8739ae039 = $8340ce93ee5018db$var$localize;
module.exports["default"] = $8340ce93ee5018db$export$2e2bcd8739ae039;

});

parcelRegister("5uKey", function(module, exports) {

var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $40039e210c82bfae$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var $40039e210c82bfae$var$parseOrdinalNumberPattern = /\d+/i;
var $40039e210c82bfae$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var $40039e210c82bfae$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $40039e210c82bfae$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var $40039e210c82bfae$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $40039e210c82bfae$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var $40039e210c82bfae$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $40039e210c82bfae$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var $40039e210c82bfae$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var $40039e210c82bfae$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var $40039e210c82bfae$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var $40039e210c82bfae$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $40039e210c82bfae$var$matchOrdinalNumberPattern,
        parsePattern: $40039e210c82bfae$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $40039e210c82bfae$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $40039e210c82bfae$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $40039e210c82bfae$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $40039e210c82bfae$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $40039e210c82bfae$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $40039e210c82bfae$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $40039e210c82bfae$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $40039e210c82bfae$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $40039e210c82bfae$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $40039e210c82bfae$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $40039e210c82bfae$export$2e2bcd8739ae039 = $40039e210c82bfae$var$match;
module.exports["default"] = $40039e210c82bfae$export$2e2bcd8739ae039;

});

parcelRegister("4ihaK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $c89ead3756642915$var$translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: 'majdnem',
    lessthan: 'kevesebb mint'
};
var $c89ead3756642915$var$withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: ' perc',
    xhours: " \xf3ra",
    xdays: ' nap',
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
var $c89ead3756642915$var$withSuffixes = {
    xseconds: {
        '-1': " m\xe1sodperccel ezel\u0151tt",
        '1': " m\xe1sodperc m\xfalva",
        '0': " m\xe1sodperce"
    },
    halfaminute: {
        '-1': "f\xe9l perccel ezel\u0151tt",
        '1': "f\xe9l perc m\xfalva",
        '0': "f\xe9l perce"
    },
    xminutes: {
        '-1': " perccel ezel\u0151tt",
        '1': " perc m\xfalva",
        '0': ' perce'
    },
    xhours: {
        '-1': " \xf3r\xe1val ezel\u0151tt",
        '1': " \xf3ra m\xfalva",
        '0': " \xf3r\xe1ja"
    },
    xdays: {
        '-1': " nappal ezel\u0151tt",
        '1': " nap m\xfalva",
        '0': ' napja'
    },
    xweeks: {
        '-1': " h\xe9ttel ezel\u0151tt",
        '1': " h\xe9t m\xfalva",
        '0': ' hete'
    },
    xmonths: {
        '-1': " h\xf3nappal ezel\u0151tt",
        '1': " h\xf3nap m\xfalva",
        '0': " h\xf3napja"
    },
    xyears: {
        '-1': " \xe9vvel ezel\u0151tt",
        '1': " \xe9v m\xfalva",
        '0': " \xe9ve"
    }
};
var $c89ead3756642915$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var key = unit.toLowerCase();
    var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
    var translated = addSuffix ? $c89ead3756642915$var$withSuffixes[key][comparison] : $c89ead3756642915$var$withoutSuffixes[key];
    var result = key === 'halfaminute' ? translated : count + translated;
    if (adverb) {
        var adv = adverb[0].toLowerCase();
        result = $c89ead3756642915$var$translations[adv] + ' ' + result;
    }
    return result;
};
var $c89ead3756642915$export$2e2bcd8739ae039 = $c89ead3756642915$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $37a06072ba6a2ebc$var$dateFormats = {
    full: 'y. MMMM d., EEEE',
    long: 'y. MMMM d.',
    medium: 'y. MMM d.',
    short: 'y. MM. dd.'
};
var $37a06072ba6a2ebc$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $37a06072ba6a2ebc$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $37a06072ba6a2ebc$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $37a06072ba6a2ebc$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $37a06072ba6a2ebc$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $37a06072ba6a2ebc$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $37a06072ba6a2ebc$export$2e2bcd8739ae039 = $37a06072ba6a2ebc$var$formatLong;


var $8adbaf31469791eb$var$accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    'kedden',
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    'szombaton'
];
function $8adbaf31469791eb$var$week(isFuture) {
    return function(date) {
        var weekday = $8adbaf31469791eb$var$accusativeWeekdays[date.getUTCDay()];
        var prefix = isFuture ? '' : "'m\xfalt' ";
        return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
    };
}
var $8adbaf31469791eb$var$formatRelativeLocale = {
    lastWeek: $8adbaf31469791eb$var$week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: $8adbaf31469791eb$var$week(true),
    other: 'P'
};
var $8adbaf31469791eb$var$formatRelative = function formatRelative(token, date) {
    var format = $8adbaf31469791eb$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $8adbaf31469791eb$export$2e2bcd8739ae039 = $8adbaf31469791eb$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $5dc1c6a037764856$var$eraValues = {
    narrow: [
        'ie.',
        'isz.'
    ],
    abbreviated: [
        'i. e.',
        'i. sz.'
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
var $5dc1c6a037764856$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
var $5dc1c6a037764856$var$formattingQuarterValues = {
    narrow: [
        'I.',
        'II.',
        'III.',
        'IV.'
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
var $5dc1c6a037764856$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        "\xc1",
        'M',
        'J',
        'J',
        'A',
        'Sz',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'febr.',
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        'aug.',
        'szept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        'augusztus',
        'szeptember',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $5dc1c6a037764856$var$dayValues = {
    narrow: [
        'V',
        'H',
        'K',
        'Sz',
        'Cs',
        'P',
        'Sz'
    ],
    short: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    abbreviated: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        'kedd',
        'szerda',
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        'szombat'
    ]
};
var $5dc1c6a037764856$var$dayPeriodValues = {
    narrow: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    abbreviated: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    wide: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: "d\xe9lut\xe1n",
        evening: 'este',
        night: "\xe9jjel"
    }
};
var $5dc1c6a037764856$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $5dc1c6a037764856$var$localize = {
    ordinalNumber: $5dc1c6a037764856$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $5dc1c6a037764856$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $5dc1c6a037764856$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        },
        formattingValues: $5dc1c6a037764856$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide'
    }),
    month: (0, $lo4TZ.default)({
        values: $5dc1c6a037764856$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $5dc1c6a037764856$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $5dc1c6a037764856$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $5dc1c6a037764856$export$2e2bcd8739ae039 = $5dc1c6a037764856$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $f8f02b9dbd8871a9$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $f8f02b9dbd8871a9$var$parseOrdinalNumberPattern = /\d+/i;
var $f8f02b9dbd8871a9$var$matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var $f8f02b9dbd8871a9$var$parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
var $f8f02b9dbd8871a9$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var $f8f02b9dbd8871a9$var$parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
var $f8f02b9dbd8871a9$var$matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var $f8f02b9dbd8871a9$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $f8f02b9dbd8871a9$var$matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var $f8f02b9dbd8871a9$var$parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
var $f8f02b9dbd8871a9$var$matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var $f8f02b9dbd8871a9$var$parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
var $f8f02b9dbd8871a9$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $f8f02b9dbd8871a9$var$matchOrdinalNumberPattern,
        parsePattern: $f8f02b9dbd8871a9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $f8f02b9dbd8871a9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f8f02b9dbd8871a9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $f8f02b9dbd8871a9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f8f02b9dbd8871a9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $f8f02b9dbd8871a9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f8f02b9dbd8871a9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $f8f02b9dbd8871a9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f8f02b9dbd8871a9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $f8f02b9dbd8871a9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $f8f02b9dbd8871a9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f8f02b9dbd8871a9$export$2e2bcd8739ae039 = $f8f02b9dbd8871a9$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
 */ var $320629f10eab44fc$var$locale = {
    code: 'hu',
    formatDistance: (0, $c89ead3756642915$export$2e2bcd8739ae039),
    formatLong: (0, $37a06072ba6a2ebc$export$2e2bcd8739ae039),
    formatRelative: (0, $8adbaf31469791eb$export$2e2bcd8739ae039),
    localize: (0, $5dc1c6a037764856$export$2e2bcd8739ae039),
    match: (0, $f8f02b9dbd8871a9$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $320629f10eab44fc$export$2e2bcd8739ae039 = $320629f10eab44fc$var$locale;
module.exports["default"] = $320629f10eab44fc$export$2e2bcd8739ae039;

});

parcelRegister("mn9Wr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $9TnnD = parcelRequire("9TnnD");


var $ke66V = parcelRequire("ke66V");

var $47b4a8da018057a3$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $47b4a8da018057a3$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $47b4a8da018057a3$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $47b4a8da018057a3$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $47b4a8da018057a3$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $47b4a8da018057a3$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $47b4a8da018057a3$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $47b4a8da018057a3$export$2e2bcd8739ae039 = $47b4a8da018057a3$var$formatLong;



var $kA6JQ = parcelRequire("kA6JQ");


var $7Mnkf = parcelRequire("7Mnkf");


var $lX7nd = parcelRequire("lX7nd");

/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */ var $043405272e5a577a$var$locale = {
    code: 'it',
    formatDistance: (0, $9TnnD.default),
    formatLong: (0, $47b4a8da018057a3$export$2e2bcd8739ae039),
    formatRelative: (0, $kA6JQ.default),
    localize: (0, $7Mnkf.default),
    match: (0, $lX7nd.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $043405272e5a577a$export$2e2bcd8739ae039 = $043405272e5a577a$var$locale;
module.exports["default"] = $043405272e5a577a$export$2e2bcd8739ae039;

});

parcelRegister("9TnnD", function(module, exports) {
var $733b62f1cb1e0852$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'meno di un secondo',
        other: 'meno di {{count}} secondi'
    },
    xSeconds: {
        one: 'un secondo',
        other: '{{count}} secondi'
    },
    halfAMinute: 'alcuni secondi',
    lessThanXMinutes: {
        one: 'meno di un minuto',
        other: 'meno di {{count}} minuti'
    },
    xMinutes: {
        one: 'un minuto',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "circa un'ora",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "un'ora",
        other: '{{count}} ore'
    },
    xDays: {
        one: 'un giorno',
        other: '{{count}} giorni'
    },
    aboutXWeeks: {
        one: 'circa una settimana',
        other: 'circa {{count}} settimane'
    },
    xWeeks: {
        one: 'una settimana',
        other: '{{count}} settimane'
    },
    aboutXMonths: {
        one: 'circa un mese',
        other: 'circa {{count}} mesi'
    },
    xMonths: {
        one: 'un mese',
        other: '{{count}} mesi'
    },
    aboutXYears: {
        one: 'circa un anno',
        other: 'circa {{count}} anni'
    },
    xYears: {
        one: 'un anno',
        other: '{{count}} anni'
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: 'quasi un anno',
        other: 'quasi {{count}} anni'
    }
};
var $733b62f1cb1e0852$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $733b62f1cb1e0852$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'tra ' + result;
        else return result + ' fa';
    }
    return result;
};
var $733b62f1cb1e0852$export$2e2bcd8739ae039 = $733b62f1cb1e0852$var$formatDistance;
module.exports["default"] = $733b62f1cb1e0852$export$2e2bcd8739ae039;

});

parcelRegister("kA6JQ", function(module, exports) {

var $c3GpY = parcelRequire("c3GpY");

var $efbc658adae59af3$var$weekdays = [
    'domenica',
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    'sabato'
];
function $efbc658adae59af3$var$_lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + $efbc658adae59af3$var$weekdays[day] + " scorso alle' p";
    }
}
function $efbc658adae59af3$var$thisWeek(day) {
    return "'" + $efbc658adae59af3$var$weekdays[day] + " alle' p";
}
function $efbc658adae59af3$var$_nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + $efbc658adae59af3$var$weekdays[day] + " prossimo alle' p";
    }
}
var $efbc658adae59af3$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $c3GpY.default)(date, baseDate, options)) return $efbc658adae59af3$var$thisWeek(day);
        else return $efbc658adae59af3$var$_lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $c3GpY.default)(date, baseDate, options)) return $efbc658adae59af3$var$thisWeek(day);
        else return $efbc658adae59af3$var$_nextWeek(day);
    },
    other: 'P'
};
var $efbc658adae59af3$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $efbc658adae59af3$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $efbc658adae59af3$export$2e2bcd8739ae039 = $efbc658adae59af3$var$formatRelative;
module.exports["default"] = $efbc658adae59af3$export$2e2bcd8739ae039;

});

parcelRegister("7Mnkf", function(module, exports) {

var $lo4TZ = parcelRequire("lo4TZ");

var $5a9f1c0c9c130134$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'avanti Cristo',
        'dopo Cristo'
    ]
};
var $5a9f1c0c9c130134$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $5a9f1c0c9c130134$var$monthValues = {
    narrow: [
        'G',
        'F',
        'M',
        'A',
        'M',
        'G',
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'gen',
        'feb',
        'mar',
        'apr',
        'mag',
        'giu',
        'lug',
        'ago',
        'set',
        'ott',
        'nov',
        'dic'
    ],
    wide: [
        'gennaio',
        'febbraio',
        'marzo',
        'aprile',
        'maggio',
        'giugno',
        'luglio',
        'agosto',
        'settembre',
        'ottobre',
        'novembre',
        'dicembre'
    ]
};
var $5a9f1c0c9c130134$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'G',
        'V',
        'S'
    ],
    short: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    wide: [
        'domenica',
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        'sabato'
    ]
};
var $5a9f1c0c9c130134$var$dayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    }
};
var $5a9f1c0c9c130134$var$formattingDayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    }
};
var $5a9f1c0c9c130134$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number);
};
var $5a9f1c0c9c130134$var$localize = {
    ordinalNumber: $5a9f1c0c9c130134$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $5a9f1c0c9c130134$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $5a9f1c0c9c130134$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $5a9f1c0c9c130134$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $5a9f1c0c9c130134$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $5a9f1c0c9c130134$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $5a9f1c0c9c130134$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $5a9f1c0c9c130134$export$2e2bcd8739ae039 = $5a9f1c0c9c130134$var$localize;
module.exports["default"] = $5a9f1c0c9c130134$export$2e2bcd8739ae039;

});

parcelRegister("lX7nd", function(module, exports) {

var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $ffb4d3df12af76b7$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $ffb4d3df12af76b7$var$parseOrdinalNumberPattern = /\d+/i;
var $ffb4d3df12af76b7$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var $ffb4d3df12af76b7$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
var $ffb4d3df12af76b7$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $ffb4d3df12af76b7$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ffb4d3df12af76b7$var$matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var $ffb4d3df12af76b7$var$parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $ffb4d3df12af76b7$var$matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var $ffb4d3df12af76b7$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
var $ffb4d3df12af76b7$var$matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var $ffb4d3df12af76b7$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
var $ffb4d3df12af76b7$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $ffb4d3df12af76b7$var$matchOrdinalNumberPattern,
        parsePattern: $ffb4d3df12af76b7$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $ffb4d3df12af76b7$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ffb4d3df12af76b7$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $ffb4d3df12af76b7$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ffb4d3df12af76b7$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $ffb4d3df12af76b7$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ffb4d3df12af76b7$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $ffb4d3df12af76b7$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ffb4d3df12af76b7$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $ffb4d3df12af76b7$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $ffb4d3df12af76b7$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $ffb4d3df12af76b7$export$2e2bcd8739ae039 = $ffb4d3df12af76b7$var$match;
module.exports["default"] = $ffb4d3df12af76b7$export$2e2bcd8739ae039;

});

parcelRegister("1bGRR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $ad602df81f0e0a05$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
    },
    xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
    },
    halfAMinute: "30\u79D2",
    lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
    },
    xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
    },
    aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
    },
    xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
    },
    xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
    },
    aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
    },
    xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
    },
    aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
    },
    xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
    },
    aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
    },
    xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
    },
    overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
    },
    almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
    }
};
var $ad602df81f0e0a05$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = $ad602df81f0e0a05$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5F8C";
        else return result + "\u524D";
    }
    return result;
};
var $ad602df81f0e0a05$export$2e2bcd8739ae039 = $ad602df81f0e0a05$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $57fd4ebc65188c57$var$dateFormats = {
    full: "y\u5E74M\u6708d\u65E5EEEE",
    long: "y\u5E74M\u6708d\u65E5",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var $57fd4ebc65188c57$var$timeFormats = {
    full: "H\u6642mm\u5206ss\u79D2 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $57fd4ebc65188c57$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $57fd4ebc65188c57$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $57fd4ebc65188c57$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $57fd4ebc65188c57$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $57fd4ebc65188c57$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $57fd4ebc65188c57$export$2e2bcd8739ae039 = $57fd4ebc65188c57$var$formatLong;


var $a63048728a2e3803$var$formatRelativeLocale = {
    lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
    yesterday: "\u6628\u65E5\u306Ep",
    today: "\u4ECA\u65E5\u306Ep",
    tomorrow: "\u660E\u65E5\u306Ep",
    nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
    other: 'P'
};
var $a63048728a2e3803$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a63048728a2e3803$var$formatRelativeLocale[token];
};
var $a63048728a2e3803$export$2e2bcd8739ae039 = $a63048728a2e3803$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $464680d0c10d260d$var$eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ],
    wide: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ]
};
var $464680d0c10d260d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u7B2C1\u56DB\u534A\u671F",
        "\u7B2C2\u56DB\u534A\u671F",
        "\u7B2C3\u56DB\u534A\u671F",
        "\u7B2C4\u56DB\u534A\u671F"
    ]
};
var $464680d0c10d260d$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ]
};
var $464680d0c10d260d$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    short: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    abbreviated: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    wide: [
        "\u65E5\u66DC\u65E5",
        "\u6708\u66DC\u65E5",
        "\u706B\u66DC\u65E5",
        "\u6C34\u66DC\u65E5",
        "\u6728\u66DC\u65E5",
        "\u91D1\u66DC\u65E5",
        "\u571F\u66DC\u65E5"
    ]
};
var $464680d0c10d260d$var$dayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $464680d0c10d260d$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $464680d0c10d260d$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u5E74");
        case 'quarter':
            return "\u7B2C".concat(number, "\u56DB\u534A\u671F");
        case 'month':
            return "".concat(number, "\u6708");
        case 'week':
            return "\u7B2C".concat(number, "\u9031");
        case 'date':
            return "".concat(number, "\u65E5");
        case 'hour':
            return "".concat(number, "\u6642");
        case 'minute':
            return "".concat(number, "\u5206");
        case 'second':
            return "".concat(number, "\u79D2");
        default:
            return "".concat(number);
    }
};
var $464680d0c10d260d$var$localize = {
    ordinalNumber: $464680d0c10d260d$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $464680d0c10d260d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $464680d0c10d260d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $464680d0c10d260d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $464680d0c10d260d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $464680d0c10d260d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $464680d0c10d260d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $464680d0c10d260d$export$2e2bcd8739ae039 = $464680d0c10d260d$var$localize;



var $aqoqo = parcelRequire("aqoqo");


var $jLTD6 = parcelRequire("jLTD6");

var $15ce5df464a1928a$var$matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var $15ce5df464a1928a$var$parseOrdinalNumberPattern = /\d+/i;
var $15ce5df464a1928a$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
var $15ce5df464a1928a$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
var $15ce5df464a1928a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
var $15ce5df464a1928a$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $15ce5df464a1928a$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
var $15ce5df464a1928a$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $15ce5df464a1928a$var$matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
var $15ce5df464a1928a$var$parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
var $15ce5df464a1928a$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var $15ce5df464a1928a$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
var $15ce5df464a1928a$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $15ce5df464a1928a$var$matchOrdinalNumberPattern,
        parsePattern: $15ce5df464a1928a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $15ce5df464a1928a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $15ce5df464a1928a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $15ce5df464a1928a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $15ce5df464a1928a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $15ce5df464a1928a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $15ce5df464a1928a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $15ce5df464a1928a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $15ce5df464a1928a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $15ce5df464a1928a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $15ce5df464a1928a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $15ce5df464a1928a$export$2e2bcd8739ae039 = $15ce5df464a1928a$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $0dd8122c1fe24321$var$locale = {
    code: 'ja',
    formatDistance: (0, $ad602df81f0e0a05$export$2e2bcd8739ae039),
    formatLong: (0, $57fd4ebc65188c57$export$2e2bcd8739ae039),
    formatRelative: (0, $a63048728a2e3803$export$2e2bcd8739ae039),
    localize: (0, $464680d0c10d260d$export$2e2bcd8739ae039),
    match: (0, $15ce5df464a1928a$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $0dd8122c1fe24321$export$2e2bcd8739ae039 = $0dd8122c1fe24321$var$locale;
module.exports["default"] = $0dd8122c1fe24321$export$2e2bcd8739ae039;

});

parcelRegister("lCGhI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $1f8f0527d3b273bf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
    },
    xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
    },
    halfAMinute: "30\uCD08",
    lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
    },
    xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
    },
    aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
    },
    xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
    },
    xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
    },
    aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
    },
    xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
    },
    aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
    },
    xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
    },
    aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
    },
    xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
    },
    overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
    },
    almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
    }
};
var $1f8f0527d3b273bf$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1f8f0527d3b273bf$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \uD6C4";
        else return result + " \uC804";
    }
    return result;
};
var $1f8f0527d3b273bf$export$2e2bcd8739ae039 = $1f8f0527d3b273bf$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $7709ccb467797130$var$dateFormats = {
    full: "y\uB144 M\uC6D4 d\uC77C EEEE",
    long: "y\uB144 M\uC6D4 d\uC77C",
    medium: 'y.MM.dd',
    short: 'y.MM.dd'
};
var $7709ccb467797130$var$timeFormats = {
    full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
    long: 'a H:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $7709ccb467797130$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $7709ccb467797130$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $7709ccb467797130$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $7709ccb467797130$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $7709ccb467797130$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7709ccb467797130$export$2e2bcd8739ae039 = $7709ccb467797130$var$formatLong;


var $6759c1eacf8c0995$var$formatRelativeLocale = {
    lastWeek: "'\uC9C0\uB09C' eeee p",
    yesterday: "'\uC5B4\uC81C' p",
    today: "'\uC624\uB298' p",
    tomorrow: "'\uB0B4\uC77C' p",
    nextWeek: "'\uB2E4\uC74C' eeee p",
    other: 'P'
};
var $6759c1eacf8c0995$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $6759c1eacf8c0995$var$formatRelativeLocale[token];
};
var $6759c1eacf8c0995$export$2e2bcd8739ae039 = $6759c1eacf8c0995$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $1179ff77d815b8a1$var$eraValues = {
    narrow: [
        'BC',
        'AD'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        "\uAE30\uC6D0\uC804",
        "\uC11C\uAE30"
    ]
};
var $1179ff77d815b8a1$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\uBD84\uAE30",
        "2\uBD84\uAE30",
        "3\uBD84\uAE30",
        "4\uBD84\uAE30"
    ]
};
var $1179ff77d815b8a1$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ],
    wide: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ]
};
var $1179ff77d815b8a1$var$dayValues = {
    narrow: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    short: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    abbreviated: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    wide: [
        "\uC77C\uC694\uC77C",
        "\uC6D4\uC694\uC77C",
        "\uD654\uC694\uC77C",
        "\uC218\uC694\uC77C",
        "\uBAA9\uC694\uC77C",
        "\uAE08\uC694\uC77C",
        "\uD1A0\uC694\uC77C"
    ]
};
var $1179ff77d815b8a1$var$dayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $1179ff77d815b8a1$var$formattingDayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $1179ff77d815b8a1$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'minute':
        case 'second':
            return String(number);
        case 'date':
            return number + "\uC77C";
        default:
            return number + "\uBC88\uC9F8";
    }
};
var $1179ff77d815b8a1$var$localize = {
    ordinalNumber: $1179ff77d815b8a1$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $1179ff77d815b8a1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $1179ff77d815b8a1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $1179ff77d815b8a1$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $1179ff77d815b8a1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $1179ff77d815b8a1$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1179ff77d815b8a1$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1179ff77d815b8a1$export$2e2bcd8739ae039 = $1179ff77d815b8a1$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $d5d56dc28091006f$var$matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var $d5d56dc28091006f$var$parseOrdinalNumberPattern = /\d+/i;
var $d5d56dc28091006f$var$matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
var $d5d56dc28091006f$var$parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
var $d5d56dc28091006f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
var $d5d56dc28091006f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $d5d56dc28091006f$var$matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
var $d5d56dc28091006f$var$parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $d5d56dc28091006f$var$matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
var $d5d56dc28091006f$var$parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
var $d5d56dc28091006f$var$matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var $d5d56dc28091006f$var$parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
var $d5d56dc28091006f$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $d5d56dc28091006f$var$matchOrdinalNumberPattern,
        parsePattern: $d5d56dc28091006f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $d5d56dc28091006f$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d5d56dc28091006f$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $d5d56dc28091006f$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d5d56dc28091006f$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $d5d56dc28091006f$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d5d56dc28091006f$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $d5d56dc28091006f$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d5d56dc28091006f$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $d5d56dc28091006f$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $d5d56dc28091006f$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d5d56dc28091006f$export$2e2bcd8739ae039 = $d5d56dc28091006f$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $fbddf271da961bc4$var$locale = {
    code: 'ko',
    formatDistance: (0, $1f8f0527d3b273bf$export$2e2bcd8739ae039),
    formatLong: (0, $7709ccb467797130$export$2e2bcd8739ae039),
    formatRelative: (0, $6759c1eacf8c0995$export$2e2bcd8739ae039),
    localize: (0, $1179ff77d815b8a1$export$2e2bcd8739ae039),
    match: (0, $d5d56dc28091006f$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $fbddf271da961bc4$export$2e2bcd8739ae039 = $fbddf271da961bc4$var$locale;
module.exports["default"] = $fbddf271da961bc4$export$2e2bcd8739ae039;

});

parcelRegister("bTX4C", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $eb614e3523c6aaed$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn ett sekund',
        other: 'mindre enn {{count}} sekunder'
    },
    xSeconds: {
        one: 'ett sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'et halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn ett minutt',
        other: 'mindre enn {{count}} minutter'
    },
    xMinutes: {
        one: 'ett minutt',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'omtrent en time',
        other: 'omtrent {{count}} timer'
    },
    xHours: {
        one: 'en time',
        other: '{{count}} timer'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dager'
    },
    aboutXWeeks: {
        one: 'omtrent en uke',
        other: 'omtrent {{count}} uker'
    },
    xWeeks: {
        one: 'en uke',
        other: '{{count}} uker'
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $eb614e3523c6aaed$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $eb614e3523c6aaed$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
var $eb614e3523c6aaed$export$2e2bcd8739ae039 = $eb614e3523c6aaed$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $ffce77a5617962ef$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $ffce77a5617962ef$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $ffce77a5617962ef$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $ffce77a5617962ef$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $ffce77a5617962ef$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $ffce77a5617962ef$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $ffce77a5617962ef$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ffce77a5617962ef$export$2e2bcd8739ae039 = $ffce77a5617962ef$var$formatLong;


var $974c396f048069a8$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $974c396f048069a8$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $974c396f048069a8$var$formatRelativeLocale[token];
};
var $974c396f048069a8$export$2e2bcd8739ae039 = $974c396f048069a8$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $4c8a7f99dc81d3bc$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var $4c8a7f99dc81d3bc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $4c8a7f99dc81d3bc$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var $4c8a7f99dc81d3bc$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        'man',
        'tir',
        'ons',
        'tor',
        'fre',
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $4c8a7f99dc81d3bc$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
var $4c8a7f99dc81d3bc$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $4c8a7f99dc81d3bc$var$localize = {
    ordinalNumber: $4c8a7f99dc81d3bc$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $4c8a7f99dc81d3bc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $4c8a7f99dc81d3bc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $4c8a7f99dc81d3bc$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $4c8a7f99dc81d3bc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $4c8a7f99dc81d3bc$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $4c8a7f99dc81d3bc$export$2e2bcd8739ae039 = $4c8a7f99dc81d3bc$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $972cef0d7d58bcd7$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $972cef0d7d58bcd7$var$parseOrdinalNumberPattern = /\d+/i;
var $972cef0d7d58bcd7$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $972cef0d7d58bcd7$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $972cef0d7d58bcd7$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $972cef0d7d58bcd7$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $972cef0d7d58bcd7$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $972cef0d7d58bcd7$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $972cef0d7d58bcd7$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $972cef0d7d58bcd7$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $972cef0d7d58bcd7$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var $972cef0d7d58bcd7$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $972cef0d7d58bcd7$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $972cef0d7d58bcd7$var$matchOrdinalNumberPattern,
        parsePattern: $972cef0d7d58bcd7$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $972cef0d7d58bcd7$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $972cef0d7d58bcd7$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $972cef0d7d58bcd7$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $972cef0d7d58bcd7$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $972cef0d7d58bcd7$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $972cef0d7d58bcd7$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $972cef0d7d58bcd7$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $972cef0d7d58bcd7$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $972cef0d7d58bcd7$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $972cef0d7d58bcd7$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $972cef0d7d58bcd7$export$2e2bcd8739ae039 = $972cef0d7d58bcd7$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */ var $8aa2a78dff1dc196$var$locale = {
    code: 'nb',
    formatDistance: (0, $eb614e3523c6aaed$export$2e2bcd8739ae039),
    formatLong: (0, $ffce77a5617962ef$export$2e2bcd8739ae039),
    formatRelative: (0, $974c396f048069a8$export$2e2bcd8739ae039),
    localize: (0, $4c8a7f99dc81d3bc$export$2e2bcd8739ae039),
    match: (0, $972cef0d7d58bcd7$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $8aa2a78dff1dc196$export$2e2bcd8739ae039 = $8aa2a78dff1dc196$var$locale;
module.exports["default"] = $8aa2a78dff1dc196$export$2e2bcd8739ae039;

});

parcelRegister("j02BH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $7231253fb42098b2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var $7231253fb42098b2$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $7231253fb42098b2$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
var $7231253fb42098b2$export$2e2bcd8739ae039 = $7231253fb42098b2$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $6559f9a8eb52ed34$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var $6559f9a8eb52ed34$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $6559f9a8eb52ed34$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $6559f9a8eb52ed34$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $6559f9a8eb52ed34$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $6559f9a8eb52ed34$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $6559f9a8eb52ed34$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6559f9a8eb52ed34$export$2e2bcd8739ae039 = $6559f9a8eb52ed34$var$formatLong;


var $94329affd7ca18d1$var$formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $94329affd7ca18d1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $94329affd7ca18d1$var$formatRelativeLocale[token];
};
var $94329affd7ca18d1$export$2e2bcd8739ae039 = $94329affd7ca18d1$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $37908b273e2acc51$var$eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $37908b273e2acc51$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var $37908b273e2acc51$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $37908b273e2acc51$var$dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var $37908b273e2acc51$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $37908b273e2acc51$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var $37908b273e2acc51$var$localize = {
    ordinalNumber: $37908b273e2acc51$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $37908b273e2acc51$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $37908b273e2acc51$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $37908b273e2acc51$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $37908b273e2acc51$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $37908b273e2acc51$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $37908b273e2acc51$export$2e2bcd8739ae039 = $37908b273e2acc51$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $0ef7fd64d67fff80$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $0ef7fd64d67fff80$var$parseOrdinalNumberPattern = /\d+/i;
var $0ef7fd64d67fff80$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $0ef7fd64d67fff80$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $0ef7fd64d67fff80$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $0ef7fd64d67fff80$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0ef7fd64d67fff80$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $0ef7fd64d67fff80$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $0ef7fd64d67fff80$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $0ef7fd64d67fff80$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $0ef7fd64d67fff80$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $0ef7fd64d67fff80$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $0ef7fd64d67fff80$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $0ef7fd64d67fff80$var$matchOrdinalNumberPattern,
        parsePattern: $0ef7fd64d67fff80$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $0ef7fd64d67fff80$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0ef7fd64d67fff80$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $0ef7fd64d67fff80$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0ef7fd64d67fff80$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $0ef7fd64d67fff80$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0ef7fd64d67fff80$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $0ef7fd64d67fff80$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0ef7fd64d67fff80$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $0ef7fd64d67fff80$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0ef7fd64d67fff80$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0ef7fd64d67fff80$export$2e2bcd8739ae039 = $0ef7fd64d67fff80$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */ var $dd500a21f156aba7$var$locale = {
    code: 'nl',
    formatDistance: (0, $7231253fb42098b2$export$2e2bcd8739ae039),
    formatLong: (0, $6559f9a8eb52ed34$export$2e2bcd8739ae039),
    formatRelative: (0, $94329affd7ca18d1$export$2e2bcd8739ae039),
    localize: (0, $37908b273e2acc51$export$2e2bcd8739ae039),
    match: (0, $0ef7fd64d67fff80$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $dd500a21f156aba7$export$2e2bcd8739ae039 = $dd500a21f156aba7$var$locale;
module.exports["default"] = $dd500a21f156aba7$export$2e2bcd8739ae039;

});

parcelRegister("aJSKs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $02fab12bd5fed0a7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: '{{count}} sekundy',
        other: '{{count}} sekund'
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: '{{count}} minuty',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: 'godzina',
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: '{{count}} godziny',
        other: '{{count}} godzin'
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: '{{count}} dni',
        other: '{{count}} dni'
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: '{{count}} tygodnie',
        other: '{{count}} tygodni'
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: 'rok',
        twoFour: '{{count}} lata',
        other: '{{count}} lat'
    },
    overXYears: {
        one: 'ponad rok',
        twoFour: 'ponad {{count}} lata',
        other: 'ponad {{count}} lat'
    },
    almostXYears: {
        one: 'prawie rok',
        twoFour: 'prawie {{count}} lata',
        other: 'prawie {{count}} lat'
    }
};
function $02fab12bd5fed0a7$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    var rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    var rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function $02fab12bd5fed0a7$var$declension(scheme, count, time) {
    var group = $02fab12bd5fed0a7$var$declensionGroup(scheme, count);
    var finalText = typeof group === 'string' ? group : group[time];
    return finalText.replace('{{count}}', String(count));
}
var $02fab12bd5fed0a7$var$formatDistance = function formatDistance(token, count, options) {
    var scheme = $02fab12bd5fed0a7$var$formatDistanceLocale[token];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $02fab12bd5fed0a7$var$declension(scheme, count, 'regular');
    if (options.comparison && options.comparison > 0) return 'za ' + $02fab12bd5fed0a7$var$declension(scheme, count, 'future');
    else return $02fab12bd5fed0a7$var$declension(scheme, count, 'past') + ' temu';
};
var $02fab12bd5fed0a7$export$2e2bcd8739ae039 = $02fab12bd5fed0a7$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $f0348316bbc87dcf$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'dd.MM.y'
};
var $f0348316bbc87dcf$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $f0348316bbc87dcf$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f0348316bbc87dcf$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $f0348316bbc87dcf$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $f0348316bbc87dcf$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $f0348316bbc87dcf$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f0348316bbc87dcf$export$2e2bcd8739ae039 = $f0348316bbc87dcf$var$formatLong;



var $c3GpY = parcelRequire("c3GpY");

var $1e445b823d45cffc$var$adjectivesLastWeek = {
    masculine: 'ostatni',
    feminine: 'ostatnia'
};
var $1e445b823d45cffc$var$adjectivesThisWeek = {
    masculine: 'ten',
    feminine: 'ta'
};
var $1e445b823d45cffc$var$adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
var $1e445b823d45cffc$var$dayGrammaticalGender = {
    0: 'feminine',
    1: 'masculine',
    2: 'masculine',
    3: 'feminine',
    4: 'masculine',
    5: 'masculine',
    6: 'feminine'
};
function $1e445b823d45cffc$var$dayAndTimeWithAdjective(token, date, baseDate, options) {
    var adjectives;
    if ((0, $c3GpY.default)(date, baseDate, options)) adjectives = $1e445b823d45cffc$var$adjectivesThisWeek;
    else if (token === 'lastWeek') adjectives = $1e445b823d45cffc$var$adjectivesLastWeek;
    else if (token === 'nextWeek') adjectives = $1e445b823d45cffc$var$adjectivesNextWeek;
    else throw new Error("Cannot determine adjectives for token ".concat(token));
    var day = date.getUTCDay();
    var grammaticalGender = $1e445b823d45cffc$var$dayGrammaticalGender[day];
    var adjective = adjectives[grammaticalGender];
    return "'".concat(adjective, "' eeee 'o' p");
}
var $1e445b823d45cffc$var$formatRelativeLocale = {
    lastWeek: $1e445b823d45cffc$var$dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: $1e445b823d45cffc$var$dayAndTimeWithAdjective,
    other: 'P'
};
var $1e445b823d45cffc$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $1e445b823d45cffc$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(token, date, baseDate, options);
    return format;
};
var $1e445b823d45cffc$export$2e2bcd8739ae039 = $1e445b823d45cffc$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $8d46b2cbc8a96a60$var$eraValues = {
    narrow: [
        'p.n.e.',
        'n.e.'
    ],
    abbreviated: [
        'p.n.e.',
        'n.e.'
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        'naszej ery'
    ]
};
var $8d46b2cbc8a96a60$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I kw.',
        'II kw.',
        'III kw.',
        'IV kw.'
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
var $8d46b2cbc8a96a60$var$monthValues = {
    narrow: [
        'S',
        'L',
        'M',
        'K',
        'M',
        'C',
        'L',
        'S',
        'W',
        'P',
        'L',
        'G'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        "stycze\u0144",
        'luty',
        'marzec',
        "kwiecie\u0144",
        'maj',
        'czerwiec',
        'lipiec',
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        'listopad',
        "grudzie\u0144"
    ]
};
var $8d46b2cbc8a96a60$var$monthFormattingValues = {
    narrow: [
        's',
        'l',
        'm',
        'k',
        'm',
        'c',
        'l',
        's',
        'w',
        'p',
        'l',
        'g'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        'stycznia',
        'lutego',
        'marca',
        'kwietnia',
        'maja',
        'czerwca',
        'lipca',
        'sierpnia',
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        'listopada',
        'grudnia'
    ]
};
var $8d46b2cbc8a96a60$var$dayValues = {
    narrow: [
        'N',
        'P',
        'W',
        "\u015A",
        'C',
        'P',
        'S'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var $8d46b2cbc8a96a60$var$dayFormattingValues = {
    narrow: [
        'n',
        'p',
        'w',
        "\u015B",
        'c',
        'p',
        's'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var $8d46b2cbc8a96a60$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: 'rano',
        afternoon: "popo\u0142.",
        evening: 'wiecz.',
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    }
};
var $8d46b2cbc8a96a60$var$dayPeriodFormattingValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: 'rano',
        afternoon: "po po\u0142.",
        evening: 'wiecz.',
        night: 'w nocy'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    }
};
var $8d46b2cbc8a96a60$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $8d46b2cbc8a96a60$var$localize = {
    ordinalNumber: $8d46b2cbc8a96a60$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $8d46b2cbc8a96a60$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $8d46b2cbc8a96a60$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $8d46b2cbc8a96a60$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $8d46b2cbc8a96a60$var$monthFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $8d46b2cbc8a96a60$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $8d46b2cbc8a96a60$var$dayFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $8d46b2cbc8a96a60$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $8d46b2cbc8a96a60$var$dayPeriodFormattingValues,
        defaultFormattingWidth: 'wide'
    })
};
var $8d46b2cbc8a96a60$export$2e2bcd8739ae039 = $8d46b2cbc8a96a60$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $d1158ffa3291d4d8$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $d1158ffa3291d4d8$var$parseOrdinalNumberPattern = /\d+/i;
var $d1158ffa3291d4d8$var$matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var $d1158ffa3291d4d8$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
var $d1158ffa3291d4d8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var $d1158ffa3291d4d8$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
var $d1158ffa3291d4d8$var$matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var $d1158ffa3291d4d8$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
var $d1158ffa3291d4d8$var$matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var $d1158ffa3291d4d8$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
var $d1158ffa3291d4d8$var$matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var $d1158ffa3291d4d8$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
var $d1158ffa3291d4d8$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $d1158ffa3291d4d8$var$matchOrdinalNumberPattern,
        parsePattern: $d1158ffa3291d4d8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $d1158ffa3291d4d8$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d1158ffa3291d4d8$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $d1158ffa3291d4d8$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d1158ffa3291d4d8$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $d1158ffa3291d4d8$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d1158ffa3291d4d8$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $d1158ffa3291d4d8$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d1158ffa3291d4d8$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $d1158ffa3291d4d8$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $d1158ffa3291d4d8$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d1158ffa3291d4d8$export$2e2bcd8739ae039 = $d1158ffa3291d4d8$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */ var $7d189336ce17e64a$var$locale = {
    code: 'pl',
    formatDistance: (0, $02fab12bd5fed0a7$export$2e2bcd8739ae039),
    formatLong: (0, $f0348316bbc87dcf$export$2e2bcd8739ae039),
    formatRelative: (0, $1e445b823d45cffc$export$2e2bcd8739ae039),
    localize: (0, $8d46b2cbc8a96a60$export$2e2bcd8739ae039),
    match: (0, $d1158ffa3291d4d8$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $7d189336ce17e64a$export$2e2bcd8739ae039 = $7d189336ce17e64a$var$locale;
module.exports["default"] = $7d189336ce17e64a$export$2e2bcd8739ae039;

});

parcelRegister("fV2AU", function(module, exports) {
var $436cab5978e8913f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'cerca de 1 hora',
        other: 'cerca de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'cerca de 1 semana',
        other: 'cerca de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: 'cerca de {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'cerca de 1 ano',
        other: 'cerca de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var $436cab5978e8913f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $436cab5978e8913f$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'em ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $436cab5978e8913f$export$2e2bcd8739ae039 = $436cab5978e8913f$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $4724b2e195281e09$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $4724b2e195281e09$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $4724b2e195281e09$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $4724b2e195281e09$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $4724b2e195281e09$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $4724b2e195281e09$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $4724b2e195281e09$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $4724b2e195281e09$export$2e2bcd8739ae039 = $4724b2e195281e09$var$formatLong;


var $37d78652948798e7$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var $37d78652948798e7$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $37d78652948798e7$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $37d78652948798e7$export$2e2bcd8739ae039 = $37d78652948798e7$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $2cb12ec2cdf83ba9$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'depois de cristo'
    ]
};
var $2cb12ec2cdf83ba9$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $2cb12ec2cdf83ba9$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var $2cb12ec2cdf83ba9$var$dayValues = {
    narrow: [
        'D',
        'S',
        'T',
        'Q',
        'Q',
        'S',
        'S'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        'sab'
    ],
    abbreviated: [
        'domingo',
        'segunda',
        "ter\xe7a",
        'quarta',
        'quinta',
        'sexta',
        "s\xe1bado"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var $2cb12ec2cdf83ba9$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    }
};
var $2cb12ec2cdf83ba9$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    }
};
var $2cb12ec2cdf83ba9$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'week') return number + "\xaa";
    return number + "\xba";
};
var $2cb12ec2cdf83ba9$var$localize = {
    ordinalNumber: $2cb12ec2cdf83ba9$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $2cb12ec2cdf83ba9$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $2cb12ec2cdf83ba9$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $2cb12ec2cdf83ba9$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $2cb12ec2cdf83ba9$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $2cb12ec2cdf83ba9$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $2cb12ec2cdf83ba9$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $2cb12ec2cdf83ba9$export$2e2bcd8739ae039 = $2cb12ec2cdf83ba9$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $af6d28d309643cdb$var$matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
var $af6d28d309643cdb$var$parseOrdinalNumberPattern = /\d+/i;
var $af6d28d309643cdb$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
var $af6d28d309643cdb$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
var $af6d28d309643cdb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $af6d28d309643cdb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $af6d28d309643cdb$var$matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $af6d28d309643cdb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
var $af6d28d309643cdb$var$matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var $af6d28d309643cdb$var$parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
var $af6d28d309643cdb$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var $af6d28d309643cdb$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
var $af6d28d309643cdb$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $af6d28d309643cdb$var$matchOrdinalNumberPattern,
        parsePattern: $af6d28d309643cdb$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $af6d28d309643cdb$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af6d28d309643cdb$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $af6d28d309643cdb$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af6d28d309643cdb$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $af6d28d309643cdb$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af6d28d309643cdb$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $af6d28d309643cdb$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af6d28d309643cdb$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $af6d28d309643cdb$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $af6d28d309643cdb$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $af6d28d309643cdb$export$2e2bcd8739ae039 = $af6d28d309643cdb$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */ var $b96e310ddf0fbc63$var$locale = {
    code: 'pt-BR',
    formatDistance: (0, $436cab5978e8913f$export$2e2bcd8739ae039),
    formatLong: (0, $4724b2e195281e09$export$2e2bcd8739ae039),
    formatRelative: (0, $37d78652948798e7$export$2e2bcd8739ae039),
    localize: (0, $2cb12ec2cdf83ba9$export$2e2bcd8739ae039),
    match: (0, $af6d28d309643cdb$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b96e310ddf0fbc63$export$2e2bcd8739ae039 = $b96e310ddf0fbc63$var$locale;
module.exports["default"] = $b96e310ddf0fbc63$export$2e2bcd8739ae039;

});

parcelRegister("8DIej", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
function $663064fa7a7d1069$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $663064fa7a7d1069$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $663064fa7a7d1069$var$declension(scheme.future, count);
                else return "\u0447\u0435\u0440\u0435\u0437 " + $663064fa7a7d1069$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $663064fa7a7d1069$var$declension(scheme.past, count);
                else return $663064fa7a7d1069$var$declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return $663064fa7a7d1069$var$declension(scheme.regular, count);
    };
}
var $663064fa7a7d1069$var$formatDistanceLocale = {
    lessThanXSeconds: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: $663064fa7a7d1069$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
var $663064fa7a7d1069$var$formatDistance = function formatDistance(token, count, options) {
    return $663064fa7a7d1069$var$formatDistanceLocale[token](count, options);
};
var $663064fa7a7d1069$export$2e2bcd8739ae039 = $663064fa7a7d1069$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $f4023aa3ff4da8ef$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $f4023aa3ff4da8ef$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $f4023aa3ff4da8ef$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $f4023aa3ff4da8ef$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $f4023aa3ff4da8ef$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $f4023aa3ff4da8ef$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $f4023aa3ff4da8ef$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $f4023aa3ff4da8ef$export$2e2bcd8739ae039 = $f4023aa3ff4da8ef$var$formatLong;



var $c3GpY = parcelRequire("c3GpY");

var $e832d5fdde5f8629$var$accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function $e832d5fdde5f8629$var$_lastWeek(day) {
    var weekday = $e832d5fdde5f8629$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function $e832d5fdde5f8629$var$thisWeek(day) {
    var weekday = $e832d5fdde5f8629$var$accusativeWeekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $e832d5fdde5f8629$var$_nextWeek(day) {
    var weekday = $e832d5fdde5f8629$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
var $e832d5fdde5f8629$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $c3GpY.default)(date, baseDate, options)) return $e832d5fdde5f8629$var$thisWeek(day);
        else return $e832d5fdde5f8629$var$_lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $c3GpY.default)(date, baseDate, options)) return $e832d5fdde5f8629$var$thisWeek(day);
        else return $e832d5fdde5f8629$var$_nextWeek(day);
    },
    other: 'P'
};
var $e832d5fdde5f8629$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $e832d5fdde5f8629$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $e832d5fdde5f8629$export$2e2bcd8739ae039 = $e832d5fdde5f8629$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $a4c3b13313bd448e$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
var $a4c3b13313bd448e$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $a4c3b13313bd448e$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
var $a4c3b13313bd448e$var$formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
var $a4c3b13313bd448e$var$dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
var $a4c3b13313bd448e$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
var $a4c3b13313bd448e$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
var $a4c3b13313bd448e$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'date') suffix = "-\u0435";
    else if (unit === 'week' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = "-\u0439";
    return number + suffix;
};
var $a4c3b13313bd448e$var$localize = {
    ordinalNumber: $a4c3b13313bd448e$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $a4c3b13313bd448e$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $a4c3b13313bd448e$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $a4c3b13313bd448e$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $a4c3b13313bd448e$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $a4c3b13313bd448e$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $a4c3b13313bd448e$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $a4c3b13313bd448e$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a4c3b13313bd448e$export$2e2bcd8739ae039 = $a4c3b13313bd448e$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $7d39b86aa8e88817$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var $7d39b86aa8e88817$var$parseOrdinalNumberPattern = /\d+/i;
var $7d39b86aa8e88817$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var $7d39b86aa8e88817$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $7d39b86aa8e88817$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var $7d39b86aa8e88817$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7d39b86aa8e88817$var$matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var $7d39b86aa8e88817$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $7d39b86aa8e88817$var$matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var $7d39b86aa8e88817$var$parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $7d39b86aa8e88817$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var $7d39b86aa8e88817$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $7d39b86aa8e88817$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $7d39b86aa8e88817$var$matchOrdinalNumberPattern,
        parsePattern: $7d39b86aa8e88817$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $7d39b86aa8e88817$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d39b86aa8e88817$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $7d39b86aa8e88817$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d39b86aa8e88817$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $7d39b86aa8e88817$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d39b86aa8e88817$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $7d39b86aa8e88817$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d39b86aa8e88817$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $7d39b86aa8e88817$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d39b86aa8e88817$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7d39b86aa8e88817$export$2e2bcd8739ae039 = $7d39b86aa8e88817$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $64a4465b773e0a29$var$locale = {
    code: 'ru',
    formatDistance: (0, $663064fa7a7d1069$export$2e2bcd8739ae039),
    formatLong: (0, $f4023aa3ff4da8ef$export$2e2bcd8739ae039),
    formatRelative: (0, $e832d5fdde5f8629$export$2e2bcd8739ae039),
    localize: (0, $a4c3b13313bd448e$export$2e2bcd8739ae039),
    match: (0, $7d39b86aa8e88817$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $64a4465b773e0a29$export$2e2bcd8739ae039 = $64a4465b773e0a29$var$locale;
module.exports["default"] = $64a4465b773e0a29$export$2e2bcd8739ae039;

});

parcelRegister("aJh34", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $23ece86cae638f81$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: 'en sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'en halv minut',
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: 'en minut',
        other: '{{count}} minuter'
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: 'en timme',
        other: '{{count}} timmar'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} vecka"
    },
    xWeeks: {
        one: 'en vecka',
        other: '{{count}} vecka'
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
var $23ece86cae638f81$var$wordMapping = [
    'noll',
    'en',
    "tv\xe5",
    'tre',
    'fyra',
    'fem',
    'sex',
    'sju',
    "\xe5tta",
    'nio',
    'tio',
    'elva',
    'tolv'
];
var $23ece86cae638f81$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $23ece86cae638f81$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? $23ece86cae638f81$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sedan';
    }
    return result;
};
var $23ece86cae638f81$export$2e2bcd8739ae039 = $23ece86cae638f81$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $b3f6da9b39abf713$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'y-MM-dd'
};
var $b3f6da9b39abf713$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $b3f6da9b39abf713$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $b3f6da9b39abf713$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $b3f6da9b39abf713$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $b3f6da9b39abf713$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $b3f6da9b39abf713$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b3f6da9b39abf713$export$2e2bcd8739ae039 = $b3f6da9b39abf713$var$formatLong;


var $b5886eb83f322c83$var$formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $b5886eb83f322c83$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $b5886eb83f322c83$var$formatRelativeLocale[token];
};
var $b5886eb83f322c83$export$2e2bcd8739ae039 = $b5886eb83f322c83$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $e994354006840899$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf6re Kristus",
        'efter Kristus'
    ]
};
var $e994354006840899$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1:a kvartalet',
        '2:a kvartalet',
        '3:e kvartalet',
        '4:e kvartalet'
    ]
};
var $e994354006840899$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'maj',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'mars',
        'april',
        'maj',
        'juni',
        'juli',
        'augusti',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $e994354006840899$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf6",
        "m\xe5",
        'ti',
        'on',
        'to',
        'fr',
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        'tis',
        'ons',
        'tors',
        'fre',
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        'tisdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
var $e994354006840899$var$dayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morg.',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    abbreviated: {
        am: 'f.m.',
        pm: 'e.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: 'eftermiddag',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'eftermiddag',
        evening: "kv\xe4ll",
        night: 'natt'
    }
};
var $e994354006840899$var$formattingDayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
var $e994354006840899$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ':a';
    }
    return number + ':e';
};
var $e994354006840899$var$localize = {
    ordinalNumber: $e994354006840899$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $e994354006840899$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $e994354006840899$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $e994354006840899$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $e994354006840899$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $e994354006840899$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $e994354006840899$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $e994354006840899$export$2e2bcd8739ae039 = $e994354006840899$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $b952e846f20dd181$var$matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var $b952e846f20dd181$var$parseOrdinalNumberPattern = /\d+/i;
var $b952e846f20dd181$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var $b952e846f20dd181$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
var $b952e846f20dd181$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
var $b952e846f20dd181$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b952e846f20dd181$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var $b952e846f20dd181$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $b952e846f20dd181$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var $b952e846f20dd181$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $b952e846f20dd181$var$matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var $b952e846f20dd181$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
var $b952e846f20dd181$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $b952e846f20dd181$var$matchOrdinalNumberPattern,
        parsePattern: $b952e846f20dd181$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $b952e846f20dd181$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b952e846f20dd181$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $b952e846f20dd181$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b952e846f20dd181$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $b952e846f20dd181$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b952e846f20dd181$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $b952e846f20dd181$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b952e846f20dd181$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $b952e846f20dd181$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $b952e846f20dd181$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b952e846f20dd181$export$2e2bcd8739ae039 = $b952e846f20dd181$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */ var $7cfb54d2a117dff3$var$locale = {
    code: 'sv',
    formatDistance: (0, $23ece86cae638f81$export$2e2bcd8739ae039),
    formatLong: (0, $b3f6da9b39abf713$export$2e2bcd8739ae039),
    formatRelative: (0, $b5886eb83f322c83$export$2e2bcd8739ae039),
    localize: (0, $e994354006840899$export$2e2bcd8739ae039),
    match: (0, $b952e846f20dd181$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $7cfb54d2a117dff3$export$2e2bcd8739ae039 = $7cfb54d2a117dff3$var$locale;
module.exports["default"] = $7cfb54d2a117dff3$export$2e2bcd8739ae039;

});

parcelRegister("eI3Et", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $4e8c63eedb3b4824$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    xSeconds: {
        one: "1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    halfAMinute: "\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
    lessThanXMinutes: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    xMinutes: {
        one: "1 \u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    aboutXHours: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xHours: {
        one: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xDays: {
        one: "1 \u0E27\u0E31\u0E19",
        other: "{{count}} \u0E27\u0E31\u0E19"
    },
    aboutXWeeks: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    xWeeks: {
        one: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    aboutXMonths: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    xMonths: {
        one: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    aboutXYears: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
    },
    xYears: {
        one: "1 \u0E1B\u0E35",
        other: "{{count}} \u0E1B\u0E35"
    },
    overXYears: {
        one: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
        other: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
    },
    almostXYears: {
        one: "\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
        other: "\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
    }
};
var $4e8c63eedb3b4824$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $4e8c63eedb3b4824$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (token === 'halfAMinute') return "\u0E43\u0E19" + result;
            else return "\u0E43\u0E19 " + result;
        } else return result + "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
    }
    return result;
};
var $4e8c63eedb3b4824$export$2e2bcd8739ae039 = $4e8c63eedb3b4824$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $bce87fbe9aa5d27c$var$dateFormats = {
    full: "\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $bce87fbe9aa5d27c$var$timeFormats = {
    full: "H:mm:ss \u0E19. zzzz",
    long: "H:mm:ss \u0E19. z",
    medium: "H:mm:ss \u0E19.",
    short: "H:mm \u0E19."
};
var $bce87fbe9aa5d27c$var$dateTimeFormats = {
    full: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    long: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $bce87fbe9aa5d27c$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $bce87fbe9aa5d27c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $bce87fbe9aa5d27c$var$timeFormats,
        defaultWidth: 'medium'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $bce87fbe9aa5d27c$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $bce87fbe9aa5d27c$export$2e2bcd8739ae039 = $bce87fbe9aa5d27c$var$formatLong;


var $980624e0c003686c$var$formatRelativeLocale = {
    lastWeek: "eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
    yesterday: "'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    today: "'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    tomorrow: "'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    nextWeek: "eeee '\u0E40\u0E27\u0E25\u0E32' p",
    other: 'P'
};
var $980624e0c003686c$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $980624e0c003686c$var$formatRelativeLocale[token];
};
var $980624e0c003686c$export$2e2bcd8739ae039 = $980624e0c003686c$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $8c1753eae8dfa451$var$eraValues = {
    narrow: [
        'B',
        "\u0E04\u0E28"
    ],
    abbreviated: [
        'BC',
        "\u0E04.\u0E28."
    ],
    wide: [
        "\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25",
        "\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"
    ]
};
var $8c1753eae8dfa451$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"
    ]
};
var $8c1753eae8dfa451$var$dayValues = {
    narrow: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    short: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    abbreviated: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    wide: [
        "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C",
        "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
        "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23",
        "\u0E1E\u0E38\u0E18",
        "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35",
        "\u0E28\u0E38\u0E01\u0E23\u0E4C",
        "\u0E40\u0E2A\u0E32\u0E23\u0E4C"
    ]
};
var $8c1753eae8dfa451$var$monthValues = {
    narrow: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    abbreviated: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    wide: [
        "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21",
        "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C",
        "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21",
        "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19",
        "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21",
        "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19",
        "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21",
        "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21",
        "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19",
        "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21",
        "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19",
        "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"
    ]
};
var $8c1753eae8dfa451$var$dayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var $8c1753eae8dfa451$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var $8c1753eae8dfa451$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $8c1753eae8dfa451$var$localize = {
    ordinalNumber: $8c1753eae8dfa451$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $8c1753eae8dfa451$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $8c1753eae8dfa451$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $8c1753eae8dfa451$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $8c1753eae8dfa451$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $8c1753eae8dfa451$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $8c1753eae8dfa451$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $8c1753eae8dfa451$export$2e2bcd8739ae039 = $8c1753eae8dfa451$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $afd382996171e7a5$var$matchOrdinalNumberPattern = /^\d+/i;
var $afd382996171e7a5$var$parseOrdinalNumberPattern = /\d+/i;
var $afd382996171e7a5$var$matchEraPatterns = {
    narrow: /^([bB]|[aA]|คศ)/i,
    abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
    wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
var $afd382996171e7a5$var$parseEraPatterns = {
    any: [
        /^[bB]/i,
        /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i
    ]
};
var $afd382996171e7a5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^ไตรมาส(ที่)? ?[1234]/i
};
var $afd382996171e7a5$var$parseQuarterPatterns = {
    any: [
        /(1|แรก|หนึ่ง)/i,
        /(2|สอง)/i,
        /(3|สาม)/i,
        /(4|สี่)/i
    ]
};
var $afd382996171e7a5$var$matchMonthPatterns = {
    narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
    abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
    wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
var $afd382996171e7a5$var$parseMonthPatterns = {
    wide: [
        /^มก/i,
        /^กุม/i,
        /^มี/i,
        /^เม/i,
        /^พฤษ/i,
        /^มิ/i,
        /^กรก/i,
        /^ส/i,
        /^กัน/i,
        /^ต/i,
        /^พฤศ/i,
        /^ธ/i
    ],
    any: [
        /^ม\.?ค\.?/i,
        /^ก\.?พ\.?/i,
        /^มี\.?ค\.?/i,
        /^เม\.?ย\.?/i,
        /^พ\.?ค\.?/i,
        /^มิ\.?ย\.?/i,
        /^ก\.?ค\.?/i,
        /^ส\.?ค\.?/i,
        /^ก\.?ย\.?/i,
        /^ต\.?ค\.?/i,
        /^พ\.?ย\.?/i,
        /^ธ\.?ค\.?/i
    ]
};
var $afd382996171e7a5$var$matchDayPatterns = {
    narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
var $afd382996171e7a5$var$parseDayPatterns = {
    wide: [
        /^อา/i,
        /^จั/i,
        /^อั/i,
        /^พุธ/i,
        /^พฤ/i,
        /^ศ/i,
        /^เส/i
    ],
    any: [
        /^อา/i,
        /^จ/i,
        /^อ/i,
        /^พ(?!ฤ)/i,
        /^พฤ/i,
        /^ศ/i,
        /^ส/i
    ]
};
var $afd382996171e7a5$var$matchDayPeriodPatterns = {
    any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
var $afd382996171e7a5$var$parseDayPeriodPatterns = {
    any: {
        am: /^ก่อนเที่ยง/i,
        pm: /^หลังเที่ยง/i,
        midnight: /^เที่ยงคืน/i,
        noon: /^เที่ยง/i,
        morning: /เช้า/i,
        afternoon: /บ่าย/i,
        evening: /เย็น/i,
        night: /กลางคืน/i
    }
};
var $afd382996171e7a5$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $afd382996171e7a5$var$matchOrdinalNumberPattern,
        parsePattern: $afd382996171e7a5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $afd382996171e7a5$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $afd382996171e7a5$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $afd382996171e7a5$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $afd382996171e7a5$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $afd382996171e7a5$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $afd382996171e7a5$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $afd382996171e7a5$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $afd382996171e7a5$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $afd382996171e7a5$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $afd382996171e7a5$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $afd382996171e7a5$export$2e2bcd8739ae039 = $afd382996171e7a5$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Thai locale.
 * @language Thai
 * @iso-639-2 tha
 * @author Athiwat Hirunworawongkun [@athivvat]{@link https://github.com/athivvat}
 * @author [@hawkup]{@link https://github.com/hawkup}
 * @author  Jirawat I. [@nodtem66]{@link https://github.com/nodtem66}
 */ var $ab5801ec48a59119$var$locale = {
    code: 'th',
    formatDistance: (0, $4e8c63eedb3b4824$export$2e2bcd8739ae039),
    formatLong: (0, $bce87fbe9aa5d27c$export$2e2bcd8739ae039),
    formatRelative: (0, $980624e0c003686c$export$2e2bcd8739ae039),
    localize: (0, $8c1753eae8dfa451$export$2e2bcd8739ae039),
    match: (0, $afd382996171e7a5$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $ab5801ec48a59119$export$2e2bcd8739ae039 = $ab5801ec48a59119$var$locale;
module.exports["default"] = $ab5801ec48a59119$export$2e2bcd8739ae039;

});

parcelRegister("9bDNQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $508f11569a9dab5a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'bir saniyeden az',
        other: '{{count}} saniyeden az'
    },
    xSeconds: {
        one: '1 saniye',
        other: '{{count}} saniye'
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: 'bir dakikadan az',
        other: '{{count}} dakikadan az'
    },
    xMinutes: {
        one: '1 dakika',
        other: '{{count}} dakika'
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
var $508f11569a9dab5a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $508f11569a9dab5a$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \xf6nce";
    }
    return result;
};
var $508f11569a9dab5a$export$2e2bcd8739ae039 = $508f11569a9dab5a$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $e73fcb2321e59757$var$dateFormats = {
    full: 'd MMMM y EEEE',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.yyyy'
};
var $e73fcb2321e59757$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $e73fcb2321e59757$var$dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e73fcb2321e59757$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $e73fcb2321e59757$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $e73fcb2321e59757$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $e73fcb2321e59757$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e73fcb2321e59757$export$2e2bcd8739ae039 = $e73fcb2321e59757$var$formatLong;


var $8fa745a8afdc9365$var$formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: 'P'
};
var $8fa745a8afdc9365$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $8fa745a8afdc9365$var$formatRelativeLocale[token];
};
var $8fa745a8afdc9365$export$2e2bcd8739ae039 = $8fa745a8afdc9365$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $bca6a136ba9bdf5c$var$eraValues = {
    narrow: [
        "M\xd6",
        'MS'
    ],
    abbreviated: [
        "M\xd6",
        'MS'
    ],
    wide: [
        "Milattan \xd6nce",
        'Milattan Sonra'
    ]
};
var $bca6a136ba9bdf5c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
var $bca6a136ba9bdf5c$var$monthValues = {
    narrow: [
        'O',
        "\u015E",
        'M',
        'N',
        'M',
        'H',
        'T',
        'A',
        'E',
        'E',
        'K',
        'A'
    ],
    abbreviated: [
        'Oca',
        "\u015Eub",
        'Mar',
        'Nis',
        'May',
        'Haz',
        'Tem',
        "A\u011Fu",
        'Eyl',
        'Eki',
        'Kas',
        'Ara'
    ],
    wide: [
        'Ocak',
        "\u015Eubat",
        'Mart',
        'Nisan',
        "May\u0131s",
        'Haziran',
        'Temmuz',
        "A\u011Fustos",
        "Eyl\xfcl",
        'Ekim',
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
var $bca6a136ba9bdf5c$var$dayValues = {
    narrow: [
        'P',
        'P',
        'S',
        "\xc7",
        'P',
        'C',
        'C'
    ],
    short: [
        'Pz',
        'Pt',
        'Sa',
        "\xc7a",
        'Pe',
        'Cu',
        'Ct'
    ],
    abbreviated: [
        'Paz',
        'Pzt',
        'Sal',
        "\xc7ar",
        'Per',
        'Cum',
        'Cts'
    ],
    wide: [
        'Pazar',
        'Pazartesi',
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        'Cuma',
        'Cumartesi'
    ]
};
var $bca6a136ba9bdf5c$var$dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    }
};
var $bca6a136ba9bdf5c$var$formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    }
};
var $bca6a136ba9bdf5c$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $bca6a136ba9bdf5c$var$localize = {
    ordinalNumber: $bca6a136ba9bdf5c$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $bca6a136ba9bdf5c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $bca6a136ba9bdf5c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $bca6a136ba9bdf5c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $bca6a136ba9bdf5c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $bca6a136ba9bdf5c$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $bca6a136ba9bdf5c$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $bca6a136ba9bdf5c$export$2e2bcd8739ae039 = $bca6a136ba9bdf5c$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $e60c65a74d6602f8$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $e60c65a74d6602f8$var$parseOrdinalNumberPattern = /\d+/i;
var $e60c65a74d6602f8$var$matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
var $e60c65a74d6602f8$var$parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
var $e60c65a74d6602f8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var $e60c65a74d6602f8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
var $e60c65a74d6602f8$var$matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var $e60c65a74d6602f8$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
var $e60c65a74d6602f8$var$matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var $e60c65a74d6602f8$var$parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
var $e60c65a74d6602f8$var$matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var $e60c65a74d6602f8$var$parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
var $e60c65a74d6602f8$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $e60c65a74d6602f8$var$matchOrdinalNumberPattern,
        parsePattern: $e60c65a74d6602f8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $e60c65a74d6602f8$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e60c65a74d6602f8$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $e60c65a74d6602f8$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e60c65a74d6602f8$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $e60c65a74d6602f8$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e60c65a74d6602f8$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $e60c65a74d6602f8$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e60c65a74d6602f8$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $e60c65a74d6602f8$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e60c65a74d6602f8$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e60c65a74d6602f8$export$2e2bcd8739ae039 = $e60c65a74d6602f8$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
 * @author Fatih Bulut [@bulutfatih]{@link https://github.com/bulutfatih}
 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
 *
 *
 */ var $6b040426cc196557$var$locale = {
    code: 'tr',
    formatDistance: (0, $508f11569a9dab5a$export$2e2bcd8739ae039),
    formatLong: (0, $e73fcb2321e59757$export$2e2bcd8739ae039),
    formatRelative: (0, $8fa745a8afdc9365$export$2e2bcd8739ae039),
    localize: (0, $bca6a136ba9bdf5c$export$2e2bcd8739ae039),
    match: (0, $e60c65a74d6602f8$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $6b040426cc196557$export$2e2bcd8739ae039 = $6b040426cc196557$var$locale;
module.exports["default"] = $6b040426cc196557$export$2e2bcd8739ae039;

});

parcelRegister("aB16j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
function $56e4c6f7c3a08c75$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $56e4c6f7c3a08c75$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $56e4c6f7c3a08c75$var$declension(scheme.future, count);
                else return "\u0437\u0430 " + $56e4c6f7c3a08c75$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $56e4c6f7c3a08c75$var$declension(scheme.past, count);
                else return $56e4c6f7c3a08c75$var$declension(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
            }
        } else return $56e4c6f7c3a08c75$var$declension(scheme.regular, count);
    };
}
var $56e4c6f7c3a08c75$var$halfAtMinute = function halfAtMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        else return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
    }
    return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
};
var $56e4c6f7c3a08c75$var$formatDistanceLocale = {
    lessThanXSeconds: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $56e4c6f7c3a08c75$var$halfAtMinute,
    lessThanXMinutes: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    xMinutes: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    aboutXHours: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xHours: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xDays: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043Di",
            pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
        }
    }),
    aboutXWeeks: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    xWeeks: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    aboutXMonths: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    xMonths: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    aboutXYears: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    xYears: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0440\u0456\u043A",
            singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    overXYears: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    almostXYears: $56e4c6f7c3a08c75$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    })
};
var $56e4c6f7c3a08c75$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $56e4c6f7c3a08c75$var$formatDistanceLocale[token](count, options);
};
var $56e4c6f7c3a08c75$export$2e2bcd8739ae039 = $56e4c6f7c3a08c75$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $de094932ce7684e1$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0440.'",
    long: "do MMMM y '\u0440.'",
    medium: "d MMM y '\u0440.'",
    short: 'dd.MM.y'
};
var $de094932ce7684e1$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $de094932ce7684e1$var$dateTimeFormats = {
    full: "{{date}} '\u043E' {{time}}",
    long: "{{date}} '\u043E' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $de094932ce7684e1$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $de094932ce7684e1$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $de094932ce7684e1$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $de094932ce7684e1$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $de094932ce7684e1$export$2e2bcd8739ae039 = $de094932ce7684e1$var$formatLong;



var $egXhZ = parcelRequire("egXhZ");


var $c3GpY = parcelRequire("c3GpY");

var $9dc1606f8fb96a93$var$accusativeWeekdays = [
    "\u043D\u0435\u0434\u0456\u043B\u044E",
    "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
    "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
    "\u0441\u0435\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440",
    "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $9dc1606f8fb96a93$var$lastWeek(day) {
    var weekday = $9dc1606f8fb96a93$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
    }
}
function $9dc1606f8fb96a93$var$thisWeek(day) {
    var weekday = $9dc1606f8fb96a93$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u043E' p";
}
function $9dc1606f8fb96a93$var$nextWeek(day) {
    var weekday = $9dc1606f8fb96a93$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
    }
}
var $9dc1606f8fb96a93$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $c3GpY.default)(date, baseDate, options)) return $9dc1606f8fb96a93$var$thisWeek(day);
    else return $9dc1606f8fb96a93$var$lastWeek(day);
};
var $9dc1606f8fb96a93$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $c3GpY.default)(date, baseDate, options)) return $9dc1606f8fb96a93$var$thisWeek(day);
    else return $9dc1606f8fb96a93$var$nextWeek(day);
};
var $9dc1606f8fb96a93$var$formatRelativeLocale = {
    lastWeek: $9dc1606f8fb96a93$var$lastWeekFormat,
    yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
    today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
    nextWeek: $9dc1606f8fb96a93$var$nextWeekFormat,
    other: 'P'
};
var $9dc1606f8fb96a93$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $9dc1606f8fb96a93$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $9dc1606f8fb96a93$export$2e2bcd8739ae039 = $9dc1606f8fb96a93$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $2f0fd6a7f7af8b5c$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438",
        "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"
    ]
};
var $2f0fd6a7f7af8b5c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $2f0fd6a7f7af8b5c$var$monthValues = {
    // ДСТУ 3582:2013
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u0438\u0439",
        "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        "\u043A\u0432\u0456\u0442\u0435\u043D\u044C",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u0435\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0438\u043F\u0435\u043D\u044C",
        "\u0441\u0435\u0440\u043F\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        "\u0436\u043E\u0432\u0442\u0435\u043D\u044C",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"
    ]
};
var $2f0fd6a7f7af8b5c$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u043D\u044F",
        "\u043B\u044E\u0442\u043E\u0433\u043E",
        "\u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        "\u043A\u0432\u0456\u0442\u043D\u044F",
        "\u0442\u0440\u0430\u0432\u043D\u044F",
        "\u0447\u0435\u0440\u0432\u043D\u044F",
        "\u043B\u0438\u043F\u043D\u044F",
        "\u0441\u0435\u0440\u043F\u043D\u044F",
        "\u0432\u0435\u0440\u0435\u0441\u043D\u044F",
        "\u0436\u043E\u0432\u0442\u043D\u044F",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430",
        "\u0433\u0440\u0443\u0434\u043D\u044F"
    ]
};
var $2f0fd6a7f7af8b5c$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0456\u0432",
        "\u0441\u0435\u0440",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0456\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        "\u0441\u0435\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440",
        "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $2f0fd6a7f7af8b5c$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0456\u0440",
        night: "\u043D\u0456\u0447"
    }
};
var $2f0fd6a7f7af8b5c$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    }
};
var $2f0fd6a7f7af8b5c$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    if (unit === 'date') {
        if (number === 3 || number === 23) suffix = "-\u0454";
        else suffix = "-\u0435";
    } else if (unit === 'minute' || unit === 'second' || unit === 'hour') suffix = "-\u0430";
    else suffix = "-\u0439";
    return number + suffix;
};
var $2f0fd6a7f7af8b5c$var$localize = {
    ordinalNumber: $2f0fd6a7f7af8b5c$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $2f0fd6a7f7af8b5c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $2f0fd6a7f7af8b5c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $2f0fd6a7f7af8b5c$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $2f0fd6a7f7af8b5c$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $2f0fd6a7f7af8b5c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $2f0fd6a7f7af8b5c$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $2f0fd6a7f7af8b5c$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $2f0fd6a7f7af8b5c$export$2e2bcd8739ae039 = $2f0fd6a7f7af8b5c$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $d2f60e71096ccf28$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
var $d2f60e71096ccf28$var$parseOrdinalNumberPattern = /\d+/i;
var $d2f60e71096ccf28$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?е\.?)/i,
    abbreviated: /^((до )?н\.?\s?е\.?)/i,
    wide: /^(до нашої ери|нашої ери|наша ера)/i
};
var $d2f60e71096ccf28$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $d2f60e71096ccf28$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
    wide: /^[1234](-?[иі]?й?)? квартал/i
};
var $d2f60e71096ccf28$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $d2f60e71096ccf28$var$matchMonthPatterns = {
    narrow: /^[слбктчвжг]/i,
    abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
    wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
var $d2f60e71096ccf28$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^с/i,
        /^в/i,
        /^ж/i,
        /^л/i,
        /^г/i
    ],
    any: [
        /^сі/i,
        /^лю/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^лип/i,
        /^се/i,
        /^в/i,
        /^ж/i,
        /^лис/i,
        /^г/i
    ]
};
var $d2f60e71096ccf28$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
    abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
    wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
var $d2f60e71096ccf28$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[он]/i,
        /^в/i,
        /^с[ер]/i,
        /^ч/i,
        /^п\W*?[ят]/i,
        /^с[уб]/i
    ]
};
var $d2f60e71096ccf28$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
var $d2f60e71096ccf28$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $d2f60e71096ccf28$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $d2f60e71096ccf28$var$matchOrdinalNumberPattern,
        parsePattern: $d2f60e71096ccf28$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $d2f60e71096ccf28$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d2f60e71096ccf28$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $d2f60e71096ccf28$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d2f60e71096ccf28$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $d2f60e71096ccf28$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d2f60e71096ccf28$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $d2f60e71096ccf28$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d2f60e71096ccf28$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $d2f60e71096ccf28$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d2f60e71096ccf28$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d2f60e71096ccf28$export$2e2bcd8739ae039 = $d2f60e71096ccf28$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
 * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
 */ var $7b6e36b1ae60dffe$var$locale = {
    code: 'uk',
    formatDistance: (0, $56e4c6f7c3a08c75$export$2e2bcd8739ae039),
    formatLong: (0, $de094932ce7684e1$export$2e2bcd8739ae039),
    formatRelative: (0, $9dc1606f8fb96a93$export$2e2bcd8739ae039),
    localize: (0, $2f0fd6a7f7af8b5c$export$2e2bcd8739ae039),
    match: (0, $d2f60e71096ccf28$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $7b6e36b1ae60dffe$export$2e2bcd8739ae039 = $7b6e36b1ae60dffe$var$locale;
module.exports["default"] = $7b6e36b1ae60dffe$export$2e2bcd8739ae039;

});

parcelRegister("aBdsV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $8811a1ced60ca35b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "d\u01B0\u1EDBi 1 gi\xe2y",
        other: "d\u01B0\u1EDBi {{count}} gi\xe2y"
    },
    xSeconds: {
        one: "1 gi\xe2y",
        other: "{{count}} gi\xe2y"
    },
    halfAMinute: "n\u1EEDa ph\xfat",
    lessThanXMinutes: {
        one: "d\u01B0\u1EDBi 1 ph\xfat",
        other: "d\u01B0\u1EDBi {{count}} ph\xfat"
    },
    xMinutes: {
        one: "1 ph\xfat",
        other: "{{count}} ph\xfat"
    },
    aboutXHours: {
        one: "kho\u1EA3ng 1 gi\u1EDD",
        other: "kho\u1EA3ng {{count}} gi\u1EDD"
    },
    xHours: {
        one: "1 gi\u1EDD",
        other: "{{count}} gi\u1EDD"
    },
    xDays: {
        one: "1 ng\xe0y",
        other: "{{count}} ng\xe0y"
    },
    aboutXWeeks: {
        one: "kho\u1EA3ng 1 tu\u1EA7n",
        other: "kho\u1EA3ng {{count}} tu\u1EA7n"
    },
    xWeeks: {
        one: "1 tu\u1EA7n",
        other: "{{count}} tu\u1EA7n"
    },
    aboutXMonths: {
        one: "kho\u1EA3ng 1 th\xe1ng",
        other: "kho\u1EA3ng {{count}} th\xe1ng"
    },
    xMonths: {
        one: "1 th\xe1ng",
        other: "{{count}} th\xe1ng"
    },
    aboutXYears: {
        one: "kho\u1EA3ng 1 n\u0103m",
        other: "kho\u1EA3ng {{count}} n\u0103m"
    },
    xYears: {
        one: "1 n\u0103m",
        other: "{{count}} n\u0103m"
    },
    overXYears: {
        one: "h\u01A1n 1 n\u0103m",
        other: "h\u01A1n {{count}} n\u0103m"
    },
    almostXYears: {
        one: "g\u1EA7n 1 n\u0103m",
        other: "g\u1EA7n {{count}} n\u0103m"
    }
};
var $8811a1ced60ca35b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8811a1ced60ca35b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " n\u1EEFa";
        else return result + " tr\u01B0\u1EDBc";
    }
    return result;
};
var $8811a1ced60ca35b$export$2e2bcd8739ae039 = $8811a1ced60ca35b$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $0e7b4f023259c17a$var$dateFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017
    full: "EEEE, 'ng\xe0y' d MMMM 'n\u0103m' y",
    // ngày 25 tháng 08 năm 2017
    long: "'ng\xe0y' d MMMM 'n\u0103m' y",
    // 25 thg 08 năm 2017
    medium: "d MMM 'n\u0103m' y",
    // 25/08/2017
    short: 'dd/MM/y'
};
var $0e7b4f023259c17a$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $0e7b4f023259c17a$var$dateTimeFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
    full: '{{date}} {{time}}',
    // ngày 25 tháng 08 năm 2017 23:25
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $0e7b4f023259c17a$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $0e7b4f023259c17a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $0e7b4f023259c17a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $0e7b4f023259c17a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $0e7b4f023259c17a$export$2e2bcd8739ae039 = $0e7b4f023259c17a$var$formatLong;


var $fa149f0a10cb3c33$var$formatRelativeLocale = {
    lastWeek: "eeee 'tu\u1EA7n tr\u01B0\u1EDBc v\xe0o l\xfac' p",
    yesterday: "'h\xf4m qua v\xe0o l\xfac' p",
    today: "'h\xf4m nay v\xe0o l\xfac' p",
    tomorrow: "'ng\xe0y mai v\xe0o l\xfac' p",
    nextWeek: "eeee 't\u1EDBi v\xe0o l\xfac' p",
    other: 'P'
};
var $fa149f0a10cb3c33$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $fa149f0a10cb3c33$var$formatRelativeLocale[token];
};
var $fa149f0a10cb3c33$export$2e2bcd8739ae039 = $fa149f0a10cb3c33$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134
var $4c33e6989996f2d6$var$eraValues = {
    narrow: [
        'TCN',
        'SCN'
    ],
    abbreviated: [
        "tr\u01B0\u1EDBc CN",
        'sau CN'
    ],
    wide: [
        "tr\u01B0\u1EDBc C\xf4ng Nguy\xean",
        "sau C\xf4ng Nguy\xean"
    ]
};
var $4c33e6989996f2d6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "Qu\xfd 1",
        "Qu\xfd 2",
        "Qu\xfd 3",
        "Qu\xfd 4"
    ]
};
var $4c33e6989996f2d6$var$formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    // I notice many news outlet use this "quý II/2018"
    wide: [
        "qu\xfd I",
        "qu\xfd II",
        "qu\xfd III",
        "qu\xfd IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $4c33e6989996f2d6$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        'Thg 1',
        'Thg 2',
        'Thg 3',
        'Thg 4',
        'Thg 5',
        'Thg 6',
        'Thg 7',
        'Thg 8',
        'Thg 9',
        'Thg 10',
        'Thg 11',
        'Thg 12'
    ],
    wide: [
        "Th\xe1ng M\u1ED9t",
        "Th\xe1ng Hai",
        "Th\xe1ng Ba",
        "Th\xe1ng T\u01B0",
        "Th\xe1ng N\u0103m",
        "Th\xe1ng S\xe1u",
        "Th\xe1ng B\u1EA3y",
        "Th\xe1ng T\xe1m",
        "Th\xe1ng Ch\xedn",
        "Th\xe1ng M\u01B0\u1EDDi",
        "Th\xe1ng M\u01B0\u1EDDi M\u1ED9t",
        "Th\xe1ng M\u01B0\u1EDDi Hai"
    ]
};
// In Vietnamese date formatting, month number less than 10 expected to have leading zero
var $4c33e6989996f2d6$var$formattingMonthValues = {
    narrow: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        'thg 1',
        'thg 2',
        'thg 3',
        'thg 4',
        'thg 5',
        'thg 6',
        'thg 7',
        'thg 8',
        'thg 9',
        'thg 10',
        'thg 11',
        'thg 12'
    ],
    wide: [
        "th\xe1ng 01",
        "th\xe1ng 02",
        "th\xe1ng 03",
        "th\xe1ng 04",
        "th\xe1ng 05",
        "th\xe1ng 06",
        "th\xe1ng 07",
        "th\xe1ng 08",
        "th\xe1ng 09",
        "th\xe1ng 10",
        "th\xe1ng 11",
        "th\xe1ng 12"
    ]
};
var $4c33e6989996f2d6$var$dayValues = {
    narrow: [
        'CN',
        'T2',
        'T3',
        'T4',
        'T5',
        'T6',
        'T7'
    ],
    short: [
        'CN',
        'Th 2',
        'Th 3',
        'Th 4',
        'Th 5',
        'Th 6',
        'Th 7'
    ],
    abbreviated: [
        'CN',
        "Th\u1EE9 2",
        "Th\u1EE9 3",
        "Th\u1EE9 4",
        "Th\u1EE9 5",
        "Th\u1EE9 6",
        "Th\u1EE9 7"
    ],
    wide: [
        "Ch\u1EE7 Nh\u1EADt",
        "Th\u1EE9 Hai",
        "Th\u1EE9 Ba",
        "Th\u1EE9 T\u01B0",
        "Th\u1EE9 N\u0103m",
        "Th\u1EE9 S\xe1u",
        "Th\u1EE9 B\u1EA3y"
    ]
};
// Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`
var $4c33e6989996f2d6$var$dayPeriodValues = {
    // narrow date period is extremely rare in Vietnamese
    // I used abbreviated form for noon, morning and afternoon
    // which are regconizable by Vietnamese, others cannot be any shorter
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: 'tr',
        morning: 'sg',
        afternoon: 'ch',
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: 'SA',
        pm: 'CH',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    }
};
var $4c33e6989996f2d6$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: 'tr',
        morning: 'sg',
        afternoon: 'ch',
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: 'SA',
        pm: 'CH',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "gi\u1EEFa tr\u01B0a",
        morning: "v\xe0o bu\u1ED5i s\xe1ng",
        afternoon: "v\xe0o bu\u1ED5i chi\u1EC1u",
        evening: "v\xe0o bu\u1ED5i t\u1ED1i",
        night: "v\xe0o ban \u0111\xeam"
    }
};
var $4c33e6989996f2d6$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'quarter') // many news outlets use "quý I"...
    switch(number){
        case 1:
            return 'I';
        case 2:
            return 'II';
        case 3:
            return 'III';
        case 4:
            return 'IV';
    }
    else if (unit === 'day') // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch(number){
        case 1:
            return "th\u1EE9 2";
        // meaning 2nd day but it's the first day of the week :D
        case 2:
            return "th\u1EE9 3";
        // meaning 3rd day
        case 3:
            return "th\u1EE9 4";
        // meaning 4th day and so on
        case 4:
            return "th\u1EE9 5";
        case 5:
            return "th\u1EE9 6";
        case 6:
            return "th\u1EE9 7";
        case 7:
            return "ch\u1EE7 nh\u1EADt";
    }
    else if (unit === 'week') {
        if (number === 1) return "th\u1EE9 nh\u1EA5t";
        else return "th\u1EE9 " + number;
    } else if (unit === 'dayOfYear') {
        if (number === 1) return "\u0111\u1EA7u ti\xean";
        else return "th\u1EE9 " + number;
    }
    // there are no different forms of ordinal numbers in Vietnamese
    return String(number);
};
var $4c33e6989996f2d6$var$localize = {
    ordinalNumber: $4c33e6989996f2d6$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $4c33e6989996f2d6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $4c33e6989996f2d6$var$quarterValues,
        defaultWidth: 'wide',
        formattingValues: $4c33e6989996f2d6$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $4c33e6989996f2d6$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $4c33e6989996f2d6$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $4c33e6989996f2d6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $4c33e6989996f2d6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $4c33e6989996f2d6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $4c33e6989996f2d6$export$2e2bcd8739ae039 = $4c33e6989996f2d6$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $899b3364dc90a4d7$var$matchOrdinalNumberPattern = /^(\d+)/i;
var $899b3364dc90a4d7$var$parseOrdinalNumberPattern = /\d+/i;
var $899b3364dc90a4d7$var$matchEraPatterns = {
    narrow: /^(tcn|scn)/i,
    abbreviated: /^(trước CN|sau CN)/i,
    wide: /^(trước Công Nguyên|sau Công Nguyên)/i
};
var $899b3364dc90a4d7$var$parseEraPatterns = {
    any: [
        /^t/i,
        /^s/i
    ]
};
var $899b3364dc90a4d7$var$matchQuarterPatterns = {
    narrow: /^([1234]|i{1,3}v?)/i,
    abbreviated: /^q([1234]|i{1,3}v?)/i,
    wide: /^quý ([1234]|i{1,3}v?)/i
};
var $899b3364dc90a4d7$var$parseQuarterPatterns = {
    any: [
        /(1|i)$/i,
        /(2|ii)$/i,
        /(3|iii)$/i,
        /(4|iv)$/i
    ]
};
var $899b3364dc90a4d7$var$matchMonthPatterns = {
    // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
    // note the order of '1' since it is a sub-string of '10', so must be lower priority
    narrow: /^(0?[2-9]|10|11|12|0?1)/i,
    // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
    abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
    // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
    wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
var $899b3364dc90a4d7$var$parseMonthPatterns = {
    narrow: [
        /0?1$/i,
        /0?2/i,
        /3/,
        /4/,
        /5/,
        /6/,
        /7/,
        /8/,
        /9/,
        /10/,
        /11/,
        /12/
    ],
    abbreviated: [
        /^thg[ _]?0?1(?!\d)/i,
        /^thg[ _]?0?2/i,
        /^thg[ _]?0?3/i,
        /^thg[ _]?0?4/i,
        /^thg[ _]?0?5/i,
        /^thg[ _]?0?6/i,
        /^thg[ _]?0?7/i,
        /^thg[ _]?0?8/i,
        /^thg[ _]?0?9/i,
        /^thg[ _]?10/i,
        /^thg[ _]?11/i,
        /^thg[ _]?12/i
    ],
    wide: [
        /^tháng ?(Một|0?1(?!\d))/i,
        /^tháng ?(Hai|0?2)/i,
        /^tháng ?(Ba|0?3)/i,
        /^tháng ?(Tư|0?4)/i,
        /^tháng ?(Năm|0?5)/i,
        /^tháng ?(Sáu|0?6)/i,
        /^tháng ?(Bảy|0?7)/i,
        /^tháng ?(Tám|0?8)/i,
        /^tháng ?(Chín|0?9)/i,
        /^tháng ?(Mười|10)/i,
        /^tháng ?(Mười ?Một|11)/i,
        /^tháng ?(Mười ?Hai|12)/i
    ]
};
var $899b3364dc90a4d7$var$matchDayPatterns = {
    narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
    short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
var $899b3364dc90a4d7$var$parseDayPatterns = {
    narrow: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    short: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    abbreviated: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    wide: [
        /(Chủ|Chúa) ?Nhật/i,
        /Hai/i,
        /Ba/i,
        /Tư/i,
        /Năm/i,
        /Sáu/i,
        /Bảy/i
    ]
};
var $899b3364dc90a4d7$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
var $899b3364dc90a4d7$var$parseDayPeriodPatterns = {
    any: {
        am: /^(a|sa)/i,
        pm: /^(p|ch[^i]*)/i,
        midnight: /nửa đêm/i,
        noon: /trưa/i,
        morning: /sáng/i,
        afternoon: /chiều/i,
        evening: /tối/i,
        night: /^đêm/i
    }
};
var $899b3364dc90a4d7$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $899b3364dc90a4d7$var$matchOrdinalNumberPattern,
        parsePattern: $899b3364dc90a4d7$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $899b3364dc90a4d7$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $899b3364dc90a4d7$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $899b3364dc90a4d7$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $899b3364dc90a4d7$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $899b3364dc90a4d7$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $899b3364dc90a4d7$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $899b3364dc90a4d7$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $899b3364dc90a4d7$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $899b3364dc90a4d7$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $899b3364dc90a4d7$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $899b3364dc90a4d7$export$2e2bcd8739ae039 = $899b3364dc90a4d7$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
 * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
 */ var $7b77ce0d567bf9a8$var$locale = {
    code: 'vi',
    formatDistance: (0, $8811a1ced60ca35b$export$2e2bcd8739ae039),
    formatLong: (0, $0e7b4f023259c17a$export$2e2bcd8739ae039),
    formatRelative: (0, $fa149f0a10cb3c33$export$2e2bcd8739ae039),
    localize: (0, $4c33e6989996f2d6$export$2e2bcd8739ae039),
    match: (0, $899b3364dc90a4d7$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1 /* First week of new year contains Jan 1st  */ 
    }
};
var $7b77ce0d567bf9a8$export$2e2bcd8739ae039 = $7b77ce0d567bf9a8$var$locale;
module.exports["default"] = $7b77ce0d567bf9a8$export$2e2bcd8739ae039;

});

parcelRegister("2y7u1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $45d7a26f0a067f33$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u949F",
    lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
    },
    xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
    },
    xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
    },
    aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
    },
    xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
    }
};
var $45d7a26f0a067f33$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $45d7a26f0a067f33$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5185";
        else return result + "\u524D";
    }
    return result;
};
var $45d7a26f0a067f33$export$2e2bcd8739ae039 = $45d7a26f0a067f33$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $55b8b0336eb8221c$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $55b8b0336eb8221c$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $55b8b0336eb8221c$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $55b8b0336eb8221c$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $55b8b0336eb8221c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $55b8b0336eb8221c$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $55b8b0336eb8221c$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $55b8b0336eb8221c$export$2e2bcd8739ae039 = $55b8b0336eb8221c$var$formatLong;



var $c3GpY = parcelRequire("c3GpY");

function $ba41edad79ff96b6$var$checkWeek(date, baseDate, options) {
    var baseFormat = 'eeee p';
    if ((0, $c3GpY.default)(date, baseDate, options)) return baseFormat; // in same week
    else if (date.getTime() > baseDate.getTime()) return "'\u4E0B\u4E2A'" + baseFormat; // in next week
    return "'\u4E0A\u4E2A'" + baseFormat; // in last week
}
var $ba41edad79ff96b6$var$formatRelativeLocale = {
    lastWeek: $ba41edad79ff96b6$var$checkWeek,
    // days before yesterday, maybe in this week or last week
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: $ba41edad79ff96b6$var$checkWeek,
    // days after tomorrow, maybe in this week or next week
    other: 'PP p'
};
var $ba41edad79ff96b6$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $ba41edad79ff96b6$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $ba41edad79ff96b6$export$2e2bcd8739ae039 = $ba41edad79ff96b6$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $d72b87a48288bb7d$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $d72b87a48288bb7d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var $d72b87a48288bb7d$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $d72b87a48288bb7d$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u5468\u65E5",
        "\u5468\u4E00",
        "\u5468\u4E8C",
        "\u5468\u4E09",
        "\u5468\u56DB",
        "\u5468\u4E94",
        "\u5468\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $d72b87a48288bb7d$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $d72b87a48288bb7d$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $d72b87a48288bb7d$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number.toString() + "\u65E5";
        case 'hour':
            return number.toString() + "\u65F6";
        case 'minute':
            return number.toString() + "\u5206";
        case 'second':
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
};
var $d72b87a48288bb7d$var$localize = {
    ordinalNumber: $d72b87a48288bb7d$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $d72b87a48288bb7d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $d72b87a48288bb7d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $d72b87a48288bb7d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $d72b87a48288bb7d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $d72b87a48288bb7d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d72b87a48288bb7d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d72b87a48288bb7d$export$2e2bcd8739ae039 = $d72b87a48288bb7d$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $eafb0be4601f932f$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
var $eafb0be4601f932f$var$parseOrdinalNumberPattern = /\d+/i;
var $eafb0be4601f932f$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $eafb0be4601f932f$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $eafb0be4601f932f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
var $eafb0be4601f932f$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $eafb0be4601f932f$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $eafb0be4601f932f$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $eafb0be4601f932f$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $eafb0be4601f932f$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $eafb0be4601f932f$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var $eafb0be4601f932f$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $eafb0be4601f932f$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $eafb0be4601f932f$var$matchOrdinalNumberPattern,
        parsePattern: $eafb0be4601f932f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $eafb0be4601f932f$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $eafb0be4601f932f$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $eafb0be4601f932f$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $eafb0be4601f932f$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $eafb0be4601f932f$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $eafb0be4601f932f$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $eafb0be4601f932f$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $eafb0be4601f932f$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $eafb0be4601f932f$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $eafb0be4601f932f$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $eafb0be4601f932f$export$2e2bcd8739ae039 = $eafb0be4601f932f$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $1db48fc8cb84cd47$var$locale = {
    code: 'zh-CN',
    formatDistance: (0, $45d7a26f0a067f33$export$2e2bcd8739ae039),
    formatLong: (0, $55b8b0336eb8221c$export$2e2bcd8739ae039),
    formatRelative: (0, $ba41edad79ff96b6$export$2e2bcd8739ae039),
    localize: (0, $d72b87a48288bb7d$export$2e2bcd8739ae039),
    match: (0, $eafb0be4601f932f$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $1db48fc8cb84cd47$export$2e2bcd8739ae039 = $1db48fc8cb84cd47$var$locale;
module.exports["default"] = $1db48fc8cb84cd47$export$2e2bcd8739ae039;

});

parcelRegister("2LLdF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $483ba5aae69e689d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var $483ba5aae69e689d$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $483ba5aae69e689d$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
var $483ba5aae69e689d$export$2e2bcd8739ae039 = $483ba5aae69e689d$var$formatDistance;



var $ke66V = parcelRequire("ke66V");

var $83bcdb38c60ef701$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $83bcdb38c60ef701$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $83bcdb38c60ef701$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $83bcdb38c60ef701$var$formatLong = {
    date: (0, $ke66V.default)({
        formats: $83bcdb38c60ef701$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $ke66V.default)({
        formats: $83bcdb38c60ef701$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $ke66V.default)({
        formats: $83bcdb38c60ef701$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $83bcdb38c60ef701$export$2e2bcd8739ae039 = $83bcdb38c60ef701$var$formatLong;


var $19030c7897715980$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var $19030c7897715980$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $19030c7897715980$var$formatRelativeLocale[token];
};
var $19030c7897715980$export$2e2bcd8739ae039 = $19030c7897715980$var$formatRelative;



var $lo4TZ = parcelRequire("lo4TZ");

var $7ba38e5313beb051$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $7ba38e5313beb051$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u9418",
        "\u7B2C\u4E8C\u523B\u9418",
        "\u7B2C\u4E09\u523B\u9418",
        "\u7B2C\u56DB\u523B\u9418"
    ]
};
var $7ba38e5313beb051$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $7ba38e5313beb051$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $7ba38e5313beb051$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $7ba38e5313beb051$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $7ba38e5313beb051$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var $7ba38e5313beb051$var$localize = {
    ordinalNumber: $7ba38e5313beb051$var$ordinalNumber,
    era: (0, $lo4TZ.default)({
        values: $7ba38e5313beb051$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lo4TZ.default)({
        values: $7ba38e5313beb051$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lo4TZ.default)({
        values: $7ba38e5313beb051$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lo4TZ.default)({
        values: $7ba38e5313beb051$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lo4TZ.default)({
        values: $7ba38e5313beb051$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $7ba38e5313beb051$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $7ba38e5313beb051$export$2e2bcd8739ae039 = $7ba38e5313beb051$var$localize;



var $jLTD6 = parcelRequire("jLTD6");


var $aqoqo = parcelRequire("aqoqo");

var $45065e7b346d7aa3$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $45065e7b346d7aa3$var$parseOrdinalNumberPattern = /\d+/i;
var $45065e7b346d7aa3$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $45065e7b346d7aa3$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $45065e7b346d7aa3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
var $45065e7b346d7aa3$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $45065e7b346d7aa3$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $45065e7b346d7aa3$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $45065e7b346d7aa3$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $45065e7b346d7aa3$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $45065e7b346d7aa3$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $45065e7b346d7aa3$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $45065e7b346d7aa3$var$match = {
    ordinalNumber: (0, $aqoqo.default)({
        matchPattern: $45065e7b346d7aa3$var$matchOrdinalNumberPattern,
        parsePattern: $45065e7b346d7aa3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jLTD6.default)({
        matchPatterns: $45065e7b346d7aa3$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $45065e7b346d7aa3$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $jLTD6.default)({
        matchPatterns: $45065e7b346d7aa3$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $45065e7b346d7aa3$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jLTD6.default)({
        matchPatterns: $45065e7b346d7aa3$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $45065e7b346d7aa3$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $jLTD6.default)({
        matchPatterns: $45065e7b346d7aa3$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $45065e7b346d7aa3$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $jLTD6.default)({
        matchPatterns: $45065e7b346d7aa3$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $45065e7b346d7aa3$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $45065e7b346d7aa3$export$2e2bcd8739ae039 = $45065e7b346d7aa3$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai]{@link https://github.com/tpai}
 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $2044995f5c1a2cf9$var$locale = {
    code: 'zh-TW',
    formatDistance: (0, $483ba5aae69e689d$export$2e2bcd8739ae039),
    formatLong: (0, $83bcdb38c60ef701$export$2e2bcd8739ae039),
    formatRelative: (0, $19030c7897715980$export$2e2bcd8739ae039),
    localize: (0, $7ba38e5313beb051$export$2e2bcd8739ae039),
    match: (0, $45065e7b346d7aa3$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2044995f5c1a2cf9$export$2e2bcd8739ae039 = $2044995f5c1a2cf9$var$locale;
module.exports["default"] = $2044995f5c1a2cf9$export$2e2bcd8739ae039;

});

parcelRegister("lhT9r", function(module, exports) {

var $42omo = parcelRequire("42omo");




class $d6fdc1f3aa5fd3b7$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    async UNSAFE_componentWillMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) try {
            const [mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule] = await Promise.all([
                (parcelRequire("kSwPg")),
                (parcelRequire("e2H6V")),
                (parcelRequire("6iqzA"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        } catch (error) {
        // TODO [MS-2272]: Add operational error to catch async import error
        }
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Dropzone, this.props));
    }
    constructor(...args){
        super(...args);
        this.state = {
            Dropzone: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}
$d6fdc1f3aa5fd3b7$export$66201d263cd6342.displayName = 'AsyncDropzone';
$d6fdc1f3aa5fd3b7$export$66201d263cd6342.Dropzone = void 0;
$d6fdc1f3aa5fd3b7$export$66201d263cd6342.MediaPickerErrorBoundary = void 0;
module.exports["DropzoneLoader"] = $d6fdc1f3aa5fd3b7$export$66201d263cd6342;

});

parcelRegister("e2H6V", function(module, exports) {

let $a392b174a819d493$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a392b174a819d493$var$load("15VrD"),
    $a392b174a819d493$var$load("f35QR"),
    $a392b174a819d493$var$load("eVYW1"),
    $a392b174a819d493$var$load("ls0Um"),
    $a392b174a819d493$var$load("020xd"),
    $a392b174a819d493$var$load("eTBsW"),
    $a392b174a819d493$var$load("bYxCZ"),
    $a392b174a819d493$var$load("6HBYC"),
    $a392b174a819d493$var$load("eDqo1"),
    $a392b174a819d493$var$load("lxiFd"),
    $a392b174a819d493$var$load("1oiJ6"),
    $a392b174a819d493$var$load("huUvS"),
    $a392b174a819d493$var$load("h4k4y"),
    $a392b174a819d493$var$load("4lnLb"),
    $a392b174a819d493$var$load("6vhrJ"),
    $a392b174a819d493$var$load("cCWZm")
]).then(()=>parcelRequire('xvLlm'));

});

parcelRegister("6iqzA", function(module, exports) {

let $4959095ecc2086e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4959095ecc2086e9$var$load("15VrD"),
    $4959095ecc2086e9$var$load("lE3cg")
]).then(()=>parcelRequire('dp2qz'));

});

parcelRegister("6ZDLj", function(module, exports) {

var $42omo = parcelRequire("42omo");

/* wrappers-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $3bV1Q = parcelRequire("3bV1Q");


var $4HvFx = parcelRequire("4HvFx");


var $46EIy = parcelRequire("46EIy");

const $1156f5d5007639c5$var$filmStripViewStyles = null;
const $1156f5d5007639c5$var$filmStripListWrapperStyles = null;
const $1156f5d5007639c5$var$filmStripListStyles = null;
const $1156f5d5007639c5$var$filmStripListItemStyles = null;
const $1156f5d5007639c5$var$arrowWrapperStyles = null;
const $1156f5d5007639c5$var$arrowLeftWrapperStyles = null;
const $1156f5d5007639c5$var$arrowRightWrapperStyles = null;
const $1156f5d5007639c5$var$shadowStyles = null;
const $1156f5d5007639c5$var$shadowLeftStyles = null;
const $1156f5d5007639c5$var$shadowRightStyles = null;
const $1156f5d5007639c5$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1ltvidpf"
        ])
    }, children);
const $1156f5d5007639c5$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: onClick
    }, children);
const $1156f5d5007639c5$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1xi2idpf"
        ])
    }, children);
const $1156f5d5007639c5$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: onClick
    }, children);
const $1156f5d5007639c5$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3bV1Q))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $1156f5d5007639c5$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4HvFx))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $1156f5d5007639c5$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": dataTestId,
        className: (0, $gMc0m.default)([
            "_2rkofajl _kqswh2mm _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _1yqxkb7n _1ajs4jg8"
        ])
    }, children);
const $1156f5d5007639c5$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
        ])
    }, children));
const $1156f5d5007639c5$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
        ref: ref,
        style: style,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l"
        ])
    }, children));
const $1156f5d5007639c5$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf",
            (0, $46EIy.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);


const $15c7f4a4aa94e52b$export$924abd21043fc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1156f5d5007639c5$export$924abd21043fc000), props);
const $15c7f4a4aa94e52b$export$a5ffe38c17bbc0a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1156f5d5007639c5$export$a5ffe38c17bbc0a1), props);
const $15c7f4a4aa94e52b$export$abf07652016c7e56 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1156f5d5007639c5$export$abf07652016c7e56), props);
const $15c7f4a4aa94e52b$export$b39b1b86b48b621f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1156f5d5007639c5$export$b39b1b86b48b621f), props);
const $15c7f4a4aa94e52b$export$6208675820d4cc50 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1156f5d5007639c5$export$6208675820d4cc50), props);
const $15c7f4a4aa94e52b$export$d37eb83491863cbb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1156f5d5007639c5$export$d37eb83491863cbb), props);
const $15c7f4a4aa94e52b$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1156f5d5007639c5$export$4b7fe5339e3afada), {
        ...props,
        ref: ref
    }));
const $15c7f4a4aa94e52b$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1156f5d5007639c5$export$710ee13c74b7a1f0), {
        ...props,
        ref: ref
    }));
const $15c7f4a4aa94e52b$export$54cfc70c184c0713 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1156f5d5007639c5$export$54cfc70c184c0713), props);
module.exports["LeftArrow"] = $15c7f4a4aa94e52b$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $15c7f4a4aa94e52b$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $15c7f4a4aa94e52b$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $15c7f4a4aa94e52b$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $15c7f4a4aa94e52b$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $15c7f4a4aa94e52b$export$54cfc70c184c0713;

});

parcelRegister("9HuAe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fX8We = parcelRequire("fX8We");

const $40f11cd2f33df153$export$be58b4326e23250f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.IconWrapper), props);
const $40f11cd2f33df153$export$e31a6cc0a4c97f0e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.EmojiWrapper), props);
const $40f11cd2f33df153$export$c73a53738ef9e3f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.IconTitleWrapper), props);
const $40f11cd2f33df153$export$75180efdd3f4d9c2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.LozengeWrapper), props);
const $40f11cd2f33df153$export$a16269f205a2f280 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.LozengeBlockWrapper), props);
const $40f11cd2f33df153$export$91b164375b8037b5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.RightIconPositionWrapper), props);
const $40f11cd2f33df153$export$7291f9f954790243 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.IconPositionWrapper), props);
const $40f11cd2f33df153$export$ddce81e032b0736e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fX8We.IconEmptyWrapper), props);
module.exports["IconWrapper"] = $40f11cd2f33df153$export$be58b4326e23250f;
module.exports["EmojiWrapper"] = $40f11cd2f33df153$export$e31a6cc0a4c97f0e;
module.exports["IconTitleWrapper"] = $40f11cd2f33df153$export$c73a53738ef9e3f;
module.exports["RightIconPositionWrapper"] = $40f11cd2f33df153$export$91b164375b8037b5;
module.exports["IconPositionWrapper"] = $40f11cd2f33df153$export$7291f9f954790243;
module.exports["IconEmptyWrapper"] = $40f11cd2f33df153$export$ddce81e032b0736e;

});

parcelRegister("fX8We", function(module, exports) {
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// TODO: remove this override behaviour for @atlaskit/icon-object

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $fd9b070c354e8c1f$var$iconObjectOverrideStyles = null; // TODO: remove this override behaviour for @atlaskit/icon
const $fd9b070c354e8c1f$var$iconOverrideStyles = null;
const $fd9b070c354e8c1f$var$iconWrapperStyles = null; // Wraps all icons represented in Inline Links. Icons have three sources/types:
const $fd9b070c354e8c1f$export$be58b4326e23250f = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ])
    }, children);
const $fd9b070c354e8c1f$var$emojiWrapperStyles = null; // Wraps all emoji in Inline Links similar to icon
const $fd9b070c354e8c1f$export$e31a6cc0a4c97f0e = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _2hwxv77o _uiztglyw",
            "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe",
            "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"
        ])
    }, children);
const $fd9b070c354e8c1f$var$iconTitleWrapperStyles = null; // The main 'wrapping' element, title of the content.
const $fd9b070c354e8c1f$export$c73a53738ef9e3f = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_o5721jtm _1nmz9jpi"
        ])
    }, children);
const $fd9b070c354e8c1f$var$lozengeWrapperStyles = null; // TODO: Replace overrides with proper AtlasKit solution.
const $fd9b070c354e8c1f$export$75180efdd3f4d9c2 = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _s7n4t94y _1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ])
    }, children);
const $fd9b070c354e8c1f$var$lozengeBlockWrapperStyles = null; // TODO: Replace overrides with proper AtlasKit solution.
const $fd9b070c354e8c1f$export$a16269f205a2f280 = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"
        ])
    }, children);
const $fd9b070c354e8c1f$var$rightIconPositionWrapperStyles = null;
const $fd9b070c354e8c1f$export$91b164375b8037b5 = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_18u0v77o _2hwx1b66 _kqswh2mm _1e0c1o8l"
        ])
    }, children);
const $fd9b070c354e8c1f$var$iconPositionWrapperStyles = null; // The following components are used to absolutely position icons in the vertical center.
const $fd9b070c354e8c1f$export$7291f9f954790243 = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_2hwx1b66 _kqswh2mm _1e0c1o8l"
        ])
    }, children);
const $fd9b070c354e8c1f$var$iconEmptyWrapperStyles = null;
const $fd9b070c354e8c1f$export$ddce81e032b0736e = ({ children: children, ...props })=>/*#__PURE__*/ $42omo.createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsbdlk8 _4t3i1osq _1e0c1o8l _tzy4idpf"
        ])
    }, children);
module.exports["IconWrapper"] = $fd9b070c354e8c1f$export$be58b4326e23250f;
module.exports["EmojiWrapper"] = $fd9b070c354e8c1f$export$e31a6cc0a4c97f0e;
module.exports["IconTitleWrapper"] = $fd9b070c354e8c1f$export$c73a53738ef9e3f;
module.exports["LozengeWrapper"] = $fd9b070c354e8c1f$export$75180efdd3f4d9c2;
module.exports["LozengeBlockWrapper"] = $fd9b070c354e8c1f$export$a16269f205a2f280;
module.exports["RightIconPositionWrapper"] = $fd9b070c354e8c1f$export$91b164375b8037b5;
module.exports["IconPositionWrapper"] = $fd9b070c354e8c1f$export$7291f9f954790243;
module.exports["IconEmptyWrapper"] = $fd9b070c354e8c1f$export$ddce81e032b0736e;

});


$parcel$global.rlb("15VrD")
//# sourceMappingURL=media.f462a0b4.js.map
